/* tslint:disable */
/* eslint-disable */
/**
 * Merchant Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddPushTokenRequest
 */
export interface AddPushTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPushTokenRequest
     */
    'pushToken': string;
}
/**
 * 
 * @export
 * @interface AddSitesPaymentMethodRequest
 */
export interface AddSitesPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof AddSitesPaymentMethodRequest
     */
    'paymentMethod'?: AddSitesPaymentMethodRequestPaymentMethodEnum;
}

export const AddSitesPaymentMethodRequestPaymentMethodEnum = {
    Visa: 'visa',
    Mc: 'mc',
    Amex: 'amex',
    Cup: 'cup',
    Discover: 'discover',
    Girocard: 'girocard',
    Maestro: 'maestro'
} as const;

export type AddSitesPaymentMethodRequestPaymentMethodEnum = typeof AddSitesPaymentMethodRequestPaymentMethodEnum[keyof typeof AddSitesPaymentMethodRequestPaymentMethodEnum];

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'stateOrProvince'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface Amount
 */
export interface Amount {
    /**
     * Amount value in cents
     * @type {number}
     * @memberof Amount
     */
    'value': number;
    /**
     * Currency code
     * @type {string}
     * @memberof Amount
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface AssignDevice200Response
 */
export interface AssignDevice200Response {
    /**
     * 
     * @type {string}
     * @memberof AssignDevice200Response
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface AssignDeviceRequest
 */
export interface AssignDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignDeviceRequest
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface BalanceAccountPayoutConfig
 */
export interface BalanceAccountPayoutConfig {
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfig
     */
    'category'?: BalanceAccountPayoutConfigCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfig
     */
    'status'?: BalanceAccountPayoutConfigStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfig
     */
    'currency': string;
    /**
     * 
     * @type {Amount}
     * @memberof BalanceAccountPayoutConfig
     */
    'amount'?: Amount;
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfig
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfig
     */
    'counterparty'?: string;
    /**
     * 
     * @type {BalanceAccountPayoutConfigSchedule}
     * @memberof BalanceAccountPayoutConfig
     */
    'schedule': BalanceAccountPayoutConfigSchedule;
}

export const BalanceAccountPayoutConfigCategoryEnum = {
    Bank: 'bank',
    Internal: 'internal'
} as const;

export type BalanceAccountPayoutConfigCategoryEnum = typeof BalanceAccountPayoutConfigCategoryEnum[keyof typeof BalanceAccountPayoutConfigCategoryEnum];
export const BalanceAccountPayoutConfigStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type BalanceAccountPayoutConfigStatusEnum = typeof BalanceAccountPayoutConfigStatusEnum[keyof typeof BalanceAccountPayoutConfigStatusEnum];

/**
 * 
 * @export
 * @interface BalanceAccountPayoutConfigSchedule
 */
export interface BalanceAccountPayoutConfigSchedule {
    /**
     * 
     * @type {string}
     * @memberof BalanceAccountPayoutConfigSchedule
     */
    'cronExpression'?: string;
}
/**
 * 
 * @export
 * @interface BasicPaymentRates
 */
export interface BasicPaymentRates {
    /**
     * 
     * @type {number}
     * @memberof BasicPaymentRates
     */
    'auth': number;
    /**
     * 
     * @type {number}
     * @memberof BasicPaymentRates
     */
    'card': number;
}
/**
 * 
 * @export
 * @interface Bill
 */
export interface Bill {
    /**
     * 
     * @type {Array<BillTransactionsInner>}
     * @memberof Bill
     */
    'transactions': Array<BillTransactionsInner>;
}
/**
 * 
 * @export
 * @interface BillSimplified
 */
export interface BillSimplified {
    /**
     * 
     * @type {string}
     * @memberof BillSimplified
     */
    'firstTransactionTime': string;
    /**
     * 
     * @type {string}
     * @memberof BillSimplified
     */
    'lastTransactionTime': string;
    /**
     * 
     * @type {number}
     * @memberof BillSimplified
     */
    'transactionsCount': number;
    /**
     * 
     * @type {Amount}
     * @memberof BillSimplified
     */
    'totalAmount': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof BillSimplified
     */
    'includedGratuity'?: Amount;
}
/**
 * 
 * @export
 * @interface BillTransactionsInner
 */
export interface BillTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof BillTransactionsInner
     */
    'time': string;
    /**
     * 
     * @type {Amount}
     * @memberof BillTransactionsInner
     */
    'amount': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof BillTransactionsInner
     */
    'gratuity'?: Amount;
    /**
     * 
     * @type {string}
     * @memberof BillTransactionsInner
     */
    'paymentMethod': string;
}
/**
 * 
 * @export
 * @interface CPullNCRIntegrationConfig
 */
export interface CPullNCRIntegrationConfig {
    /**
     * 
     * @type {string}
     * @memberof CPullNCRIntegrationConfig
     */
    'siteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullNCRIntegrationConfig
     */
    'waiterId'?: string;
    /**
     * 
     * @type {CPullNCRIntegrationConfigAuthentication}
     * @memberof CPullNCRIntegrationConfig
     */
    'authentication'?: CPullNCRIntegrationConfigAuthentication;
}
/**
 * 
 * @export
 * @interface CPullNCRIntegrationConfigAuthentication
 */
export interface CPullNCRIntegrationConfigAuthentication {
    /**
     * 
     * @type {string}
     * @memberof CPullNCRIntegrationConfigAuthentication
     */
    'hash'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullNCRIntegrationConfigAuthentication
     */
    'redactedToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullNCRIntegrationConfigAuthentication
     */
    'salt'?: string;
}
/**
 * 
 * @export
 * @interface CPullZonalIntegrationConfig
 */
export interface CPullZonalIntegrationConfig {
    /**
     * 
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    'identityGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    'identitySecret'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    'iOrderBrandToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    'iOrderUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    'iOrderPassword'?: string;
    /**
     * 
     * @type {number}
     * @memberof CPullZonalIntegrationConfig
     */
    'siteId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CPullZonalIntegrationConfig
     */
    'salesAreaId'?: number;
    /**
     * Encrypted secret that is not returned to the client and only serves for internal typing
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    '_iOrderPasswordEncrypted'?: string | null;
    /**
     * Encrypted secret that is not returned to the client and only serves for internal typing
     * @type {string}
     * @memberof CPullZonalIntegrationConfig
     */
    '_identitySecretEncrypted'?: string | null;
    /**
     * 
     * @type {CPullZonalIntegrationConfigPaymentMethodIds}
     * @memberof CPullZonalIntegrationConfig
     */
    'paymentMethodIds'?: CPullZonalIntegrationConfigPaymentMethodIds;
}
/**
 * 
 * @export
 * @interface CPullZonalIntegrationConfigPaymentMethodIds
 */
export interface CPullZonalIntegrationConfigPaymentMethodIds {
    [key: string]: number | any;

    /**
     * 
     * @type {number}
     * @memberof CPullZonalIntegrationConfigPaymentMethodIds
     */
    'default'?: number;
}
/**
 * 
 * @export
 * @interface Capability
 */
export interface Capability {
    /**
     * 
     * @type {boolean}
     * @memberof Capability
     */
    'enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Capability
     */
    'requested': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Capability
     */
    'allowed': boolean;
    /**
     * 
     * @type {string}
     * @memberof Capability
     */
    'verificationStatus': CapabilityVerificationStatusEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Capability
     */
    'problems'?: { [key: string]: string; };
}

export const CapabilityVerificationStatusEnum = {
    Pending: 'pending',
    Invalid: 'invalid',
    Valid: 'valid',
    Rejected: 'rejected'
} as const;

export type CapabilityVerificationStatusEnum = typeof CapabilityVerificationStatusEnum[keyof typeof CapabilityVerificationStatusEnum];

/**
 * 
 * @export
 * @interface ConnectPullFetchAccountDetails500Response
 */
export interface ConnectPullFetchAccountDetails500Response {
    /**
     * 
     * @type {number}
     * @memberof ConnectPullFetchAccountDetails500Response
     */
    'code'?: ConnectPullFetchAccountDetails500ResponseCodeEnum;
}

export const ConnectPullFetchAccountDetails500ResponseCodeEnum = {
    NUMBER_999: 999,
    NUMBER_888: 888,
    NUMBER_111: 111,
    NUMBER_444: 444,
    NUMBER_222: 222
} as const;

export type ConnectPullFetchAccountDetails500ResponseCodeEnum = typeof ConnectPullFetchAccountDetails500ResponseCodeEnum[keyof typeof ConnectPullFetchAccountDetails500ResponseCodeEnum];

/**
 * 
 * @export
 * @interface ConnectPullFetchOpenAccounts500Response
 */
export interface ConnectPullFetchOpenAccounts500Response {
    /**
     * 
     * @type {number}
     * @memberof ConnectPullFetchOpenAccounts500Response
     */
    'code'?: ConnectPullFetchOpenAccounts500ResponseCodeEnum;
}

export const ConnectPullFetchOpenAccounts500ResponseCodeEnum = {
    NUMBER_999: 999,
    NUMBER_888: 888,
    NUMBER_111: 111
} as const;

export type ConnectPullFetchOpenAccounts500ResponseCodeEnum = typeof ConnectPullFetchOpenAccounts500ResponseCodeEnum[keyof typeof ConnectPullFetchOpenAccounts500ResponseCodeEnum];

/**
 * 
 * @export
 * @interface CountryIndustryCode
 */
export interface CountryIndustryCode {
    /**
     * 
     * @type {string}
     * @memberof CountryIndustryCode
     */
    'desc'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryIndustryCode
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface CreateCapitalSession200Response
 */
export interface CreateCapitalSession200Response {
    /**
     * The session token
     * @type {string}
     * @memberof CreateCapitalSession200Response
     */
    'token'?: string;
    /**
     * The session id
     * @type {string}
     * @memberof CreateCapitalSession200Response
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CreateDealRates201Response
 */
export interface CreateDealRates201Response {
    /**
     * 
     * @type {boolean}
     * @memberof CreateDealRates201Response
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDraftMerchantInviteToken200Response
 */
export interface CreateDraftMerchantInviteToken200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftMerchantInviteToken200Response
     */
    'userType'?: CreateDraftMerchantInviteToken200ResponseUserTypeEnum;
}

export const CreateDraftMerchantInviteToken200ResponseUserTypeEnum = {
    Existing: 'existing',
    New: 'new'
} as const;

export type CreateDraftMerchantInviteToken200ResponseUserTypeEnum = typeof CreateDraftMerchantInviteToken200ResponseUserTypeEnum[keyof typeof CreateDraftMerchantInviteToken200ResponseUserTypeEnum];

/**
 * 
 * @export
 * @interface CreateDraftMerchantInviteTokenRequest
 */
export interface CreateDraftMerchantInviteTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftMerchantInviteTokenRequest
     */
    'recipientEmail': string;
}
/**
 * 
 * @export
 * @interface CreateDraftMerchantRequest
 */
export interface CreateDraftMerchantRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftMerchantRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftMerchantRequest
     */
    'dealShortCode': string;
}
/**
 * 
 * @export
 * @interface CreateEODReportRequest
 */
export interface CreateEODReportRequest {
    /**
     * Site ID to scope the report
     * @type {string}
     * @memberof CreateEODReportRequest
     */
    'siteId'?: string;
}
/**
 * 
 * @export
 * @interface CreateMobilePosSession200Response
 */
export interface CreateMobilePosSession200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateMobilePosSession200Response
     */
    'sdkData': string;
}
/**
 * 
 * @export
 * @interface CreateMobilePosSessionRequest
 */
export interface CreateMobilePosSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMobilePosSessionRequest
     */
    'setupToken': string;
}
/**
 * 
 * @export
 * @interface CreateReport201Response
 */
export interface CreateReport201Response {
    /**
     * 
     * @type {string}
     * @memberof CreateReport201Response
     */
    'reportId'?: string;
}
/**
 * 
 * @export
 * @interface CreateReportRequest
 */
export interface CreateReportRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'dataType': CreateReportRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'siteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'dates'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'psp'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'amounts'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'statuses'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'cardSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'type'?: string;
    /**
     * 
     * @type {PaymentSource}
     * @memberof CreateReportRequest
     */
    'paymentSource'?: PaymentSource;
    /**
     * 
     * @type {string}
     * @memberof CreateReportRequest
     */
    'paymentMethods'?: string;
}

export const CreateReportRequestDataTypeEnum = {
    Transactions: 'transactions',
    Payouts: 'payouts'
} as const;

export type CreateReportRequestDataTypeEnum = typeof CreateReportRequestDataTypeEnum[keyof typeof CreateReportRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface CreateTransactionDeviceRequest
 */
export interface CreateTransactionDeviceRequest {
    /**
     * PSP reference of the transaction
     * @type {string}
     * @memberof CreateTransactionDeviceRequest
     */
    'pspReference': string;
    /**
     * Merchant reference of the transaction
     * @type {string}
     * @memberof CreateTransactionDeviceRequest
     */
    'merchantReference': string;
    /**
     * Amount in minor units
     * @type {number}
     * @memberof CreateTransactionDeviceRequest
     */
    'amount': number;
    /**
     * Gratuity in minor units
     * @type {number}
     * @memberof CreateTransactionDeviceRequest
     */
    'includedGratuity'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDeviceRequest
     */
    'paymentMethod': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDeviceRequest
     */
    'firstTransactionPsp'?: string;
    /**
     * 
     * @type {CreateTransactionDeviceRequestIntegration}
     * @memberof CreateTransactionDeviceRequest
     */
    'integration'?: CreateTransactionDeviceRequestIntegration;
}
/**
 * 
 * @export
 * @interface CreateTransactionDeviceRequestIntegration
 */
export interface CreateTransactionDeviceRequestIntegration {
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDeviceRequestIntegration
     */
    'tableNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionDeviceRequestIntegration
     */
    'billNumber'?: string;
}
/**
 * 
 * @export
 * @interface CreateTransactionReceiptRequest
 */
export interface CreateTransactionReceiptRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionReceiptRequest
     */
    'emailToSendReceipt': string;
}
/**
 * 
 * @export
 * @interface CreateTransactionRequest
 */
export interface CreateTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    'siteId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    'pspReference': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    'firstTransactionPsp': string;
    /**
     * Merchant reference of the transaction
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    'merchantReference': string;
    /**
     * Amount in minor units
     * @type {number}
     * @memberof CreateTransactionRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    'paymentMethod': string;
    /**
     * Whether the transaction was successful
     * @type {boolean}
     * @memberof CreateTransactionRequest
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateVerificationLink200Response
 */
export interface CreateVerificationLink200Response {
    /**
     * The verification URL link
     * @type {string}
     * @memberof CreateVerificationLink200Response
     */
    'data': string;
}
/**
 * 
 * @export
 * @interface CreateVerificationLinkRequest
 */
export interface CreateVerificationLinkRequest {
    /**
     * Whether to use the V2 onboarding flow
     * @type {boolean}
     * @memberof CreateVerificationLinkRequest
     */
    'isOnboardingV2'?: boolean;
}
/**
 * 
 * @export
 * @interface Credit
 */
export interface Credit {
    /**
     * 
     * @type {number}
     * @memberof Credit
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof Credit
     */
    'amountUsed'?: number;
    /**
     * 
     * @type {string}
     * @memberof Credit
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface DeactivateMerchantRequest
 */
export interface DeactivateMerchantRequest {
    /**
     * 
     * @type {string}
     * @memberof DeactivateMerchantRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface DealRates
 */
export interface DealRates {
    /**
     * 
     * @type {TransactionRates}
     * @memberof DealRates
     */
    'transactionRates': TransactionRates;
    /**
     * 
     * @type {number}
     * @memberof DealRates
     */
    'deviceRate': number;
    /**
     * 
     * @type {number}
     * @memberof DealRates
     */
    'settlementRate': number;
    /**
     * 
     * @type {number}
     * @memberof DealRates
     */
    'pciRate': number;
    /**
     * 
     * @type {number}
     * @memberof DealRates
     */
    'mccRate': number;
    /**
     * Number of minimum monthly payouts per month (per site)
     * @type {number}
     * @memberof DealRates
     */
    'mmpQty'?: number;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof DealRates
     */
    'discounts'?: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof DealRates
     */
    'currency': string;
    /**
     * Date when the contract ends, if not set or past date, it\'s a rolling contract
     * @type {string}
     * @memberof DealRates
     */
    'contractEndDate'?: string;
    /**
     * Indicates if the rates have been signed and are useable
     * @type {boolean}
     * @memberof DealRates
     */
    'signed'?: boolean;
    /**
     * URL to sign the agreed rates
     * @type {string}
     * @memberof DealRates
     */
    'signUrl'?: string;
    /**
     * Deal reference from our external system, used to link with later available Account Holder ID
     * @type {string}
     * @memberof DealRates
     */
    'dealReference': string;
    /**
     * Short code for the deal. If not provided, it will be generated
     * @type {string}
     * @memberof DealRates
     */
    'shortCode'?: string;
    /**
     * 
     * @type {Array<Credit>}
     * @memberof DealRates
     */
    'credits'?: Array<Credit>;
    /**
     * If true, the settlement will be net of fees, gross settlement otherwise
     * @type {boolean}
     * @memberof DealRates
     */
    'netSettlement'?: boolean;
}
/**
 * 
 * @export
 * @interface DeviceConfig
 */
export interface DeviceConfig {
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'storeBalanceAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'liableAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'siteId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'siteName': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'adyenStoreId': string;
    /**
     * 
     * @type {DeviceTipConfig}
     * @memberof DeviceConfig
     */
    'tips': DeviceTipConfig;
    /**
     * 
     * @type {DeviceConnectPullConfig}
     * @memberof DeviceConfig
     */
    'connectPull'?: DeviceConnectPullConfig;
    /**
     * 
     * @type {DeviceConnectPushConfig}
     * @memberof DeviceConfig
     */
    'connectPush'?: DeviceConnectPushConfig;
    /**
     * Use `pinList` instead
     * @type {Array<DeviceConfigPinsInner>}
     * @memberof DeviceConfig
     * @deprecated
     */
    'pins': Array<DeviceConfigPinsInner>;
    /**
     * 
     * @type {Array<DeviceConfigPinListInner>}
     * @memberof DeviceConfig
     */
    'pinList'?: Array<DeviceConfigPinListInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceConfig
     */
    'addOnFeatures'?: Array<string>;
    /**
     * 
     * @type {SiteInternalSettingsUnreferencedRefunds}
     * @memberof DeviceConfig
     */
    'moto'?: SiteInternalSettingsUnreferencedRefunds;
    /**
     * 
     * @type {SiteInternalSettingsUnreferencedRefunds}
     * @memberof DeviceConfig
     */
    'unreferencedRefunds'?: SiteInternalSettingsUnreferencedRefunds;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfig
     */
    'appVariant'?: DeviceConfigAppVariantEnum;
}

export const DeviceConfigAppVariantEnum = {
    Yetipay: 'yetipay',
    Tableyeti: 'tableyeti'
} as const;

export type DeviceConfigAppVariantEnum = typeof DeviceConfigAppVariantEnum[keyof typeof DeviceConfigAppVariantEnum];

/**
 * 
 * @export
 * @interface DeviceConfigPinListInner
 */
export interface DeviceConfigPinListInner {
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigPinListInner
     */
    'pin': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigPinListInner
     */
    'role': DeviceConfigPinListInnerRoleEnum;
}

export const DeviceConfigPinListInnerRoleEnum = {
    Manager: 'manager',
    Staff: 'staff',
    Transactions: 'transactions',
    Settings: 'settings'
} as const;

export type DeviceConfigPinListInnerRoleEnum = typeof DeviceConfigPinListInnerRoleEnum[keyof typeof DeviceConfigPinListInnerRoleEnum];

/**
 * 
 * @export
 * @interface DeviceConfigPinsInner
 */
export interface DeviceConfigPinsInner {
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigPinsInner
     */
    'pin': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigPinsInner
     */
    'role': DeviceConfigPinsInnerRoleEnum;
}

export const DeviceConfigPinsInnerRoleEnum = {
    Manager: 'manager',
    Staff: 'staff'
} as const;

export type DeviceConfigPinsInnerRoleEnum = typeof DeviceConfigPinsInnerRoleEnum[keyof typeof DeviceConfigPinsInnerRoleEnum];

/**
 * 
 * @export
 * @interface DeviceConnectPullConfig
 */
export interface DeviceConnectPullConfig {
    /**
     * 
     * @type {string}
     * @memberof DeviceConnectPullConfig
     */
    'provider': DeviceConnectPullConfigProviderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceConnectPullConfig
     */
    'enabled': boolean;
}

export const DeviceConnectPullConfigProviderEnum = {
    Zonalv1: 'zonalv1',
    Ncrv1: 'ncrv1'
} as const;

export type DeviceConnectPullConfigProviderEnum = typeof DeviceConnectPullConfigProviderEnum[keyof typeof DeviceConnectPullConfigProviderEnum];

/**
 * 
 * @export
 * @interface DeviceConnectPushConfig
 */
export interface DeviceConnectPushConfig {
    /**
     * 
     * @type {string}
     * @memberof DeviceConnectPushConfig
     */
    'baseUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConnectPushConfig
     */
    'provider': DeviceConnectPushConfigProviderEnum;
}

export const DeviceConnectPushConfigProviderEnum = {
    YetiConnectPush: 'YetiConnectPush',
    PsConnect: 'PSConnect'
} as const;

export type DeviceConnectPushConfigProviderEnum = typeof DeviceConnectPushConfigProviderEnum[keyof typeof DeviceConnectPushConfigProviderEnum];

/**
 * 
 * @export
 * @interface DeviceTipConfig
 */
export interface DeviceTipConfig {
    /**
     * 
     * @type {string}
     * @memberof DeviceTipConfig
     */
    'tipProvider'?: DeviceTipConfigTipProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceTipConfig
     */
    'tipJarBalanceAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTipConfig
     */
    'tipjarShortCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceTipConfig
     */
    'tipjarFeeRate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTipConfig
     */
    'skipTipsIfServiceChargeIncluded'?: boolean;
}

export const DeviceTipConfigTipProviderEnum = {
    Tipjar: 'tipjar',
    Yetipay: 'yetipay'
} as const;

export type DeviceTipConfigTipProviderEnum = typeof DeviceTipConfigTipProviderEnum[keyof typeof DeviceTipConfigTipProviderEnum];

/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'type': DiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'product': DiscountProductEnum;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    'value': number;
    /**
     * Date when the discount ends, if not set or past date, it\'s a rolling discount
     * @type {string}
     * @memberof Discount
     */
    'appliedUntil'?: string;
}

export const DiscountTypeEnum = {
    Unit: 'unit'
} as const;

export type DiscountTypeEnum = typeof DiscountTypeEnum[keyof typeof DiscountTypeEnum];
export const DiscountProductEnum = {
    Device: 'device'
} as const;

export type DiscountProductEnum = typeof DiscountProductEnum[keyof typeof DiscountProductEnum];

/**
 * 
 * @export
 * @interface DownloadInvoice200ResponseInner
 */
export interface DownloadInvoice200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof DownloadInvoice200ResponseInner
     */
    'downloadUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadInvoice200ResponseInner
     */
    'type'?: DownloadInvoice200ResponseInnerTypeEnum;
}

export const DownloadInvoice200ResponseInnerTypeEnum = {
    YetiInvoice: 'YETI_INVOICE',
    StripeInvoice: 'STRIPE_INVOICE',
    BillingSummary: 'BILLING_SUMMARY'
} as const;

export type DownloadInvoice200ResponseInnerTypeEnum = typeof DownloadInvoice200ResponseInnerTypeEnum[keyof typeof DownloadInvoice200ResponseInnerTypeEnum];

/**
 * 
 * @export
 * @interface DownloadReport200Response
 */
export interface DownloadReport200Response {
    /**
     * 
     * @type {string}
     * @memberof DownloadReport200Response
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadReport200Response
     */
    'presignedUrl'?: string;
}
/**
 * 
 * @export
 * @interface DownloadReport400Response
 */
export interface DownloadReport400Response {
    /**
     * 
     * @type {string}
     * @memberof DownloadReport400Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadReport400Response
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadReport400Response
     */
    'state'?: DownloadReport400ResponseStateEnum;
}

export const DownloadReport400ResponseStateEnum = {
    New: 'NEW',
    Processing: 'PROCESSING',
    Ready: 'READY',
    Error: 'ERROR'
} as const;

export type DownloadReport400ResponseStateEnum = typeof DownloadReport400ResponseStateEnum[keyof typeof DownloadReport400ResponseStateEnum];

/**
 * 
 * @export
 * @interface DraftMerchant
 */
export interface DraftMerchant {
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'userId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftMerchant
     */
    'isExistingUser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'userStatus'?: DraftMerchantUserStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'dealShortCode': string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'entity'?: DraftMerchantEntityEnum;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'legalEntityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'industryCode'?: string;
    /**
     * The hosted onboarding link for the draft merchant. It is generated when the draft merchant details are submitted it\'s valid for a single use. 
     * @type {string}
     * @memberof DraftMerchant
     */
    'hostedOnboardingLink'?: string;
    /**
     * 
     * @type {KycOnboardingDetails}
     * @memberof DraftMerchant
     */
    'kycOnboardingDetails'?: KycOnboardingDetails;
    /**
     * 
     * @type {string}
     * @memberof DraftMerchant
     */
    'kycOnboardingStatus'?: DraftMerchantKycOnboardingStatusEnum;
    /**
     * 
     * @type {OnboardingActions}
     * @memberof DraftMerchant
     */
    'onboardingActions'?: OnboardingActions;
    /**
     * Contract signing URL for the draft merchant. 
     * @type {string}
     * @memberof DraftMerchant
     */
    'dealSignUrl'?: string;
    /**
     * The status of the draft merchant: | status                   | description                                                                                                                                                                 | |--------------------------|-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------| | created                  | initial status when a new draft merchant is created                                                                                                                         | | details-added            | when the merchant details are updated                                                                                                                                       | | details-submitted        | when the merchant details are submitted and all merchant related entities create on Adyen. It can be resubmitted if error occurs or to regenerate the hostedOnboardingLink  | | details-submitted-error  | retryable error occurring when details are submitted  | | site-added               | when the merchant site and devices are updated                                                                                                                              | | site-submitted           | when the merchant site are submitted and all merchant related entities create on Adyen. It can be resubmitted if error occurs                                               | | site-submitted-error     | retryable error occurring when site is submitted  | 
     * @type {string}
     * @memberof DraftMerchant
     */
    'status': DraftMerchantStatusEnum;
    /**
     * 
     * @type {DraftSite}
     * @memberof DraftMerchant
     */
    'site'?: DraftSite;
}

export const DraftMerchantUserStatusEnum = {
    Archived: 'ARCHIVED',
    Compromised: 'COMPROMISED',
    Confirmed: 'CONFIRMED',
    ExternalProvider: 'EXTERNAL_PROVIDER',
    ForceChangePassword: 'FORCE_CHANGE_PASSWORD',
    ResetRequired: 'RESET_REQUIRED',
    Unconfirmed: 'UNCONFIRMED',
    Unknown: 'UNKNOWN'
} as const;

export type DraftMerchantUserStatusEnum = typeof DraftMerchantUserStatusEnum[keyof typeof DraftMerchantUserStatusEnum];
export const DraftMerchantEntityEnum = {
    SoleTrader: 'sole-trader',
    Company: 'company'
} as const;

export type DraftMerchantEntityEnum = typeof DraftMerchantEntityEnum[keyof typeof DraftMerchantEntityEnum];
export const DraftMerchantKycOnboardingStatusEnum = {
    Verified: 'verified',
    Pending: 'pending',
    ActionRequired: 'action-required'
} as const;

export type DraftMerchantKycOnboardingStatusEnum = typeof DraftMerchantKycOnboardingStatusEnum[keyof typeof DraftMerchantKycOnboardingStatusEnum];
export const DraftMerchantStatusEnum = {
    Created: 'created',
    DetailsAdded: 'details-added',
    DetailsSubmitted: 'details-submitted',
    SiteAdded: 'site-added',
    SiteSubmitted: 'site-submitted',
    DetailsSubmittedError: 'details-submitted-error',
    SiteSubmittedError: 'site-submitted-error'
} as const;

export type DraftMerchantStatusEnum = typeof DraftMerchantStatusEnum[keyof typeof DraftMerchantStatusEnum];

/**
 * 
 * @export
 * @interface DraftMerchantEmailRequest
 */
export interface DraftMerchantEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof DraftMerchantEmailRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface DraftSite
 */
export interface DraftSite {
    /**
     * 
     * @type {string}
     * @memberof DraftSite
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSite
     */
    'displayName'?: string;
    /**
     * 
     * @type {Address}
     * @memberof DraftSite
     */
    'address'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof DraftSite
     */
    'deliveryAddress'?: Address;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof DraftSite
     */
    'paymentMethods'?: Array<PaymentMethod>;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSite
     */
    'termsAccepted'?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DraftSite
     */
    'basket'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof DraftSite
     */
    'enableMOTO'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSite
     */
    'enablePBL'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftSite
     */
    'paymentToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSite
     */
    'stripePublishableToken'?: string;
    /**
     * 
     * @type {DraftSiteBillingPaymentMethod}
     * @memberof DraftSite
     */
    'billingPaymentMethod'?: DraftSiteBillingPaymentMethod;
    /**
     * 
     * @type {DraftSitePointOfContact}
     * @memberof DraftSite
     */
    'pointOfContact'?: DraftSitePointOfContact;
    /**
     * 
     * @type {DraftSiteTips}
     * @memberof DraftSite
     */
    'tips'?: DraftSiteTips | null;
    /**
     * 
     * @type {string}
     * @memberof DraftSite
     */
    'deliveryNotes'?: string | null;
}
/**
 * 
 * @export
 * @interface DraftSiteBillingPaymentMethod
 */
export interface DraftSiteBillingPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof DraftSiteBillingPaymentMethod
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSiteBillingPaymentMethod
     */
    'last4'?: string;
}
/**
 * 
 * @export
 * @interface DraftSitePointOfContact
 */
export interface DraftSitePointOfContact {
    /**
     * 
     * @type {string}
     * @memberof DraftSitePointOfContact
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DraftSitePointOfContact
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DraftSitePointOfContact
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DraftSitePointOfContact
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface DraftSiteTips
 */
export interface DraftSiteTips {
    /**
     * 
     * @type {string}
     * @memberof DraftSiteTips
     */
    'provider': DraftSiteTipsProviderEnum;
}

export const DraftSiteTipsProviderEnum = {
    Yetipay: 'yetipay',
    Tipjar: 'tipjar'
} as const;

export type DraftSiteTipsProviderEnum = typeof DraftSiteTipsProviderEnum[keyof typeof DraftSiteTipsProviderEnum];

/**
 * 
 * @export
 * @interface EODReport
 */
export interface EODReport {
    /**
     * Site ID
     * @type {string}
     * @memberof EODReport
     */
    'siteId': string;
    /**
     * Start date of the report
     * @type {string}
     * @memberof EODReport
     */
    'from': string;
    /**
     * Start date of the report
     * @type {string}
     * @memberof EODReport
     */
    'to': string;
    /**
     * 
     * @type {Amount}
     * @memberof EODReport
     */
    'totalTrx': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof EODReport
     */
    'totalRefunds': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof EODReport
     */
    'totalTips': Amount;
    /**
     * Number of transactions
     * @type {number}
     * @memberof EODReport
     */
    'trxCount': number;
    /**
     * Number of tips
     * @type {number}
     * @memberof EODReport
     */
    'tipsCount': number;
    /**
     * Number of refunds
     * @type {number}
     * @memberof EODReport
     */
    'refundsCount': number;
    /**
     * Total payment method
     * @type {{ [key: string]: EODReportTotalPaymentMethodValue; }}
     * @memberof EODReport
     */
    'totalPaymentMethod': { [key: string]: EODReportTotalPaymentMethodValue; };
}
/**
 * 
 * @export
 * @interface EODReportTotalPaymentMethodValue
 */
export interface EODReportTotalPaymentMethodValue {
    /**
     * 
     * @type {Amount}
     * @memberof EODReportTotalPaymentMethodValue
     */
    'totalTrx': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof EODReportTotalPaymentMethodValue
     */
    'totalRefunds': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof EODReportTotalPaymentMethodValue
     */
    'totalTips': Amount;
    /**
     * Number of transactions
     * @type {number}
     * @memberof EODReportTotalPaymentMethodValue
     */
    'trxCount': number;
    /**
     * Number of tips
     * @type {number}
     * @memberof EODReportTotalPaymentMethodValue
     */
    'tipsCount': number;
    /**
     * Number of refunds
     * @type {number}
     * @memberof EODReportTotalPaymentMethodValue
     */
    'refundsCount': number;
}
/**
 * 
 * @export
 * @interface EmailRefundReceiptRequest
 */
export interface EmailRefundReceiptRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailRefundReceiptRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmailRefundReceiptRequest
     */
    'refundPspReference': string;
}
/**
 * 
 * @export
 * @interface EmailRefundTransactionDevicesRequest
 */
export interface EmailRefundTransactionDevicesRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailRefundTransactionDevicesRequest
     */
    'refundPspReference': string;
    /**
     * 
     * @type {string}
     * @memberof EmailRefundTransactionDevicesRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EposAccountDetails
 */
export interface EposAccountDetails {
    /**
     * 
     * @type {number}
     * @memberof EposAccountDetails
     */
    'totalBalance': number;
    /**
     * 
     * @type {string}
     * @memberof EposAccountDetails
     */
    'accountId': string;
    /**
     * 
     * @type {number}
     * @memberof EposAccountDetails
     */
    'outstandingBalance': number;
    /**
     * 
     * @type {string}
     * @memberof EposAccountDetails
     */
    'tableIdentifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof EposAccountDetails
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EposAccountDetails
     */
    'staffId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EposAccountDetails
     */
    'staffName'?: string;
    /**
     * 
     * @type {Array<EposLineItem>}
     * @memberof EposAccountDetails
     */
    'lineItems': Array<EposLineItem>;
}
/**
 * 
 * @export
 * @interface EposChoiceLine
 */
export interface EposChoiceLine {
    /**
     * 
     * @type {string}
     * @memberof EposChoiceLine
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof EposChoiceLine
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof EposChoiceLine
     */
    'itemAmount': number;
    /**
     * 
     * @type {number}
     * @memberof EposChoiceLine
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof EposChoiceLine
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EposLineItem
 */
export interface EposLineItem {
    /**
     * 
     * @type {string}
     * @memberof EposLineItem
     */
    'itemType': EposLineItemItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EposLineItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EposLineItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EposLineItem
     */
    'size'?: string;
    /**
     * 
     * @type {number}
     * @memberof EposLineItem
     */
    'itemAmount': number;
    /**
     * 
     * @type {number}
     * @memberof EposLineItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof EposLineItem
     */
    'eposProductId'?: number;
    /**
     * 
     * @type {Array<EposChoiceLine>}
     * @memberof EposLineItem
     */
    'choiceLines'?: Array<EposChoiceLine>;
}

export const EposLineItemItemTypeEnum = {
    Product: 'PRODUCT',
    Payment: 'PAYMENT',
    Charge: 'CHARGE',
    Discount: 'DISCOUNT',
    Unknown: 'UNKNOWN'
} as const;

export type EposLineItemItemTypeEnum = typeof EposLineItemItemTypeEnum[keyof typeof EposLineItemItemTypeEnum];

/**
 * 
 * @export
 * @interface EposRecordPaymentRequest
 */
export interface EposRecordPaymentRequest {
    /**
     * Total amount of the payment in minor units.
     * @type {number}
     * @memberof EposRecordPaymentRequest
     */
    'amount': number;
    /**
     * The gratuity included in the payment, if any.
     * @type {number}
     * @memberof EposRecordPaymentRequest
     */
    'includedGratuity'?: number;
    /**
     * The authorization code for the payment.
     * @type {string}
     * @memberof EposRecordPaymentRequest
     */
    'authCode': string;
    /**
     * The payment method used.
     * @type {string}
     * @memberof EposRecordPaymentRequest
     */
    'paymentMethod': string;
    /**
     * The reference number for the payment.
     * @type {string}
     * @memberof EposRecordPaymentRequest
     */
    'reference'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchDevice200Response
 */
export interface FetchDevice200Response {
    /**
     * 
     * @type {string}
     * @memberof FetchDevice200Response
     */
    'id'?: string;
    /**
     * 
     * @type {FetchDevice200ResponseSignature}
     * @memberof FetchDevice200Response
     */
    'signature'?: FetchDevice200ResponseSignature;
}
/**
 * 
 * @export
 * @interface FetchDevice200ResponseSignature
 */
export interface FetchDevice200ResponseSignature {
    /**
     * 
     * @type {string}
     * @memberof FetchDevice200ResponseSignature
     */
    'deviceSlogan'?: string;
}
/**
 * 
 * @export
 * @interface FetchSiteReceiptConfig200Response
 */
export interface FetchSiteReceiptConfig200Response {
    /**
     * 
     * @type {boolean}
     * @memberof FetchSiteReceiptConfig200Response
     */
    'promptBeforePrinting'?: boolean;
    /**
     * 
     * @type {ReceiptPrintingOutcomes}
     * @memberof FetchSiteReceiptConfig200Response
     */
    'receiptPrintingOutcomes'?: ReceiptPrintingOutcomes;
}
/**
 * 
 * @export
 * @interface GetIndustries200Response
 */
export interface GetIndustries200Response {
    /**
     * 
     * @type {Array<Industry>}
     * @memberof GetIndustries200Response
     */
    'data': Array<Industry>;
}
/**
 * 
 * @export
 * @interface GetIntercomUserHash200Response
 */
export interface GetIntercomUserHash200Response {
    /**
     * 
     * @type {string}
     * @memberof GetIntercomUserHash200Response
     */
    'userHash'?: string;
}
/**
 * 
 * @export
 * @interface GetSiteSettings200Response
 */
export interface GetSiteSettings200Response {
    /**
     * 
     * @type {SiteInternalSettings}
     * @memberof GetSiteSettings200Response
     */
    'internalSettings': SiteInternalSettings;
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200Response
     */
    'name': string;
    /**
     * 
     * @type {Array<BalanceAccountPayoutConfig>}
     * @memberof GetSiteSettings200Response
     */
    'payoutSettings': Array<BalanceAccountPayoutConfig>;
    /**
     * 
     * @type {Array<GetSiteSettings200ResponseTransferInstrumentsInner>}
     * @memberof GetSiteSettings200Response
     */
    'transferInstruments'?: Array<GetSiteSettings200ResponseTransferInstrumentsInner>;
    /**
     * 
     * @type {Array<GetSiteSettings200ResponsePaymentMethodsInner>}
     * @memberof GetSiteSettings200Response
     */
    'paymentMethods'?: Array<GetSiteSettings200ResponsePaymentMethodsInner>;
}
/**
 * 
 * @export
 * @interface GetSiteSettings200ResponsePaymentMethodsInner
 */
export interface GetSiteSettings200ResponsePaymentMethodsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200ResponsePaymentMethodsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200ResponsePaymentMethodsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200ResponsePaymentMethodsInner
     */
    'displayName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSiteSettings200ResponsePaymentMethodsInner
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200ResponsePaymentMethodsInner
     */
    'verificationStatus'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSiteSettings200ResponsePaymentMethodsInner
     */
    'currencies'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetSiteSettings200ResponseTransferInstrumentsInner
 */
export interface GetSiteSettings200ResponseTransferInstrumentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200ResponseTransferInstrumentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSiteSettings200ResponseTransferInstrumentsInner
     */
    'accountIdentifier': string;
}
/**
 * 
 * @export
 * @interface GetTransactionTotals200Response
 */
export interface GetTransactionTotals200Response {
    /**
     * 
     * @type {number}
     * @memberof GetTransactionTotals200Response
     */
    'totalsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionTotals200Response
     */
    'totalsRefundsCount'?: number;
    /**
     * 
     * @type {Amount}
     * @memberof GetTransactionTotals200Response
     */
    'totalsAmount'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof GetTransactionTotals200Response
     */
    'tipsAmount'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof GetTransactionTotals200Response
     */
    'refundsAmount'?: Amount;
}
/**
 * 
 * @export
 * @interface GetsBillsDeviceResponse
 */
export interface GetsBillsDeviceResponse {
    /**
     * 
     * @type {Array<BillSimplified>}
     * @memberof GetsBillsDeviceResponse
     */
    'items'?: Array<BillSimplified>;
    /**
     * 
     * @type {string}
     * @memberof GetsBillsDeviceResponse
     */
    'lastKey'?: string;
}
/**
 * 
 * @export
 * @interface GetsTransactionsDeviceResponse
 */
export interface GetsTransactionsDeviceResponse {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof GetsTransactionsDeviceResponse
     */
    'items'?: Array<Transaction>;
    /**
     * 
     * @type {string}
     * @memberof GetsTransactionsDeviceResponse
     */
    'lastKey'?: string;
}
/**
 * 
 * @export
 * @interface Industry
 */
export interface Industry {
    /**
     * 
     * @type {string}
     * @memberof Industry
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof Industry
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Industry
     */
    'status': IndustryStatusEnum;
    /**
     * 
     * @type {IndustryCodeMapping}
     * @memberof Industry
     */
    'mapping'?: IndustryCodeMapping;
}

export const IndustryStatusEnum = {
    Approved: 'APPROVED',
    NotApproved: 'NOT_APPROVED',
    Pending: 'PENDING'
} as const;

export type IndustryStatusEnum = typeof IndustryStatusEnum[keyof typeof IndustryStatusEnum];

/**
 * 
 * @export
 * @interface IndustryCodeMapping
 */
export interface IndustryCodeMapping {
    /**
     * 
     * @type {Array<CountryIndustryCode>}
     * @memberof IndustryCodeMapping
     */
    'GB'?: Array<CountryIndustryCode>;
}
/**
 * 
 * @export
 * @interface InviteUserRequest
 */
export interface InviteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserRequest
     */
    'companyRoles': Array<string>;
    /**
     * 
     * @type {Array<InviteUserRequestSiteRolesInner>}
     * @memberof InviteUserRequest
     */
    'siteRoles': Array<InviteUserRequestSiteRolesInner>;
}
/**
 * 
 * @export
 * @interface InviteUserRequestSiteRolesInner
 */
export interface InviteUserRequestSiteRolesInner {
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequestSiteRolesInner
     */
    'siteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequestSiteRolesInner
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface KycOnboardingDetails
 */
export interface KycOnboardingDetails {
    /**
     * applicable if entity is company
     * @type {boolean}
     * @memberof KycOnboardingDetails
     */
    'businessDetails'?: boolean;
    /**
     * applicable if entity is company
     * @type {boolean}
     * @memberof KycOnboardingDetails
     */
    'decisionMakers'?: boolean;
    /**
     * applicable if entity is sole-trader
     * @type {boolean}
     * @memberof KycOnboardingDetails
     */
    'personalDetails'?: boolean;
    /**
     * applicable if entity is sole-trader
     * @type {boolean}
     * @memberof KycOnboardingDetails
     */
    'soleProprietorshipDetails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KycOnboardingDetails
     */
    'bankAccountDetails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KycOnboardingDetails
     */
    'signServiceAgreement'?: boolean;
}
/**
 * 
 * @export
 * @interface ListEODReports200Response
 */
export interface ListEODReports200Response {
    /**
     * 
     * @type {Array<EODReport>}
     * @memberof ListEODReports200Response
     */
    'data'?: Array<EODReport>;
    /**
     * 
     * @type {string}
     * @memberof ListEODReports200Response
     */
    'lastKey'?: string;
}
/**
 * 
 * @export
 * @interface ListInvoices200Response
 */
export interface ListInvoices200Response {
    /**
     * 
     * @type {Array<ListInvoices200ResponseItemsInner>}
     * @memberof ListInvoices200Response
     */
    'items': Array<ListInvoices200ResponseItemsInner>;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200Response
     */
    'lastKey'?: string;
}
/**
 * 
 * @export
 * @interface ListInvoices200ResponseItemsInner
 */
export interface ListInvoices200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    'billingPeriod': string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    'dueDate': string;
    /**
     * 
     * @type {Amount}
     * @memberof ListInvoices200ResponseItemsInner
     */
    'amount': Amount;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    'status': ListInvoices200ResponseItemsInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    'pdfLink'?: string;
}

export const ListInvoices200ResponseItemsInnerStatusEnum = {
    Upcoming: 'upcoming',
    Open: 'open',
    Paid: 'paid',
    Overdue: 'overdue',
    Void: 'void'
} as const;

export type ListInvoices200ResponseItemsInnerStatusEnum = typeof ListInvoices200ResponseItemsInnerStatusEnum[keyof typeof ListInvoices200ResponseItemsInnerStatusEnum];

/**
 * 
 * @export
 * @interface ListInvoicesV2200Response
 */
export interface ListInvoicesV2200Response {
    /**
     * 
     * @type {Array<ListInvoicesV2200ResponseItemsInner>}
     * @memberof ListInvoicesV2200Response
     */
    'items': Array<ListInvoicesV2200ResponseItemsInner>;
}
/**
 * 
 * @export
 * @interface ListInvoicesV2200ResponseItemsInner
 */
export interface ListInvoicesV2200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'billingPeriod': string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'dueDate'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'amount': Amount;
    /**
     * 
     * @type {string}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'status': ListInvoicesV2200ResponseItemsInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'pdfLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoicesV2200ResponseItemsInner
     */
    'invoiceSource'?: ListInvoicesV2200ResponseItemsInnerInvoiceSourceEnum;
}

export const ListInvoicesV2200ResponseItemsInnerStatusEnum = {
    Upcoming: 'upcoming',
    Open: 'open',
    Paid: 'paid',
    Overdue: 'overdue',
    Void: 'void'
} as const;

export type ListInvoicesV2200ResponseItemsInnerStatusEnum = typeof ListInvoicesV2200ResponseItemsInnerStatusEnum[keyof typeof ListInvoicesV2200ResponseItemsInnerStatusEnum];
export const ListInvoicesV2200ResponseItemsInnerInvoiceSourceEnum = {
    Yetipay: 'yetipay',
    Stripe: 'stripe'
} as const;

export type ListInvoicesV2200ResponseItemsInnerInvoiceSourceEnum = typeof ListInvoicesV2200ResponseItemsInnerInvoiceSourceEnum[keyof typeof ListInvoicesV2200ResponseItemsInnerInvoiceSourceEnum];

/**
 * 
 * @export
 * @interface ListMerchants200Response
 */
export interface ListMerchants200Response {
    /**
     * 
     * @type {Array<MerchantWithPermissions>}
     * @memberof ListMerchants200Response
     */
    'data'?: Array<MerchantWithPermissions>;
}
/**
 * 
 * @export
 * @interface ListReports200Response
 */
export interface ListReports200Response {
    /**
     * 
     * @type {Array<Report>}
     * @memberof ListReports200Response
     */
    'data'?: Array<Report>;
    /**
     * 
     * @type {string}
     * @memberof ListReports200Response
     */
    'lastKey'?: string;
}
/**
 * 
 * @export
 * @interface ListSites200Response
 */
export interface ListSites200Response {
    /**
     * 
     * @type {ListSites200ResponseData}
     * @memberof ListSites200Response
     */
    'data': ListSites200ResponseData;
}
/**
 * 
 * @export
 * @interface ListSites200ResponseData
 */
export interface ListSites200ResponseData {
    /**
     * 
     * @type {Array<ListSites200ResponseDataItemsInner>}
     * @memberof ListSites200ResponseData
     */
    'items': Array<ListSites200ResponseDataItemsInner>;
}
/**
 * 
 * @export
 * @interface ListSites200ResponseDataItemsInner
 */
export interface ListSites200ResponseDataItemsInner {
    /**
     * 
     * @type {string}
     * @memberof ListSites200ResponseDataItemsInner
     */
    'siteId': string;
    /**
     * 
     * @type {string}
     * @memberof ListSites200ResponseDataItemsInner
     */
    'siteName': string;
    /**
     * 
     * @type {string}
     * @memberof ListSites200ResponseDataItemsInner
     */
    'balanceAccount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListSites200ResponseDataItemsInner
     */
    'timeZone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListSites200ResponseDataItemsInner
     */
    'salesDayClosingTime'?: string;
}
/**
 * 
 * @export
 * @interface ListTransaction200Response
 */
export interface ListTransaction200Response {
    /**
     * 
     * @type {ListTransaction200ResponseData}
     * @memberof ListTransaction200Response
     */
    'data': ListTransaction200ResponseData;
}
/**
 * 
 * @export
 * @interface ListTransaction200ResponseData
 */
export interface ListTransaction200ResponseData {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof ListTransaction200ResponseData
     */
    'items'?: Array<Transaction>;
    /**
     * 
     * @type {string}
     * @memberof ListTransaction200ResponseData
     */
    'lastKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof ListTransaction200ResponseData
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Locale = {
    EnGb: 'en-GB',
    EsEs: 'es-ES',
    FrFr: 'fr-FR',
    ItIt: 'it-IT'
} as const;

export type Locale = typeof Locale[keyof typeof Locale];


/**
 * 
 * @export
 * @interface Merchant
 */
export interface Merchant {
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'financeEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'kycOnboardingLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'kycOnboardingLinkExpiry'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'kycOnboardingStatus': MerchantKycOnboardingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'kycReviewOfDataDeadline'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'dateOnboardingComplete'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'legalEntityName': string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'merchantId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Merchant
     */
    'selectedCurrencies'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Merchant
     */
    'selectedIndustries': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Merchant
     */
    'selectedPaymentMethods': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'status': MerchantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'stripeCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'type': MerchantTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'adyenPaymentFeesBalanceAccountId'?: string;
    /**
     * 
     * @type {OnboardingActions}
     * @memberof Merchant
     */
    'onboardingActions'?: OnboardingActions;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'dealSignedUrl'?: string;
    /**
     * 
     * @type {{ [key: string]: MerchantAccountHolderCapabilitiesValue; }}
     * @memberof Merchant
     */
    'accountHolderCapabilities'?: { [key: string]: MerchantAccountHolderCapabilitiesValue; };
}

export const MerchantKycOnboardingStatusEnum = {
    Verified: 'verified',
    Pending: 'pending',
    ActionRequired: 'action-required'
} as const;

export type MerchantKycOnboardingStatusEnum = typeof MerchantKycOnboardingStatusEnum[keyof typeof MerchantKycOnboardingStatusEnum];
export const MerchantStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Churned: 'churned',
    Blocked: 'blocked'
} as const;

export type MerchantStatusEnum = typeof MerchantStatusEnum[keyof typeof MerchantStatusEnum];
export const MerchantTypeEnum = {
    SoleTrader: 'sole-trader',
    Company: 'company'
} as const;

export type MerchantTypeEnum = typeof MerchantTypeEnum[keyof typeof MerchantTypeEnum];

/**
 * 
 * @export
 * @interface MerchantAccountHolderCapabilitiesValue
 */
export interface MerchantAccountHolderCapabilitiesValue {
    /**
     * 
     * @type {boolean}
     * @memberof MerchantAccountHolderCapabilitiesValue
     */
    'allowed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantAccountHolderCapabilitiesValue
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantAccountHolderCapabilitiesValue
     */
    'requested'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MerchantAccountHolderCapabilitiesValue
     */
    'verificationStatus'?: MerchantAccountHolderCapabilitiesValueVerificationStatusEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MerchantAccountHolderCapabilitiesValue
     */
    'problems'?: { [key: string]: string; };
}

export const MerchantAccountHolderCapabilitiesValueVerificationStatusEnum = {
    Pending: 'pending',
    Invalid: 'invalid',
    Valid: 'valid',
    Rejected: 'rejected'
} as const;

export type MerchantAccountHolderCapabilitiesValueVerificationStatusEnum = typeof MerchantAccountHolderCapabilitiesValueVerificationStatusEnum[keyof typeof MerchantAccountHolderCapabilitiesValueVerificationStatusEnum];

/**
 * 
 * @export
 * @interface MerchantInternalSettings
 */
export interface MerchantInternalSettings {
    /**
     * 
     * @type {string}
     * @memberof MerchantInternalSettings
     */
    'salesDayClosingTime'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantInternalSettings
     */
    'addOnFeatures'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MerchantInternalSettings
     */
    'paymentFeeDestinationBa'?: string;
}
/**
 * 
 * @export
 * @interface MerchantSettings
 */
export interface MerchantSettings {
    /**
     * 
     * @type {MerchantSettingsTapToPay}
     * @memberof MerchantSettings
     */
    'tapToPay'?: MerchantSettingsTapToPay | null;
}
/**
 * 
 * @export
 * @interface MerchantSettingsTapToPay
 */
export interface MerchantSettingsTapToPay {
    /**
     * 
     * @type {string}
     * @memberof MerchantSettingsTapToPay
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantSettingsTapToPay
     */
    'setupDate': string;
}
/**
 * 
 * @export
 * @interface MerchantUpdateRatesRequest
 */
export interface MerchantUpdateRatesRequest {
    /**
     * 
     * @type {TransactionRates}
     * @memberof MerchantUpdateRatesRequest
     */
    'transactionRates': TransactionRates;
    /**
     * True if the rate should be backfilled to the start of the month, false otherwise
     * @type {boolean}
     * @memberof MerchantUpdateRatesRequest
     */
    'shouldBackfill'?: boolean;
    /**
     * Date when the contract ends, if not set or past date, it\'s a rolling contract
     * @type {string}
     * @memberof MerchantUpdateRatesRequest
     */
    'contractEndDate'?: string;
    /**
     * Monthly rental rate per device
     * @type {number}
     * @memberof MerchantUpdateRatesRequest
     */
    'deviceRate'?: number;
    /**
     * Settlement rate for payout fee
     * @type {number}
     * @memberof MerchantUpdateRatesRequest
     */
    'settlementRate'?: number;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof MerchantUpdateRatesRequest
     */
    'discounts'?: Array<Discount>;
}
/**
 * 
 * @export
 * @interface MerchantUserEventsRequest
 */
export interface MerchantUserEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof MerchantUserEventsRequest
     */
    'client': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantUserEventsRequest
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface MerchantWithPermissions
 */
export interface MerchantWithPermissions {
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'financeEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'kycOnboardingLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'kycOnboardingLinkExpiry'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'kycOnboardingStatus': MerchantWithPermissionsKycOnboardingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'kycReviewOfDataDeadline'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'dateOnboardingComplete'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'legalEntityName': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'merchantId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantWithPermissions
     */
    'selectedCurrencies'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantWithPermissions
     */
    'selectedIndustries': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantWithPermissions
     */
    'selectedPaymentMethods': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'status': MerchantWithPermissionsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'stripeCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'type': MerchantWithPermissionsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'adyenPaymentFeesBalanceAccountId'?: string;
    /**
     * 
     * @type {OnboardingActions}
     * @memberof MerchantWithPermissions
     */
    'onboardingActions'?: OnboardingActions;
    /**
     * 
     * @type {string}
     * @memberof MerchantWithPermissions
     */
    'dealSignedUrl'?: string;
    /**
     * 
     * @type {{ [key: string]: MerchantAccountHolderCapabilitiesValue; }}
     * @memberof MerchantWithPermissions
     */
    'accountHolderCapabilities'?: { [key: string]: MerchantAccountHolderCapabilitiesValue; };
    /**
     * 
     * @type {Permissions}
     * @memberof MerchantWithPermissions
     */
    'permissions': Permissions;
    /**
     * 
     * @type {MerchantInternalSettings}
     * @memberof MerchantWithPermissions
     */
    'settings': MerchantInternalSettings;
    /**
     * 
     * @type {MerchantSettings}
     * @memberof MerchantWithPermissions
     */
    'customerSettings'?: MerchantSettings;
}

export const MerchantWithPermissionsKycOnboardingStatusEnum = {
    Verified: 'verified',
    Pending: 'pending',
    ActionRequired: 'action-required'
} as const;

export type MerchantWithPermissionsKycOnboardingStatusEnum = typeof MerchantWithPermissionsKycOnboardingStatusEnum[keyof typeof MerchantWithPermissionsKycOnboardingStatusEnum];
export const MerchantWithPermissionsStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Churned: 'churned',
    Blocked: 'blocked'
} as const;

export type MerchantWithPermissionsStatusEnum = typeof MerchantWithPermissionsStatusEnum[keyof typeof MerchantWithPermissionsStatusEnum];
export const MerchantWithPermissionsTypeEnum = {
    SoleTrader: 'sole-trader',
    Company: 'company'
} as const;

export type MerchantWithPermissionsTypeEnum = typeof MerchantWithPermissionsTypeEnum[keyof typeof MerchantWithPermissionsTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const OnboardingActionStatus = {
    Done: 'DONE',
    NeedsReview: 'NEEDS_REVIEW',
    InProgress: 'IN_PROGRESS',
    NotStarted: 'NOT_STARTED'
} as const;

export type OnboardingActionStatus = typeof OnboardingActionStatus[keyof typeof OnboardingActionStatus];


/**
 * 
 * @export
 * @interface OnboardingActions
 */
export interface OnboardingActions {
    /**
     * 
     * @type {OnboardingActionStatus}
     * @memberof OnboardingActions
     */
    'bankAccount'?: OnboardingActionStatus;
    /**
     * 
     * @type {OnboardingActionStatus}
     * @memberof OnboardingActions
     */
    'businessDetails'?: OnboardingActionStatus;
    /**
     * 
     * @type {OnboardingActionStatus}
     * @memberof OnboardingActions
     */
    'serviceAgreement'?: OnboardingActionStatus;
    /**
     * 
     * @type {OnboardingActionStatus}
     * @memberof OnboardingActions
     */
    'pciAgreement'?: OnboardingActionStatus;
    /**
     * 
     * @type {OnboardingActionStatus}
     * @memberof OnboardingActions
     */
    'contract'?: OnboardingActionStatus;
}


/**
 * 
 * @export
 * @interface OpenEposAccount
 */
export interface OpenEposAccount {
    /**
     * 
     * @type {string}
     * @memberof OpenEposAccount
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof OpenEposAccount
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenEposAccount
     */
    'customerName'?: string;
    /**
     * 
     * @type {number}
     * @memberof OpenEposAccount
     */
    'fullAccountTotal': number;
    /**
     * 
     * @type {string}
     * @memberof OpenEposAccount
     */
    'tableNumber'?: string;
}
/**
 * 
 * @export
 * @interface OpenEposAccounts
 */
export interface OpenEposAccounts {
    /**
     * 
     * @type {Array<OpenEposAccount>}
     * @memberof OpenEposAccounts
     */
    'accounts'?: Array<OpenEposAccount>;
}
/**
 * 
 * @export
 * @interface PatchSiteRequest
 */
export interface PatchSiteRequest {
    /**
     * 
     * @type {PatchSiteRequestSite}
     * @memberof PatchSiteRequest
     */
    'site'?: PatchSiteRequestSite;
}
/**
 * 
 * @export
 * @interface PatchSiteRequestSite
 */
export interface PatchSiteRequestSite {
    /**
     * The name of the site
     * @type {string}
     * @memberof PatchSiteRequestSite
     */
    'displayName'?: string;
}
/**
 * 
 * @export
 * @interface PatchUpdateDealRates
 */
export interface PatchUpdateDealRates {
    /**
     * 
     * @type {PatchUpdateDealRatesTransactionRates}
     * @memberof PatchUpdateDealRates
     */
    'transactionRates'?: PatchUpdateDealRatesTransactionRates;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRates
     */
    'deviceRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRates
     */
    'settlementRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRates
     */
    'pciRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRates
     */
    'mccRate'?: number;
    /**
     * Number of minimum monthly payouts per month (per site)
     * @type {number}
     * @memberof PatchUpdateDealRates
     */
    'mmpQty'?: number;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof PatchUpdateDealRates
     */
    'discounts'?: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof PatchUpdateDealRates
     */
    'currency'?: string;
    /**
     * Date when the contract ends, if not set or past date, it\'s a rolling contract
     * @type {string}
     * @memberof PatchUpdateDealRates
     */
    'contractEndDate'?: string;
    /**
     * Indicates if the rates have been signed and are useable
     * @type {boolean}
     * @memberof PatchUpdateDealRates
     */
    'signed'?: boolean;
    /**
     * URL to sign the agreed rates
     * @type {string}
     * @memberof PatchUpdateDealRates
     */
    'signUrl'?: string;
}
/**
 * 
 * @export
 * @interface PatchUpdateDealRatesTransactionRates
 */
export interface PatchUpdateDealRatesTransactionRates {
    /**
     * 
     * @type {string}
     * @memberof PatchUpdateDealRatesTransactionRates
     */
    'billingType'?: PatchUpdateDealRatesTransactionRatesBillingTypeEnum;
    /**
     * 
     * @type {PatchUpdateDealRatesTransactionRatesAmex}
     * @memberof PatchUpdateDealRatesTransactionRates
     */
    'amex'?: PatchUpdateDealRatesTransactionRatesAmex;
    /**
     * 
     * @type {PatchUpdateDealRatesTransactionRatesAmex}
     * @memberof PatchUpdateDealRatesTransactionRates
     */
    'other'?: PatchUpdateDealRatesTransactionRatesAmex;
    /**
     * 
     * @type {PatchUpdateDealRatesTransactionRatesDomestic}
     * @memberof PatchUpdateDealRatesTransactionRates
     */
    'domestic'?: PatchUpdateDealRatesTransactionRatesDomestic;
    /**
     * 
     * @type {PatchUpdateDealRatesTransactionRatesDomestic}
     * @memberof PatchUpdateDealRatesTransactionRates
     */
    'inter'?: PatchUpdateDealRatesTransactionRatesDomestic;
    /**
     * 
     * @type {PatchUpdateDealRatesTransactionRatesDomestic}
     * @memberof PatchUpdateDealRatesTransactionRates
     */
    'intra'?: PatchUpdateDealRatesTransactionRatesDomestic;
}

export const PatchUpdateDealRatesTransactionRatesBillingTypeEnum = {
    PerCard: 'perCard',
    Fixed: 'fixed',
    Ic: 'ic'
} as const;

export type PatchUpdateDealRatesTransactionRatesBillingTypeEnum = typeof PatchUpdateDealRatesTransactionRatesBillingTypeEnum[keyof typeof PatchUpdateDealRatesTransactionRatesBillingTypeEnum];

/**
 * 
 * @export
 * @interface PatchUpdateDealRatesTransactionRatesAmex
 */
export interface PatchUpdateDealRatesTransactionRatesAmex {
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRatesTransactionRatesAmex
     */
    'auth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRatesTransactionRatesAmex
     */
    'card'?: number;
}
/**
 * 
 * @export
 * @interface PatchUpdateDealRatesTransactionRatesDomestic
 */
export interface PatchUpdateDealRatesTransactionRatesDomestic {
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRatesTransactionRatesDomestic
     */
    'auth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRatesTransactionRatesDomestic
     */
    'debit'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRatesTransactionRatesDomestic
     */
    'credit'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchUpdateDealRatesTransactionRatesDomestic
     */
    'premium'?: number;
}
/**
 * 
 * @export
 * @interface PaymentLink
 */
export interface PaymentLink {
    /**
     * 
     * @type {string}
     * @memberof PaymentLink
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLink
     */
    'siteId': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLink
     */
    'linkId': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLink
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLink
     */
    'siteDisplayName'?: string;
}
/**
 * 
 * @export
 * @interface PaymentLinkGet200Response
 */
export interface PaymentLinkGet200Response {
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkGet200Response
     */
    'legalEntityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkGet200Response
     */
    'siteDisplayName'?: string | null;
    /**
     * 
     * @type {PaymentLinkGet200ResponseAmount}
     * @memberof PaymentLinkGet200Response
     */
    'amount'?: PaymentLinkGet200ResponseAmount;
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkGet200Response
     */
    'termsOfServiceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkGet200Response
     */
    'internalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkGet200Response
     */
    'originalRecipientEmail'?: string | null;
}
/**
 * 
 * @export
 * @interface PaymentLinkGet200ResponseAmount
 */
export interface PaymentLinkGet200ResponseAmount {
    /**
     * 
     * @type {number}
     * @memberof PaymentLinkGet200ResponseAmount
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkGet200ResponseAmount
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface PaymentLinkReceiptRequest
 */
export interface PaymentLinkReceiptRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentLinkReceiptRequest
     */
    'recipientEmail': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentMethod = {
    Afterpaytouch: 'afterpaytouch',
    Alipay: 'alipay',
    AlipayHk: 'alipay_hk',
    Amex: 'amex',
    Applepay: 'applepay',
    Bcmc: 'bcmc',
    Blik: 'blik',
    Cartebancaire: 'cartebancaire',
    Clearpay: 'clearpay',
    Cup: 'cup',
    Diners: 'diners',
    DirectEbanking: 'directEbanking',
    DirectdebitGb: 'directdebit_GB',
    Discover: 'discover',
    EbankingFi: 'ebanking_FI',
    EftposAustralia: 'eftpos_australia',
    Elo: 'elo',
    Elocredit: 'elocredit',
    Elodebit: 'elodebit',
    Girocard: 'girocard',
    Googlepay: 'googlepay',
    Hiper: 'hiper',
    Hipercard: 'hipercard',
    Ideal: 'ideal',
    InteracCard: 'interac_card',
    Jcb: 'jcb',
    Klarna: 'klarna',
    KlarnaAccount: 'klarna_account',
    KlarnaPaynow: 'klarna_paynow',
    Maestro: 'maestro',
    Mbway: 'mbway',
    Mc: 'mc',
    Mcdebit: 'mcdebit',
    MealVoucherFr: 'mealVoucher_FR',
    Mobilepay: 'mobilepay',
    Multibanco: 'multibanco',
    OnlineBankingPl: 'onlineBanking_PL',
    Paybybank: 'paybybank',
    Paypal: 'paypal',
    Payshop: 'payshop',
    Swish: 'swish',
    Trustly: 'trustly',
    Twint: 'twint',
    TwintPos: 'twint_pos',
    Vipps: 'vipps',
    Visa: 'visa',
    Visadebit: 'visadebit',
    Vpay: 'vpay',
    Wechatpay: 'wechatpay',
    WechatpayPos: 'wechatpay_pos'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];


/**
 * 
 * @export
 * @interface PaymentRates
 */
export interface PaymentRates {
    /**
     * 
     * @type {number}
     * @memberof PaymentRates
     */
    'auth': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentRates
     */
    'debit': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentRates
     */
    'credit': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentRates
     */
    'premium': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentSource = {
    AdyenTerminal: 'adyen-terminal',
    PayByLink: 'pay-by-link',
    TapToPay: 'tap-to-pay'
} as const;

export type PaymentSource = typeof PaymentSource[keyof typeof PaymentSource];


/**
 * 
 * @export
 * @interface Permissions
 */
export interface Permissions {
    /**
     * 
     * @type {Array<string>}
     * @memberof Permissions
     */
    'companyScoped'?: Array<string>;
    /**
     * 
     * @type {Array<PermissionsSiteScopedInner>}
     * @memberof Permissions
     */
    'siteScoped'?: Array<PermissionsSiteScopedInner>;
}
/**
 * 
 * @export
 * @interface PermissionsSiteScopedInner
 */
export interface PermissionsSiteScopedInner {
    /**
     * 
     * @type {string}
     * @memberof PermissionsSiteScopedInner
     */
    'siteId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionsSiteScopedInner
     */
    'permissions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface QueryMerchants200Response
 */
export interface QueryMerchants200Response {
    /**
     * 
     * @type {Array<Merchant>}
     * @memberof QueryMerchants200Response
     */
    'data'?: Array<Merchant>;
}
/**
 * 
 * @export
 * @interface ReceiptPrintingOutcomes
 */
export interface ReceiptPrintingOutcomes {
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantCancelled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantCaptureApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantCaptureRefused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantRefundApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantRefundRefused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantRefused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'merchantVoid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperCancelled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperCaptureApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperCaptureRefused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperRefundApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperRefundRefused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperRefused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptPrintingOutcomes
     */
    'shopperVoid'?: boolean;
}
/**
 * 
 * @export
 * @interface RefundTransactionRequest
 */
export interface RefundTransactionRequest {
    /**
     * 
     * @type {Amount}
     * @memberof RefundTransactionRequest
     */
    'amount': Amount;
    /**
     * 
     * @type {string}
     * @memberof RefundTransactionRequest
     */
    'emailToSendReceipt'?: string;
}
/**
 * 
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    'reportId': string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    'dataType': ReportDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    'state'?: ReportStateEnum;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    'requestedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    'fileName'?: string;
}

export const ReportDataTypeEnum = {
    Transactions: 'transactions',
    Payouts: 'payouts',
    PayoutDetail: 'payout-detail'
} as const;

export type ReportDataTypeEnum = typeof ReportDataTypeEnum[keyof typeof ReportDataTypeEnum];
export const ReportStateEnum = {
    New: 'NEW',
    Processing: 'PROCESSING',
    Ready: 'READY',
    Error: 'ERROR'
} as const;

export type ReportStateEnum = typeof ReportStateEnum[keyof typeof ReportStateEnum];

/**
 * 
 * @export
 * @interface SessionTransferCreateToken200Response
 */
export interface SessionTransferCreateToken200Response {
    /**
     * 
     * @type {string}
     * @memberof SessionTransferCreateToken200Response
     */
    'sessionToken': string;
}
/**
 * 
 * @export
 * @interface SessionTransferCreateTokenRequest
 */
export interface SessionTransferCreateTokenRequest {
    /**
     * The ID token for authentication
     * @type {string}
     * @memberof SessionTransferCreateTokenRequest
     */
    'idToken'?: string;
    /**
     * The access token for authentication
     * @type {string}
     * @memberof SessionTransferCreateTokenRequest
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface SessionTransferExchangeToken200Response
 */
export interface SessionTransferExchangeToken200Response {
    /**
     * The ID token for authentication
     * @type {string}
     * @memberof SessionTransferExchangeToken200Response
     */
    'idToken': string;
    /**
     * The access token for authentication
     * @type {string}
     * @memberof SessionTransferExchangeToken200Response
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface SessionTransferExchangeTokenRequest
 */
export interface SessionTransferExchangeTokenRequest {
    /**
     * The session token to retrieve credentials for
     * @type {string}
     * @memberof SessionTransferExchangeTokenRequest
     */
    'sessionToken'?: string;
}
/**
 * 
 * @export
 * @interface SignUrlDealRatesRequest
 */
export interface SignUrlDealRatesRequest {
    /**
     * URL to sign the agreed rates
     * @type {string}
     * @memberof SignUrlDealRatesRequest
     */
    'signUrl': string;
}
/**
 * 
 * @export
 * @interface SiteInternalSettings
 */
export interface SiteInternalSettings {
    /**
     * 
     * @type {string}
     * @memberof SiteInternalSettings
     */
    'appVariant'?: SiteInternalSettingsAppVariantEnum;
    /**
     * 
     * @type {Tips}
     * @memberof SiteInternalSettings
     */
    'tips'?: Tips;
    /**
     * 
     * @type {SiteInternalSettingsConnectPush}
     * @memberof SiteInternalSettings
     */
    'connectPush'?: SiteInternalSettingsConnectPush;
    /**
     * 
     * @type {SiteInternalSettingsConnectPull}
     * @memberof SiteInternalSettings
     */
    'connectPull'?: SiteInternalSettingsConnectPull;
    /**
     * 
     * @type {Array<SiteInternalSettingsPinsInner>}
     * @memberof SiteInternalSettings
     */
    'pins'?: Array<SiteInternalSettingsPinsInner>;
    /**
     * 
     * @type {SiteInternalSettingsMoto}
     * @memberof SiteInternalSettings
     */
    'moto'?: SiteInternalSettingsMoto;
    /**
     * 
     * @type {SiteInternalSettingsUnreferencedRefunds}
     * @memberof SiteInternalSettings
     */
    'unreferencedRefunds'?: SiteInternalSettingsUnreferencedRefunds;
}

export const SiteInternalSettingsAppVariantEnum = {
    Yetipay: 'yetipay',
    Tableyeti: 'tableyeti'
} as const;

export type SiteInternalSettingsAppVariantEnum = typeof SiteInternalSettingsAppVariantEnum[keyof typeof SiteInternalSettingsAppVariantEnum];

/**
 * 
 * @export
 * @interface SiteInternalSettingsConnectPull
 */
export interface SiteInternalSettingsConnectPull {
    /**
     * 
     * @type {string}
     * @memberof SiteInternalSettingsConnectPull
     */
    'provider': SiteInternalSettingsConnectPullProviderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SiteInternalSettingsConnectPull
     */
    'enabled': boolean;
    /**
     * 
     * @type {SiteInternalSettingsConnectPullIntegrationConfig}
     * @memberof SiteInternalSettingsConnectPull
     */
    'integrationConfig'?: SiteInternalSettingsConnectPullIntegrationConfig;
}

export const SiteInternalSettingsConnectPullProviderEnum = {
    Zonalv1: 'zonalv1',
    Ncrv1: 'ncrv1'
} as const;

export type SiteInternalSettingsConnectPullProviderEnum = typeof SiteInternalSettingsConnectPullProviderEnum[keyof typeof SiteInternalSettingsConnectPullProviderEnum];

/**
 * @type SiteInternalSettingsConnectPullIntegrationConfig
 * @export
 */
export type SiteInternalSettingsConnectPullIntegrationConfig = CPullNCRIntegrationConfig | CPullZonalIntegrationConfig;

/**
 * 
 * @export
 * @interface SiteInternalSettingsConnectPush
 */
export interface SiteInternalSettingsConnectPush {
    /**
     * 
     * @type {string}
     * @memberof SiteInternalSettingsConnectPush
     */
    'provider': SiteInternalSettingsConnectPushProviderEnum;
}

export const SiteInternalSettingsConnectPushProviderEnum = {
    YetiConnectPush: 'YetiConnectPush',
    PsConnect: 'PSConnect'
} as const;

export type SiteInternalSettingsConnectPushProviderEnum = typeof SiteInternalSettingsConnectPushProviderEnum[keyof typeof SiteInternalSettingsConnectPushProviderEnum];

/**
 * 
 * @export
 * @interface SiteInternalSettingsMoto
 */
export interface SiteInternalSettingsMoto {
    /**
     * 
     * @type {boolean}
     * @memberof SiteInternalSettingsMoto
     */
    'enabled': boolean;
    /**
     * Max amount in pence
     * @type {number}
     * @memberof SiteInternalSettingsMoto
     */
    'limit'?: number;
    /**
     * Max amount in pence for a single day
     * @type {number}
     * @memberof SiteInternalSettingsMoto
     */
    'dailyLimit'?: number;
}
/**
 * 
 * @export
 * @interface SiteInternalSettingsPinsInner
 */
export interface SiteInternalSettingsPinsInner {
    /**
     * 
     * @type {string}
     * @memberof SiteInternalSettingsPinsInner
     */
    'pin': string;
    /**
     * 
     * @type {string}
     * @memberof SiteInternalSettingsPinsInner
     */
    'role': SiteInternalSettingsPinsInnerRoleEnum;
}

export const SiteInternalSettingsPinsInnerRoleEnum = {
    Transactions: 'transactions',
    Settings: 'settings'
} as const;

export type SiteInternalSettingsPinsInnerRoleEnum = typeof SiteInternalSettingsPinsInnerRoleEnum[keyof typeof SiteInternalSettingsPinsInnerRoleEnum];

/**
 * 
 * @export
 * @interface SiteInternalSettingsUnreferencedRefunds
 */
export interface SiteInternalSettingsUnreferencedRefunds {
    /**
     * 
     * @type {boolean}
     * @memberof SiteInternalSettingsUnreferencedRefunds
     */
    'enabled': boolean;
    /**
     * Max amount in pence
     * @type {number}
     * @memberof SiteInternalSettingsUnreferencedRefunds
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface TapToPayRates
 */
export interface TapToPayRates {
    /**
     * 
     * @type {number}
     * @memberof TapToPayRates
     */
    'auth': number;
    /**
     * 
     * @type {number}
     * @memberof TapToPayRates
     */
    'ios': number;
    /**
     * 
     * @type {number}
     * @memberof TapToPayRates
     */
    'android': number;
}
/**
 * 
 * @export
 * @interface Tips
 */
export interface Tips {
    /**
     * 
     * @type {string}
     * @memberof Tips
     */
    'provider'?: TipsProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof Tips
     */
    'tipjarShortcode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Tips
     */
    'skipTipsIfServiceChargeIncluded'?: boolean;
}

export const TipsProviderEnum = {
    Tipjar: 'tipjar',
    Yetipay: 'yetipay'
} as const;

export type TipsProviderEnum = typeof TipsProviderEnum[keyof typeof TipsProviderEnum];

/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'adyenMerchantReference': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'status': TransactionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'siteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'siteName': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'success': TransactionSuccessEnum;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'paymentLinkId'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof Transaction
     */
    'amount': Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Transaction
     */
    'includedTipAmount'?: Amount;
    /**
     * 
     * @type {Array<TransactionRefund>}
     * @memberof Transaction
     */
    'refunds'?: Array<TransactionRefund>;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'pspReference': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'paymentMethod': string;
    /**
     * 
     * @type {PaymentSource}
     * @memberof Transaction
     */
    'paymentSource'?: PaymentSource;
    /**
     * 
     * @type {Array<TransactionRelatedPaymentNotificationsInner>}
     * @memberof Transaction
     */
    'relatedPaymentNotifications'?: Array<TransactionRelatedPaymentNotificationsInner>;
}

export const TransactionStatusEnum = {
    Pending: 'pending',
    Captured: 'captured',
    Failed: 'failed',
    RefundPending: 'refund-pending',
    Refunded: 'refunded',
    UnrefRefund: 'unref-refund',
    PartiallyRefunded: 'partially-refunded',
    ChargebackPending: 'chargeback-pending',
    Chargedback: 'chargedback'
} as const;

export type TransactionStatusEnum = typeof TransactionStatusEnum[keyof typeof TransactionStatusEnum];
export const TransactionSuccessEnum = {
    True: 'true',
    False: 'false'
} as const;

export type TransactionSuccessEnum = typeof TransactionSuccessEnum[keyof typeof TransactionSuccessEnum];

/**
 * 
 * @export
 * @interface TransactionRates
 */
export interface TransactionRates {
    /**
     * 
     * @type {string}
     * @memberof TransactionRates
     */
    'billingType': TransactionRatesBillingTypeEnum;
    /**
     * 
     * @type {BasicPaymentRates}
     * @memberof TransactionRates
     */
    'amex': BasicPaymentRates;
    /**
     * 
     * @type {BasicPaymentRates}
     * @memberof TransactionRates
     */
    'other': BasicPaymentRates;
    /**
     * 
     * @type {PaymentRates}
     * @memberof TransactionRates
     */
    'domestic': PaymentRates;
    /**
     * 
     * @type {PaymentRates}
     * @memberof TransactionRates
     */
    'inter': PaymentRates;
    /**
     * 
     * @type {PaymentRates}
     * @memberof TransactionRates
     */
    'intra': PaymentRates;
    /**
     * 
     * @type {TapToPayRates}
     * @memberof TransactionRates
     */
    'tapToPay'?: TapToPayRates;
}

export const TransactionRatesBillingTypeEnum = {
    PerCard: 'perCard',
    Fixed: 'fixed',
    Ic: 'ic'
} as const;

export type TransactionRatesBillingTypeEnum = typeof TransactionRatesBillingTypeEnum[keyof typeof TransactionRatesBillingTypeEnum];

/**
 * 
 * @export
 * @interface TransactionRefund
 */
export interface TransactionRefund {
    /**
     * 
     * @type {Amount}
     * @memberof TransactionRefund
     */
    'amount': Amount;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionRefund
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransactionRefund
     */
    'pspReference': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionRefund
     */
    'bookingDate': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionRefund
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface TransactionRelatedPaymentNotificationsInner
 */
export interface TransactionRelatedPaymentNotificationsInner {
    /**
     * 
     * @type {TransactionRelatedPaymentNotificationsInnerAdditionalData}
     * @memberof TransactionRelatedPaymentNotificationsInner
     */
    'additionalData'?: TransactionRelatedPaymentNotificationsInnerAdditionalData;
}
/**
 * 
 * @export
 * @interface TransactionRelatedPaymentNotificationsInnerAdditionalData
 */
export interface TransactionRelatedPaymentNotificationsInnerAdditionalData {
    /**
     * 
     * @type {string}
     * @memberof TransactionRelatedPaymentNotificationsInnerAdditionalData
     */
    'cardSummary'?: string;
}
/**
 * 
 * @export
 * @interface TransferMerchantRequest
 */
export interface TransferMerchantRequest {
    /**
     * 
     * @type {string}
     * @memberof TransferMerchantRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface TriggerTransferRequest
 */
export interface TriggerTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof TriggerTransferRequest
     */
    'transferInstrumentId': string;
}
/**
 * 
 * @export
 * @interface UpdateDealRates
 */
export interface UpdateDealRates {
    /**
     * 
     * @type {TransactionRates}
     * @memberof UpdateDealRates
     */
    'transactionRates': TransactionRates;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealRates
     */
    'deviceRate': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealRates
     */
    'settlementRate': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealRates
     */
    'pciRate': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealRates
     */
    'mccRate': number;
    /**
     * Number of minimum monthly payouts per month (per site)
     * @type {number}
     * @memberof UpdateDealRates
     */
    'mmpQty'?: number;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof UpdateDealRates
     */
    'discounts'?: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof UpdateDealRates
     */
    'currency': string;
    /**
     * Date when the contract ends, if not set or past date, it\'s a rolling contract
     * @type {string}
     * @memberof UpdateDealRates
     */
    'contractEndDate'?: string;
    /**
     * Indicates if the rates have been signed and are useable
     * @type {boolean}
     * @memberof UpdateDealRates
     */
    'signed'?: boolean;
    /**
     * URL to sign the agreed rates
     * @type {string}
     * @memberof UpdateDealRates
     */
    'signUrl'?: string;
}
/**
 * 
 * @export
 * @interface UpdateDeviceRequest
 */
export interface UpdateDeviceRequest {
    /**
     * 
     * @type {UpdateDeviceRequestSignature}
     * @memberof UpdateDeviceRequest
     */
    'signature'?: UpdateDeviceRequestSignature;
}
/**
 * 
 * @export
 * @interface UpdateDeviceRequestSignature
 */
export interface UpdateDeviceRequestSignature {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeviceRequestSignature
     */
    'deviceSlogan'?: string;
}
/**
 * 
 * @export
 * @interface UpdateDraftMerchantDetails
 */
export interface UpdateDraftMerchantDetails {
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'entity'?: UpdateDraftMerchantDetailsEntityEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'legalEntityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantDetails
     */
    'industryCode'?: string;
}

export const UpdateDraftMerchantDetailsEntityEnum = {
    SoleTrader: 'sole-trader',
    Company: 'company'
} as const;

export type UpdateDraftMerchantDetailsEntityEnum = typeof UpdateDraftMerchantDetailsEntityEnum[keyof typeof UpdateDraftMerchantDetailsEntityEnum];

/**
 * 
 * @export
 * @interface UpdateDraftMerchantSite
 */
export interface UpdateDraftMerchantSite {
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantSite
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantSite
     */
    'displayName'?: string;
    /**
     * 
     * @type {Address}
     * @memberof UpdateDraftMerchantSite
     */
    'address'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof UpdateDraftMerchantSite
     */
    'deliveryAddress'?: Address;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof UpdateDraftMerchantSite
     */
    'paymentMethods'?: Array<PaymentMethod>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDraftMerchantSite
     */
    'termsAccepted'?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof UpdateDraftMerchantSite
     */
    'basket'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDraftMerchantSite
     */
    'enableMOTO'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDraftMerchantSite
     */
    'enablePBL'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantSite
     */
    'paymentToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantSite
     */
    'stripePublishableToken'?: string;
    /**
     * 
     * @type {DraftSiteBillingPaymentMethod}
     * @memberof UpdateDraftMerchantSite
     */
    'billingPaymentMethod'?: DraftSiteBillingPaymentMethod;
    /**
     * 
     * @type {DraftSitePointOfContact}
     * @memberof UpdateDraftMerchantSite
     */
    'pointOfContact'?: DraftSitePointOfContact;
    /**
     * 
     * @type {DraftSiteTips}
     * @memberof UpdateDraftMerchantSite
     */
    'tips'?: DraftSiteTips | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftMerchantSite
     */
    'deliveryNotes'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMerchantInternalSettingsRequest
 */
export interface UpdateMerchantInternalSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantInternalSettingsRequest
     */
    'appVariant'?: UpdateMerchantInternalSettingsRequestAppVariantEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantInternalSettingsRequest
     */
    'salesDayClosingTime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMerchantInternalSettingsRequest
     */
    'addOnFeatures'?: Array<UpdateMerchantInternalSettingsRequestAddOnFeaturesEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantInternalSettingsRequest
     */
    'paymentFeeDestinationBa'?: UpdateMerchantInternalSettingsRequestPaymentFeeDestinationBaEnum;
}

export const UpdateMerchantInternalSettingsRequestAppVariantEnum = {
    Yetipay: 'yetipay',
    Tableyeti: 'tableyeti'
} as const;

export type UpdateMerchantInternalSettingsRequestAppVariantEnum = typeof UpdateMerchantInternalSettingsRequestAppVariantEnum[keyof typeof UpdateMerchantInternalSettingsRequestAppVariantEnum];
export const UpdateMerchantInternalSettingsRequestAddOnFeaturesEnum = {
    LeaveAtTable: 'leave-at-table',
    PayWaiter: 'pay-waiter',
    TapToPay: 'tap-to-pay',
    LegacyStandalonePayments: 'legacy-standalone-payments'
} as const;

export type UpdateMerchantInternalSettingsRequestAddOnFeaturesEnum = typeof UpdateMerchantInternalSettingsRequestAddOnFeaturesEnum[keyof typeof UpdateMerchantInternalSettingsRequestAddOnFeaturesEnum];
export const UpdateMerchantInternalSettingsRequestPaymentFeeDestinationBaEnum = {
    LiableAccountBa: 'liable-account-ba',
    StoreBa: 'store-ba',
    AccountHolderFeesBa: 'account-holder-fees-ba'
} as const;

export type UpdateMerchantInternalSettingsRequestPaymentFeeDestinationBaEnum = typeof UpdateMerchantInternalSettingsRequestPaymentFeeDestinationBaEnum[keyof typeof UpdateMerchantInternalSettingsRequestPaymentFeeDestinationBaEnum];

/**
 * 
 * @export
 * @interface UpdateMerchantRequest
 */
export interface UpdateMerchantRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantRequest
     */
    'financeEmail': string;
}
/**
 * 
 * @export
 * @interface UpdateMerchantSettingsRequest
 */
export interface UpdateMerchantSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMerchantSettingsRequest
     */
    'setupTapToPay'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateSiteDevicesPasscodes200Response
 */
export interface UpdateSiteDevicesPasscodes200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteDevicesPasscodes200Response
     */
    'adminMenuPin'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteDevicesPasscodes200Response
     */
    'txMenuPin'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSiteDevicesPasscodesRequest
 */
export interface UpdateSiteDevicesPasscodesRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteDevicesPasscodesRequest
     */
    'adminMenuPin'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteDevicesPasscodesRequest
     */
    'txMenuPin'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSiteReceiptConfigRequest
 */
export interface UpdateSiteReceiptConfigRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSiteReceiptConfigRequest
     */
    'promptBeforePrinting'?: boolean;
    /**
     * 
     * @type {ReceiptPrintingOutcomes}
     * @memberof UpdateSiteReceiptConfigRequest
     */
    'receiptPrintingOutcomes'?: ReceiptPrintingOutcomes;
}
/**
 * 
 * @export
 * @interface UpdateSitesPaymentMethodRequest
 */
export interface UpdateSitesPaymentMethodRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSitesPaymentMethodRequest
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateSweepSettings200Response
 */
export interface UpdateSweepSettings200Response {
    /**
     * 
     * @type {BalanceAccountPayoutConfig}
     * @memberof UpdateSweepSettings200Response
     */
    'data': BalanceAccountPayoutConfig;
}
/**
 * 
 * @export
 * @interface UpdateSweepSettingsRequest
 */
export interface UpdateSweepSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSweepSettingsRequest
     */
    'status'?: UpdateSweepSettingsRequestStatusEnum;
    /**
     * 
     * @type {UpdateSweepSettingsRequestCounterparty}
     * @memberof UpdateSweepSettingsRequest
     */
    'counterparty'?: UpdateSweepSettingsRequestCounterparty;
}

export const UpdateSweepSettingsRequestStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type UpdateSweepSettingsRequestStatusEnum = typeof UpdateSweepSettingsRequestStatusEnum[keyof typeof UpdateSweepSettingsRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdateSweepSettingsRequestCounterparty
 */
export interface UpdateSweepSettingsRequestCounterparty {
    /**
     * 
     * @type {string}
     * @memberof UpdateSweepSettingsRequestCounterparty
     */
    'transferInstrumentId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'jobTitle'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserRequest
     */
    'companyRoles'?: Array<string>;
    /**
     * 
     * @type {Array<InviteUserRequestSiteRolesInner>}
     * @memberof UpdateUserRequest
     */
    'siteRoles'?: Array<InviteUserRequestSiteRolesInner>;
    /**
     * 
     * @type {UpdateUserRequestPreferences}
     * @memberof UpdateUserRequest
     */
    'preferences'?: UpdateUserRequestPreferences | null;
}
/**
 * 
 * @export
 * @interface UpdateUserRequestPreferences
 */
export interface UpdateUserRequestPreferences {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequestPreferences
     */
    'isTapToPayEnabled'?: boolean | null;
    /**
     * 
     * @type {Locale}
     * @memberof UpdateUserRequestPreferences
     */
    'locale'?: Locale;
}


/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName'?: string;
    /**
     * Job title of the user in the company
     * @type {string}
     * @memberof User
     */
    'jobTitle'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'companyRoles': Array<string>;
    /**
     * 
     * @type {Array<UserSiteRolesInner>}
     * @memberof User
     */
    'siteRoles': Array<UserSiteRolesInner>;
    /**
     * 
     * @type {UserPreferences}
     * @memberof User
     */
    'preferences'?: UserPreferences;
}
/**
 * 
 * @export
 * @interface UserPreferences
 */
export interface UserPreferences {
    /**
     * User preference for tap to pay being enabled for device
     * @type {boolean}
     * @memberof UserPreferences
     */
    'isTapToPayEnabled'?: boolean;
    /**
     * 
     * @type {Locale}
     * @memberof UserPreferences
     */
    'locale'?: Locale;
}


/**
 * 
 * @export
 * @interface UserSiteRolesInner
 */
export interface UserSiteRolesInner {
    /**
     * 
     * @type {string}
     * @memberof UserSiteRolesInner
     */
    'siteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSiteRolesInner
     */
    'role'?: string;
}

/**
 * BasecampApi - axios parameter creator
 * @export
 */
export const BasecampApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new credit grant to a deal
         * @summary Add a new credit grant to a deal
         * @param {string} merchantId ID of the customer
         * @param {Credit} credit Credit grant to add to a deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCreditGrant: async (merchantId: string, credit: Credit, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('addCreditGrant', 'merchantId', merchantId)
            // verify required parameter 'credit' is not null or undefined
            assertParamExists('addCreditGrant', 'credit', credit)
            const localVarPath = `/v1/merchants/{merchantId}/rates/credits`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(credit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a push token
         * @summary Add a push token
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPushToken: async (merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('addPushToken', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addPushToken', 'userId', userId)
            // verify required parameter 'addPushTokenRequest' is not null or undefined
            assertParamExists('addPushToken', 'addPushTokenRequest', addPushTokenRequest)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}/push-tokens`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPushTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new payment method to a site
         * @summary Add a new payment method to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSitesPaymentMethod: async (merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('addSitesPaymentMethod', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('addSitesPaymentMethod', 'siteId', siteId)
            // verify required parameter 'addSitesPaymentMethodRequest' is not null or undefined
            assertParamExists('addSitesPaymentMethod', 'addSitesPaymentMethodRequest', addSitesPaymentMethodRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/payment-methods`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSitesPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new device to a site
         * @summary Add a new device to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice: async (merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('assignDevice', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('assignDevice', 'siteId', siteId)
            // verify required parameter 'assignDeviceRequest' is not null or undefined
            assertParamExists('assignDevice', 'assignDeviceRequest', assignDeviceRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/assign-device`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Associate a deal\'s rate to a merchant
         * @summary Associate a deal\'s rate to a merchant
         * @param {string} merchantId ID of the customer
         * @param {string} dealReference Reference of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateRates: async (merchantId: string, dealReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('associateRates', 'merchantId', merchantId)
            // verify required parameter 'dealReference' is not null or undefined
            assertParamExists('associateRates', 'dealReference', dealReference)
            const localVarPath = `/v1/merchants/{merchantId}/rates/associate`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dealReference !== undefined) {
                localVarQueryParameter['dealReference'] = dealReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Block a merchant
         * @summary Block a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockMerchant: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('blockMerchant', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/block`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a session for adyen capital
         * @summary Create a session for adyen capital
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCapitalSession: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createCapitalSession', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/capital/sessions`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a draft merchant
         * @summary Create a draft merchant
         * @param {CreateDraftMerchantRequest} [createDraftMerchantRequest] Create draft merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftMerchant: async (createDraftMerchantRequest?: CreateDraftMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/draft-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an invite token for a draft merchant and sends an email to the recipient
         * @summary Create an invite token for a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {CreateDraftMerchantInviteTokenRequest} [createDraftMerchantInviteTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftMerchantInviteToken: async (email: string, dealShortCode?: string, createDraftMerchantInviteTokenRequest?: CreateDraftMerchantInviteTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createDraftMerchantInviteToken', 'email', email)
            const localVarPath = `/v1/draft-merchants/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftMerchantInviteTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create EOD report
         * @summary Create EOD report
         * @param {string} merchantId ID of the customer
         * @param {CreateEODReportRequest} createEODReportRequest Site ID to scope the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEODReport: async (merchantId: string, createEODReportRequest: CreateEODReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createEODReport', 'merchantId', merchantId)
            // verify required parameter 'createEODReportRequest' is not null or undefined
            assertParamExists('createEODReport', 'createEODReportRequest', createEODReportRequest)
            const localVarPath = `/v1/merchants/{merchantId}/eod-reports`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DeviceBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEODReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a report
         * @summary Create a report
         * @param {string} merchantId ID of the customer
         * @param {CreateReportRequest} createReportRequest Create report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport: async (merchantId: string, createReportRequest: CreateReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createReport', 'merchantId', merchantId)
            // verify required parameter 'createReportRequest' is not null or undefined
            assertParamExists('createReport', 'createReportRequest', createReportRequest)
            const localVarPath = `/v1/merchants/{merchantId}/reports`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a transaction
         * @summary Create a transaction placeholder
         * @param {string} merchantId ID of the customer
         * @param {CreateTransactionRequest} createTransactionRequest Create transaction body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction: async (merchantId: string, createTransactionRequest: CreateTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createTransaction', 'merchantId', merchantId)
            // verify required parameter 'createTransactionRequest' is not null or undefined
            assertParamExists('createTransaction', 'createTransactionRequest', createTransactionRequest)
            const localVarPath = `/v2/merchants/{merchantId}/transactions`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create and send a transaction receipt
         * @summary Create and send a transaction receipt
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Receipt params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransactionReceipt: async (merchantId: string, pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createTransactionReceipt', 'merchantId', merchantId)
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('createTransactionReceipt', 'pspReference', pspReference)
            // verify required parameter 'createTransactionReceiptRequest' is not null or undefined
            assertParamExists('createTransactionReceipt', 'createTransactionReceiptRequest', createTransactionReceiptRequest)
            const localVarPath = `/v1/merchants/{merchantId}/transactions/{pspReference}/receipt`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a hosted onboarding verification link for a merchant\'s onboarding process
         * @summary Create a hosted onboarding verification link for a merchant
         * @param {string} merchantId ID of the customer
         * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationLink: async (merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createVerificationLink', 'merchantId', merchantId)
            const localVarPath = `/merchants/{merchantId}/verification-links`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVerificationLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a merchant
         * @summary Deactivate a merchant
         * @param {string} merchantId ID of the customer
         * @param {DeactivateMerchantStageEnum} stage Stage of deactivation, allowing to report an action or effectively deactivate a customer
         * @param {DeactivateMerchantRequest} deactivateMerchantRequest Deactivate merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateMerchant: async (merchantId: string, stage: DeactivateMerchantStageEnum, deactivateMerchantRequest: DeactivateMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deactivateMerchant', 'merchantId', merchantId)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('deactivateMerchant', 'stage', stage)
            // verify required parameter 'deactivateMerchantRequest' is not null or undefined
            assertParamExists('deactivateMerchant', 'deactivateMerchantRequest', deactivateMerchantRequest)
            const localVarPath = `/v1/merchants/{merchantId}/deactivate`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deactivateMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set default payment method
         * @summary Set default payment method
         * @param {string} merchantId ID of the customer
         * @param {string} paymentMethodId ID of the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultPaymentMethod: async (merchantId: string, paymentMethodId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('defaultPaymentMethod', 'merchantId', merchantId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('defaultPaymentMethod', 'paymentMethodId', paymentMethodId)
            const localVarPath = `/v1/merchants/{merchantId}/billing-settings/payment-methods/{paymentMethodId}/default`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a payment method
         * @summary Delete a payment method
         * @param {string} merchantId ID of the customer
         * @param {string} paymentMethodId ID of the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod: async (merchantId: string, paymentMethodId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deletePaymentMethod', 'merchantId', merchantId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('deletePaymentMethod', 'paymentMethodId', paymentMethodId)
            const localVarPath = `/v1/merchants/{merchantId}/billing-settings/payment-methods/{paymentMethodId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a push token
         * @summary Delete a push token
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushToken: async (merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deletePushToken', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deletePushToken', 'userId', userId)
            // verify required parameter 'addPushTokenRequest' is not null or undefined
            assertParamExists('deletePushToken', 'addPushTokenRequest', addPushTokenRequest)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}/push-tokens`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPushTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete user
         * @summary Delete a user
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (merchantId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deleteUser', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an invoice
         * @summary Download an invoice
         * @param {string} merchantId ID of the customer
         * @param {string} invoiceNumber Number / ID of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice: async (merchantId: string, invoiceNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('downloadInvoice', 'merchantId', merchantId)
            // verify required parameter 'invoiceNumber' is not null or undefined
            assertParamExists('downloadInvoice', 'invoiceNumber', invoiceNumber)
            const localVarPath = `/v1/merchants/{merchantId}/invoices/{invoiceNumber}/download`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"invoiceNumber"}}`, encodeURIComponent(String(invoiceNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a report
         * @summary Download a report
         * @param {string} merchantId ID of the customer
         * @param {string} reportId ID of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport: async (merchantId: string, reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('downloadReport', 'merchantId', merchantId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('downloadReport', 'reportId', reportId)
            const localVarPath = `/v1/merchants/{merchantId}/reports/{reportId}/download`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit draft merchant details
         * @summary Update a merchant email during onboarding
         * @param {DraftMerchantEmailRequest} draftMerchantEmailRequest 
         * @param {string} [email] Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {string} [inviteToken] Token from the invite email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        draftMerchantEmail: async (draftMerchantEmailRequest: DraftMerchantEmailRequest, email?: string, dealShortCode?: string, inviteToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftMerchantEmailRequest' is not null or undefined
            assertParamExists('draftMerchantEmail', 'draftMerchantEmailRequest', draftMerchantEmailRequest)
            const localVarPath = `/v1/draft-merchants/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }

            if (inviteToken !== undefined) {
                localVarQueryParameter['inviteToken'] = inviteToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(draftMerchantEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Email a receipt for a refund
         * @summary Email a receipt for a refund
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {EmailRefundReceiptRequest} emailRefundReceiptRequest Referenced refund additional parameters to send email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRefundReceipt: async (merchantId: string, pspReference: string, emailRefundReceiptRequest: EmailRefundReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('emailRefundReceipt', 'merchantId', merchantId)
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('emailRefundReceipt', 'pspReference', pspReference)
            // verify required parameter 'emailRefundReceiptRequest' is not null or undefined
            assertParamExists('emailRefundReceipt', 'emailRefundReceiptRequest', emailRefundReceiptRequest)
            const localVarPath = `/v1/merchants/{merchantId}/transactions/{pspReference}/refund/receipt`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailRefundReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch device settings
         * @summary Fetch device settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} deviceId ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDevice: async (merchantId: string, siteId: string, deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('fetchDevice', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('fetchDevice', 'siteId', siteId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('fetchDevice', 'deviceId', deviceId)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/devices/{deviceId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the receipt printing preferences configured for a specific site
         * @summary Fetch receipt config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSiteReceiptConfig: async (merchantId: string, siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('fetchSiteReceiptConfig', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('fetchSiteReceiptConfig', 'siteId', siteId)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/receipts`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a draft merchant
         * @summary Get a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftMerchant: async (email: string, dealShortCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getDraftMerchant', 'email', email)
            const localVarPath = `/v1/draft-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available industries
         * @summary List all available industries
         * @param {string} [email] Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndustries: async (email?: string, dealShortCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/industries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate and return a user hash for intercom user verification based on the user ID and platform.
         * @summary Retrieve a user hash for intercom user verification
         * @param {GetIntercomUserHashPlatformEnum} platform The platform for which the user hash is being requested.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntercomUserHash: async (platform: GetIntercomUserHashPlatformEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('getIntercomUserHash', 'platform', platform)
            const localVarPath = `/v1/intercom/{platform}/user-hash`
                .replace(`{${"platform"}}`, encodeURIComponent(String(platform)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a merchant
         * @summary Get a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchant: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchant', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get draft merchant from invite
         * @summary Get draft merchant from invite
         * @param {string} inviteToken Token from the invite email
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingInvite: async (inviteToken: string, dealShortCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteToken' is not null or undefined
            assertParamExists('getOnboardingInvite', 'inviteToken', inviteToken)
            const localVarPath = `/v1/draft-merchants/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }

            if (inviteToken !== undefined) {
                localVarQueryParameter['inviteToken'] = inviteToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an existing site\'s settings by Id
         * @summary Get an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteSettings: async (merchantId: string, siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getSiteSettings', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getSiteSettings', 'siteId', siteId)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/internal`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transaction totals for a time period
         * @summary Get transaction totals for a time period
         * @param {string} merchantId ID of the customer
         * @param {string} siteId Scope transactions by site
         * @param {string} startDate Start date for the time period (24-hour range)
         * @param {string} [type] Search by transaction type
         * @param {GetTransactionTotalsPaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionTotals: async (merchantId: string, siteId: string, startDate: string, type?: string, paymentSource?: GetTransactionTotalsPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getTransactionTotals', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getTransactionTotals', 'siteId', siteId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTransactionTotals', 'startDate', startDate)
            const localVarPath = `/v1/merchants/{merchantId}/transactions/totals`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (paymentSource !== undefined) {
                localVarQueryParameter['paymentSource'] = paymentSource;
            }

            if (paymentMethods !== undefined) {
                localVarQueryParameter['paymentMethods'] = paymentMethods;
            }

            if (amounts !== undefined) {
                localVarQueryParameter['amounts'] = amounts;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (cardSummary !== undefined) {
                localVarQueryParameter['cardSummary'] = cardSummary;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user
         * @summary Get user details
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (merchantId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getUser', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite user
         * @summary Invite user
         * @param {string} merchantId ID of the customer
         * @param {InviteUserRequest} inviteUserRequest Invite user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (merchantId: string, inviteUserRequest: InviteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('inviteUser', 'merchantId', merchantId)
            // verify required parameter 'inviteUserRequest' is not null or undefined
            assertParamExists('inviteUser', 'inviteUserRequest', inviteUserRequest)
            const localVarPath = `/v1/merchants/{merchantId}/users`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List EOD reports
         * @summary List EOD reports
         * @param {string} merchantId ID of the customer
         * @param {string} [siteId] Scope reports by site
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [dates] Date range for report (Comma separates start and end date)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEODReports: async (merchantId: string, siteId?: string, lastKey?: string, dates?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listEODReports', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/eod-reports`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DeviceBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }

            if (dates !== undefined) {
                localVarQueryParameter['dates'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [createdBetween] Search invoices created between dates in timestamp format
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices: async (merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listInvoices', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/invoices`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }

            if (createdBetween !== undefined) {
                localVarQueryParameter['createdBetween'] = createdBetween;
            }

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [year] Year to fetch invoices for. Default is current year
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoicesV2: async (merchantId: string, year?: string, invoiceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listInvoicesV2', 'merchantId', merchantId)
            const localVarPath = `/v2/merchants/{merchantId}/invoices`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all merchants associated with the requesting user.
         * @summary Get merchants for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchants: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List payment links for a set of link id
         * @summary List payment links for a set of link id
         * @param {string} merchantId ID of the customer
         * @param {string} linkIds Link ids to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPaymentLinks: async (merchantId: string, linkIds: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listPaymentLinks', 'merchantId', merchantId)
            // verify required parameter 'linkIds' is not null or undefined
            assertParamExists('listPaymentLinks', 'linkIds', linkIds)
            const localVarPath = `/v1/merchant/{merchantId}/payment-links`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (linkIds !== undefined) {
                localVarQueryParameter['linkIds'] = linkIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List reports
         * @summary List reports
         * @param {string} merchantId ID of the customer
         * @param {string} [siteId] Scope reports by site
         * @param {ListReportsTypeEnum} [type] Type of report to list
         * @param {string} [lastKey] Pagination parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports: async (merchantId: string, siteId?: string, type?: ListReportsTypeEnum, lastKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listReports', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/reports`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all sites for a merchant
         * @summary List all sites for a merchant
         * @param {string} merchantId ID of the customer
         * @param {boolean} [includeConfig] Include extended site configuration information
         * @param {boolean} [all] Deprecated. No-op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSites: async (merchantId: string, includeConfig?: boolean, all?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listSites', 'merchantId', merchantId)
            const localVarPath = `/merchants/{merchantId}/sites`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeConfig !== undefined) {
                localVarQueryParameter['includeConfig'] = includeConfig;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List transactions from a merchant
         * @summary List transactions of a merchant
         * @param {string} merchantId ID of the customer
         * @param {string} [type] Search by transaction type
         * @param {ListTransactionPaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {string} [dates] Date range for transactions (Comma separates start and end date)
         * @param {string} [psp] Search transactions by PSP
         * @param {string} [siteId] Search by site
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [countOnly] Returns the number of pages, and no items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransaction: async (merchantId: string, type?: string, paymentSource?: ListTransactionPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, dates?: string, psp?: string, siteId?: string, lastKey?: string, countOnly?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listTransaction', 'merchantId', merchantId)
            const localVarPath = `/v2/merchants/{merchantId}/transactions`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (paymentSource !== undefined) {
                localVarQueryParameter['paymentSource'] = paymentSource;
            }

            if (paymentMethods !== undefined) {
                localVarQueryParameter['paymentMethods'] = paymentMethods;
            }

            if (amounts !== undefined) {
                localVarQueryParameter['amounts'] = amounts;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (cardSummary !== undefined) {
                localVarQueryParameter['cardSummary'] = cardSummary;
            }

            if (dates !== undefined) {
                localVarQueryParameter['dates'] = dates;
            }

            if (psp !== undefined) {
                localVarQueryParameter['psp'] = psp;
            }

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }

            if (countOnly !== undefined) {
                localVarQueryParameter['countOnly'] = countOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List users
         * @summary List users
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listUsers', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/users`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get rates for a merchant
         * @summary Get rates for a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetRates: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('merchantGetRates', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/rates`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update rates for a merchant
         * @summary Update rates for a merchant
         * @param {string} merchantId ID of the customer
         * @param {MerchantUpdateRatesRequest} merchantUpdateRatesRequest Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantUpdateRates: async (merchantId: string, merchantUpdateRatesRequest: MerchantUpdateRatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('merchantUpdateRates', 'merchantId', merchantId)
            // verify required parameter 'merchantUpdateRatesRequest' is not null or undefined
            assertParamExists('merchantUpdateRates', 'merchantUpdateRatesRequest', merchantUpdateRatesRequest)
            const localVarPath = `/v1/merchants/{merchantId}/rates`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantUpdateRatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle merchant user events
         * @summary Handle merchant user events
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {MerchantUserEventsRequest} merchantUserEventsRequest Event body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantUserEvents: async (merchantId: string, userId: string, merchantUserEventsRequest: MerchantUserEventsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('merchantUserEvents', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('merchantUserEvents', 'userId', userId)
            // verify required parameter 'merchantUserEventsRequest' is not null or undefined
            assertParamExists('merchantUserEvents', 'merchantUserEventsRequest', merchantUserEventsRequest)
            const localVarPath = `/v2/merchants/{merchantId}/users/{userId}/events`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantUserEventsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch site
         * @summary Patch site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {PatchSiteRequest} patchSiteRequest Update site details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSite: async (merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('patchSite', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('patchSite', 'siteId', siteId)
            // verify required parameter 'patchSiteRequest' is not null or undefined
            assertParamExists('patchSite', 'patchSiteRequest', patchSiteRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchSiteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for merchants
         * @summary Search for merchants
         * @param {string} [name] Partial name of customer
         * @param {string} [accountHolderId] Account holder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryMerchants: async (name?: string, accountHolderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/merchants/staff-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (accountHolderId !== undefined) {
                localVarQueryParameter['accountHolderId'] = accountHolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refund a transaction
         * @summary Refund a transaction
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundTransaction: async (merchantId: string, pspReference: string, refundTransactionRequest: RefundTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('refundTransaction', 'merchantId', merchantId)
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('refundTransaction', 'pspReference', pspReference)
            // verify required parameter 'refundTransactionRequest' is not null or undefined
            assertParamExists('refundTransaction', 'refundTransactionRequest', refundTransactionRequest)
            const localVarPath = `/merchants/{merchantId}/transactions/{pspReference}/refunds`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset user password
         * @summary Reset user password
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (merchantId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('resetUserPassword', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserPassword', 'userId', userId)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}/reset-password`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate and return a session token to transfer access and id tokens
         * @summary Create a token for session transfer
         * @param {SessionTransferCreateTokenRequest} sessionTransferCreateTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionTransferCreateToken: async (sessionTransferCreateTokenRequest: SessionTransferCreateTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionTransferCreateTokenRequest' is not null or undefined
            assertParamExists('sessionTransferCreateToken', 'sessionTransferCreateTokenRequest', sessionTransferCreateTokenRequest)
            const localVarPath = `/v1/session-transfer/create-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionTransferCreateTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the Cognito credentials associated with a session transfer token.
         * @summary Exchange session token for access and id tokens
         * @param {SessionTransferExchangeTokenRequest} sessionTransferExchangeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionTransferExchangeToken: async (sessionTransferExchangeTokenRequest: SessionTransferExchangeTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionTransferExchangeTokenRequest' is not null or undefined
            assertParamExists('sessionTransferExchangeToken', 'sessionTransferExchangeTokenRequest', sessionTransferExchangeTokenRequest)
            const localVarPath = `/v1/session-transfer/exchange-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionTransferExchangeTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit draft merchant details
         * @summary Submit draft merchant details
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDraftMerchantDetails: async (email: string, dealShortCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('submitDraftMerchantDetails', 'email', email)
            const localVarPath = `/v1/draft-merchants/details/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit draft merchant site
         * @summary Submit draft merchant site
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDraftMerchantSite: async (email: string, dealShortCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('submitDraftMerchantSite', 'email', email)
            const localVarPath = `/v1/draft-merchants/site/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer a Customer to another user - Staff only
         * @summary Transfer a Customer to another user - Staff only
         * @param {string} merchantId ID of the customer
         * @param {TransferMerchantRequest} transferMerchantRequest Update settings of a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferMerchant: async (merchantId: string, transferMerchantRequest: TransferMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('transferMerchant', 'merchantId', merchantId)
            // verify required parameter 'transferMerchantRequest' is not null or undefined
            assertParamExists('transferMerchant', 'transferMerchantRequest', transferMerchantRequest)
            const localVarPath = `/v1/merchants/{merchantId}/transfer`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a transfer to the balance account\'s assigned transfer instrument
         * @summary Trigger a transfer to the balance account\'s assigned transfer instrument
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {TriggerTransferRequest} triggerTransferRequest Trigger a transfer to the balance account\&#39;s assigned transfer instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerTransfer: async (merchantId: string, siteId: string, triggerTransferRequest: TriggerTransferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('triggerTransfer', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('triggerTransfer', 'siteId', siteId)
            // verify required parameter 'triggerTransferRequest' is not null or undefined
            assertParamExists('triggerTransfer', 'triggerTransferRequest', triggerTransferRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/transfers/trigger`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(triggerTransferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update device settings
         * @summary Update device settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} deviceId ID of the device
         * @param {UpdateDeviceRequest} updateDeviceRequest Update device parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevice: async (merchantId: string, siteId: string, deviceId: string, updateDeviceRequest: UpdateDeviceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateDevice', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateDevice', 'siteId', siteId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('updateDevice', 'deviceId', deviceId)
            // verify required parameter 'updateDeviceRequest' is not null or undefined
            assertParamExists('updateDevice', 'updateDeviceRequest', updateDeviceRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/devices/{deviceId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a draft merchant
         * @summary Update a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {UpdateDraftMerchantDetails} [updateDraftMerchantDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftMerchantDetails: async (email: string, dealShortCode?: string, updateDraftMerchantDetails?: UpdateDraftMerchantDetails, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateDraftMerchantDetails', 'email', email)
            const localVarPath = `/v1/draft-merchants/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDraftMerchantDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a draft merchant with site details
         * @summary Update a draft merchant with site details
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {UpdateDraftMerchantSite} [updateDraftMerchantSite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftMerchantSite: async (email: string, dealShortCode?: string, updateDraftMerchantSite?: UpdateDraftMerchantSite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateDraftMerchantSite', 'email', email)
            const localVarPath = `/v1/draft-merchants/site`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (dealShortCode !== undefined) {
                localVarQueryParameter['dealShortCode'] = dealShortCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDraftMerchantSite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a merchant
         * @summary Update a merchant
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantRequest} updateMerchantRequest Update merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchant: async (merchantId: string, updateMerchantRequest: UpdateMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchant', 'merchantId', merchantId)
            // verify required parameter 'updateMerchantRequest' is not null or undefined
            assertParamExists('updateMerchant', 'updateMerchantRequest', updateMerchantRequest)
            const localVarPath = `/v1/merchants/{merchantId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update internal merchant settings
         * @summary Update internal merchant settings
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantInternalSettingsRequest} updateMerchantInternalSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantInternalSettings: async (merchantId: string, updateMerchantInternalSettingsRequest: UpdateMerchantInternalSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchantInternalSettings', 'merchantId', merchantId)
            // verify required parameter 'updateMerchantInternalSettingsRequest' is not null or undefined
            assertParamExists('updateMerchantInternalSettings', 'updateMerchantInternalSettingsRequest', updateMerchantInternalSettingsRequest)
            const localVarPath = `/v1/merchants/{merchantId}/internal-settings`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantInternalSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update merchant settings
         * @summary Update merchant settings
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantSettingsRequest} updateMerchantSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantSettings: async (merchantId: string, updateMerchantSettingsRequest: UpdateMerchantSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchantSettings', 'merchantId', merchantId)
            // verify required parameter 'updateMerchantSettingsRequest' is not null or undefined
            assertParamExists('updateMerchantSettings', 'updateMerchantSettingsRequest', updateMerchantSettingsRequest)
            const localVarPath = `/v1/merchants/{merchantId}/settings`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the passcodes for all devices at a site
         * @summary Update the passcodes for all devices at a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteDevicesPasscodes: async (merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteDevicesPasscodes', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteDevicesPasscodes', 'siteId', siteId)
            // verify required parameter 'updateSiteDevicesPasscodesRequest' is not null or undefined
            assertParamExists('updateSiteDevicesPasscodes', 'updateSiteDevicesPasscodesRequest', updateSiteDevicesPasscodesRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/passcodes`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSiteDevicesPasscodesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the receipt printing behavior for a specific site
         * @summary Update receipt printing config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteReceiptConfig: async (merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteReceiptConfig', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteReceiptConfig', 'siteId', siteId)
            // verify required parameter 'updateSiteReceiptConfigRequest' is not null or undefined
            assertParamExists('updateSiteReceiptConfig', 'updateSiteReceiptConfigRequest', updateSiteReceiptConfigRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/receipts`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSiteReceiptConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing site\'s settings by Id
         * @summary Update an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {SiteInternalSettings} siteInternalSettings Update settings of a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteSettings: async (merchantId: string, siteId: string, siteInternalSettings: SiteInternalSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteSettings', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteSettings', 'siteId', siteId)
            // verify required parameter 'siteInternalSettings' is not null or undefined
            assertParamExists('updateSiteSettings', 'siteInternalSettings', siteInternalSettings)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/internal`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteInternalSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update tips configuration for a site
         * @summary Update tips configuration for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {Tips} tips Tips configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteTips: async (merchantId: string, siteId: string, tips: Tips, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteTips', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteTips', 'siteId', siteId)
            // verify required parameter 'tips' is not null or undefined
            assertParamExists('updateSiteTips', 'tips', tips)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/tips`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tips, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing site\'s payment method
         * @summary Update an existing site\'s payment method
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} paymentMethodId ID of the payment method
         * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSitesPaymentMethod: async (merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'siteId', siteId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'paymentMethodId', paymentMethodId)
            // verify required parameter 'updateSitesPaymentMethodRequest' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'updateSitesPaymentMethodRequest', updateSitesPaymentMethodRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/payment-methods/{paymentMethodId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSitesPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing site\'s sweep
         * @summary Update an existing site\'s sweep
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} sweepId ID of the sweep
         * @param {UpdateSweepSettingsRequest} updateSweepSettingsRequest Updated settings of a sweep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSweepSettings: async (merchantId: string, siteId: string, sweepId: string, updateSweepSettingsRequest: UpdateSweepSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSweepSettings', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSweepSettings', 'siteId', siteId)
            // verify required parameter 'sweepId' is not null or undefined
            assertParamExists('updateSweepSettings', 'sweepId', sweepId)
            // verify required parameter 'updateSweepSettingsRequest' is not null or undefined
            assertParamExists('updateSweepSettings', 'updateSweepSettingsRequest', updateSweepSettingsRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/internal/sweeps/{sweepId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)))
                .replace(`{${"sweepId"}}`, encodeURIComponent(String(sweepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSweepSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user
         * @summary Update user
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {UpdateUserRequest} updateUserRequest Update user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (merchantId: string, userId: string, updateUserRequest: UpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateUser', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BasecampApi - functional programming interface
 * @export
 */
export const BasecampApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BasecampApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new credit grant to a deal
         * @summary Add a new credit grant to a deal
         * @param {string} merchantId ID of the customer
         * @param {Credit} credit Credit grant to add to a deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCreditGrant(merchantId: string, credit: Credit, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCreditGrant(merchantId, credit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.addCreditGrant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a push token
         * @summary Add a push token
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPushToken(merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPushToken(merchantId, userId, addPushTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.addPushToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new payment method to a site
         * @summary Add a new payment method to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSitesPaymentMethod(merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSitesPaymentMethod(merchantId, siteId, addSitesPaymentMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.addSitesPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new device to a site
         * @summary Add a new device to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDevice(merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignDevice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDevice(merchantId, siteId, assignDeviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.assignDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Associate a deal\'s rate to a merchant
         * @summary Associate a deal\'s rate to a merchant
         * @param {string} merchantId ID of the customer
         * @param {string} dealReference Reference of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async associateRates(merchantId: string, dealReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.associateRates(merchantId, dealReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.associateRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Block a merchant
         * @summary Block a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockMerchant(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockMerchant(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.blockMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a session for adyen capital
         * @summary Create a session for adyen capital
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCapitalSession(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCapitalSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCapitalSession(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createCapitalSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a draft merchant
         * @summary Create a draft merchant
         * @param {CreateDraftMerchantRequest} [createDraftMerchantRequest] Create draft merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftMerchant(createDraftMerchantRequest?: CreateDraftMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftMerchant(createDraftMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createDraftMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates an invite token for a draft merchant and sends an email to the recipient
         * @summary Create an invite token for a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {CreateDraftMerchantInviteTokenRequest} [createDraftMerchantInviteTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftMerchantInviteToken(email: string, dealShortCode?: string, createDraftMerchantInviteTokenRequest?: CreateDraftMerchantInviteTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDraftMerchantInviteToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftMerchantInviteToken(email, dealShortCode, createDraftMerchantInviteTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createDraftMerchantInviteToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create EOD report
         * @summary Create EOD report
         * @param {string} merchantId ID of the customer
         * @param {CreateEODReportRequest} createEODReportRequest Site ID to scope the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEODReport(merchantId: string, createEODReportRequest: CreateEODReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EODReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEODReport(merchantId, createEODReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createEODReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a report
         * @summary Create a report
         * @param {string} merchantId ID of the customer
         * @param {CreateReportRequest} createReportRequest Create report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReport(merchantId: string, createReportRequest: CreateReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReport201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReport(merchantId, createReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a transaction
         * @summary Create a transaction placeholder
         * @param {string} merchantId ID of the customer
         * @param {CreateTransactionRequest} createTransactionRequest Create transaction body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransaction(merchantId: string, createTransactionRequest: CreateTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransaction(merchantId, createTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create and send a transaction receipt
         * @summary Create and send a transaction receipt
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Receipt params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransactionReceipt(merchantId: string, pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransactionReceipt(merchantId, pspReference, createTransactionReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createTransactionReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a hosted onboarding verification link for a merchant\'s onboarding process
         * @summary Create a hosted onboarding verification link for a merchant
         * @param {string} merchantId ID of the customer
         * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVerificationLink(merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateVerificationLink200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVerificationLink(merchantId, createVerificationLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.createVerificationLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a merchant
         * @summary Deactivate a merchant
         * @param {string} merchantId ID of the customer
         * @param {DeactivateMerchantStageEnum} stage Stage of deactivation, allowing to report an action or effectively deactivate a customer
         * @param {DeactivateMerchantRequest} deactivateMerchantRequest Deactivate merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateMerchant(merchantId: string, stage: DeactivateMerchantStageEnum, deactivateMerchantRequest: DeactivateMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateMerchant(merchantId, stage, deactivateMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.deactivateMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set default payment method
         * @summary Set default payment method
         * @param {string} merchantId ID of the customer
         * @param {string} paymentMethodId ID of the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defaultPaymentMethod(merchantId: string, paymentMethodId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defaultPaymentMethod(merchantId, paymentMethodId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.defaultPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a payment method
         * @summary Delete a payment method
         * @param {string} merchantId ID of the customer
         * @param {string} paymentMethodId ID of the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentMethod(merchantId: string, paymentMethodId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentMethod(merchantId, paymentMethodId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.deletePaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a push token
         * @summary Delete a push token
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePushToken(merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePushToken(merchantId, userId, addPushTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.deletePushToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete user
         * @summary Delete a user
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(merchantId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(merchantId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an invoice
         * @summary Download an invoice
         * @param {string} merchantId ID of the customer
         * @param {string} invoiceNumber Number / ID of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadInvoice(merchantId: string, invoiceNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DownloadInvoice200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadInvoice(merchantId, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.downloadInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a report
         * @summary Download a report
         * @param {string} merchantId ID of the customer
         * @param {string} reportId ID of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadReport(merchantId: string, reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadReport200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReport(merchantId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.downloadReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit draft merchant details
         * @summary Update a merchant email during onboarding
         * @param {DraftMerchantEmailRequest} draftMerchantEmailRequest 
         * @param {string} [email] Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {string} [inviteToken] Token from the invite email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async draftMerchantEmail(draftMerchantEmailRequest: DraftMerchantEmailRequest, email?: string, dealShortCode?: string, inviteToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.draftMerchantEmail(draftMerchantEmailRequest, email, dealShortCode, inviteToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.draftMerchantEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Email a receipt for a refund
         * @summary Email a receipt for a refund
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {EmailRefundReceiptRequest} emailRefundReceiptRequest Referenced refund additional parameters to send email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailRefundReceipt(merchantId: string, pspReference: string, emailRefundReceiptRequest: EmailRefundReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailRefundReceipt(merchantId, pspReference, emailRefundReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.emailRefundReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch device settings
         * @summary Fetch device settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} deviceId ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchDevice(merchantId: string, siteId: string, deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchDevice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDevice(merchantId, siteId, deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.fetchDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the receipt printing preferences configured for a specific site
         * @summary Fetch receipt config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchSiteReceiptConfig(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSiteReceiptConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchSiteReceiptConfig(merchantId, siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.fetchSiteReceiptConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a draft merchant
         * @summary Get a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftMerchant(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftMerchant(email, dealShortCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getDraftMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available industries
         * @summary List all available industries
         * @param {string} [email] Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndustries(email?: string, dealShortCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIndustries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndustries(email, dealShortCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getIndustries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate and return a user hash for intercom user verification based on the user ID and platform.
         * @summary Retrieve a user hash for intercom user verification
         * @param {GetIntercomUserHashPlatformEnum} platform The platform for which the user hash is being requested.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntercomUserHash(platform: GetIntercomUserHashPlatformEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIntercomUserHash200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntercomUserHash(platform, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getIntercomUserHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a merchant
         * @summary Get a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchant(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Merchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchant(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get draft merchant from invite
         * @summary Get draft merchant from invite
         * @param {string} inviteToken Token from the invite email
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingInvite(inviteToken: string, dealShortCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingInvite(inviteToken, dealShortCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getOnboardingInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an existing site\'s settings by Id
         * @summary Get an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteSettings(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSiteSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteSettings(merchantId, siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getSiteSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get transaction totals for a time period
         * @summary Get transaction totals for a time period
         * @param {string} merchantId ID of the customer
         * @param {string} siteId Scope transactions by site
         * @param {string} startDate Start date for the time period (24-hour range)
         * @param {string} [type] Search by transaction type
         * @param {GetTransactionTotalsPaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionTotals(merchantId: string, siteId: string, startDate: string, type?: string, paymentSource?: GetTransactionTotalsPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionTotals200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionTotals(merchantId, siteId, startDate, type, paymentSource, paymentMethods, amounts, statuses, cardSummary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getTransactionTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user
         * @summary Get user details
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(merchantId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(merchantId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite user
         * @summary Invite user
         * @param {string} merchantId ID of the customer
         * @param {InviteUserRequest} inviteUserRequest Invite user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(merchantId: string, inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(merchantId, inviteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List EOD reports
         * @summary List EOD reports
         * @param {string} merchantId ID of the customer
         * @param {string} [siteId] Scope reports by site
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [dates] Date range for report (Comma separates start and end date)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEODReports(merchantId: string, siteId?: string, lastKey?: string, dates?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEODReports200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEODReports(merchantId, siteId, lastKey, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listEODReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [createdBetween] Search invoices created between dates in timestamp format
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoices(merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInvoices200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoices(merchantId, lastKey, createdBetween, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [year] Year to fetch invoices for. Default is current year
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoicesV2(merchantId: string, year?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInvoicesV2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoicesV2(merchantId, year, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listInvoicesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all merchants associated with the requesting user.
         * @summary Get merchants for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchants(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMerchants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchants(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listMerchants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List payment links for a set of link id
         * @summary List payment links for a set of link id
         * @param {string} merchantId ID of the customer
         * @param {string} linkIds Link ids to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPaymentLinks(merchantId: string, linkIds: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPaymentLinks(merchantId, linkIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listPaymentLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List reports
         * @summary List reports
         * @param {string} merchantId ID of the customer
         * @param {string} [siteId] Scope reports by site
         * @param {ListReportsTypeEnum} [type] Type of report to list
         * @param {string} [lastKey] Pagination parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReports(merchantId: string, siteId?: string, type?: ListReportsTypeEnum, lastKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReports200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReports(merchantId, siteId, type, lastKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all sites for a merchant
         * @summary List all sites for a merchant
         * @param {string} merchantId ID of the customer
         * @param {boolean} [includeConfig] Include extended site configuration information
         * @param {boolean} [all] Deprecated. No-op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSites(merchantId: string, includeConfig?: boolean, all?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSites200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSites(merchantId, includeConfig, all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listSites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List transactions from a merchant
         * @summary List transactions of a merchant
         * @param {string} merchantId ID of the customer
         * @param {string} [type] Search by transaction type
         * @param {ListTransactionPaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {string} [dates] Date range for transactions (Comma separates start and end date)
         * @param {string} [psp] Search transactions by PSP
         * @param {string} [siteId] Search by site
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [countOnly] Returns the number of pages, and no items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransaction(merchantId: string, type?: string, paymentSource?: ListTransactionPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, dates?: string, psp?: string, siteId?: string, lastKey?: string, countOnly?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTransaction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransaction(merchantId, type, paymentSource, paymentMethods, amounts, statuses, cardSummary, dates, psp, siteId, lastKey, countOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List users
         * @summary List users
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get rates for a merchant
         * @summary Get rates for a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantGetRates(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DealRates>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantGetRates(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.merchantGetRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update rates for a merchant
         * @summary Update rates for a merchant
         * @param {string} merchantId ID of the customer
         * @param {MerchantUpdateRatesRequest} merchantUpdateRatesRequest Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantUpdateRates(merchantId: string, merchantUpdateRatesRequest: MerchantUpdateRatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantUpdateRates(merchantId, merchantUpdateRatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.merchantUpdateRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle merchant user events
         * @summary Handle merchant user events
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {MerchantUserEventsRequest} merchantUserEventsRequest Event body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantUserEvents(merchantId: string, userId: string, merchantUserEventsRequest: MerchantUserEventsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantUserEvents(merchantId, userId, merchantUserEventsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.merchantUserEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch site
         * @summary Patch site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {PatchSiteRequest} patchSiteRequest Update site details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSite(merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSite(merchantId, siteId, patchSiteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.patchSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for merchants
         * @summary Search for merchants
         * @param {string} [name] Partial name of customer
         * @param {string} [accountHolderId] Account holder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryMerchants(name?: string, accountHolderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryMerchants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryMerchants(name, accountHolderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.queryMerchants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refund a transaction
         * @summary Refund a transaction
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundTransaction(merchantId: string, pspReference: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundTransaction(merchantId, pspReference, refundTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.refundTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset user password
         * @summary Reset user password
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(merchantId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(merchantId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.resetUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate and return a session token to transfer access and id tokens
         * @summary Create a token for session transfer
         * @param {SessionTransferCreateTokenRequest} sessionTransferCreateTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionTransferCreateToken(sessionTransferCreateTokenRequest: SessionTransferCreateTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionTransferCreateToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionTransferCreateToken(sessionTransferCreateTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.sessionTransferCreateToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the Cognito credentials associated with a session transfer token.
         * @summary Exchange session token for access and id tokens
         * @param {SessionTransferExchangeTokenRequest} sessionTransferExchangeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionTransferExchangeToken(sessionTransferExchangeTokenRequest: SessionTransferExchangeTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionTransferExchangeToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionTransferExchangeToken(sessionTransferExchangeTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.sessionTransferExchangeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit draft merchant details
         * @summary Submit draft merchant details
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitDraftMerchantDetails(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitDraftMerchantDetails(email, dealShortCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.submitDraftMerchantDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit draft merchant site
         * @summary Submit draft merchant site
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitDraftMerchantSite(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitDraftMerchantSite(email, dealShortCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.submitDraftMerchantSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transfer a Customer to another user - Staff only
         * @summary Transfer a Customer to another user - Staff only
         * @param {string} merchantId ID of the customer
         * @param {TransferMerchantRequest} transferMerchantRequest Update settings of a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferMerchant(merchantId: string, transferMerchantRequest: TransferMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferMerchant(merchantId, transferMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.transferMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger a transfer to the balance account\'s assigned transfer instrument
         * @summary Trigger a transfer to the balance account\'s assigned transfer instrument
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {TriggerTransferRequest} triggerTransferRequest Trigger a transfer to the balance account\&#39;s assigned transfer instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerTransfer(merchantId: string, siteId: string, triggerTransferRequest: TriggerTransferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerTransfer(merchantId, siteId, triggerTransferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.triggerTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update device settings
         * @summary Update device settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} deviceId ID of the device
         * @param {UpdateDeviceRequest} updateDeviceRequest Update device parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevice(merchantId: string, siteId: string, deviceId: string, updateDeviceRequest: UpdateDeviceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevice(merchantId, siteId, deviceId, updateDeviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a draft merchant
         * @summary Update a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {UpdateDraftMerchantDetails} [updateDraftMerchantDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDraftMerchantDetails(email: string, dealShortCode?: string, updateDraftMerchantDetails?: UpdateDraftMerchantDetails, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDraftMerchantDetails(email, dealShortCode, updateDraftMerchantDetails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateDraftMerchantDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a draft merchant with site details
         * @summary Update a draft merchant with site details
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {UpdateDraftMerchantSite} [updateDraftMerchantSite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDraftMerchantSite(email: string, dealShortCode?: string, updateDraftMerchantSite?: UpdateDraftMerchantSite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftMerchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDraftMerchantSite(email, dealShortCode, updateDraftMerchantSite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateDraftMerchantSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a merchant
         * @summary Update a merchant
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantRequest} updateMerchantRequest Update merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchant(merchantId: string, updateMerchantRequest: UpdateMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchant(merchantId, updateMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update internal merchant settings
         * @summary Update internal merchant settings
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantInternalSettingsRequest} updateMerchantInternalSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantInternalSettings(merchantId: string, updateMerchantInternalSettingsRequest: UpdateMerchantInternalSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantInternalSettings(merchantId, updateMerchantInternalSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateMerchantInternalSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update merchant settings
         * @summary Update merchant settings
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantSettingsRequest} updateMerchantSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantSettings(merchantId: string, updateMerchantSettingsRequest: UpdateMerchantSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantSettings(merchantId, updateMerchantSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateMerchantSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the passcodes for all devices at a site
         * @summary Update the passcodes for all devices at a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteDevicesPasscodes(merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSiteDevicesPasscodes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteDevicesPasscodes(merchantId, siteId, updateSiteDevicesPasscodesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateSiteDevicesPasscodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify the receipt printing behavior for a specific site
         * @summary Update receipt printing config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteReceiptConfig(merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSiteReceiptConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteReceiptConfig(merchantId, siteId, updateSiteReceiptConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateSiteReceiptConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing site\'s settings by Id
         * @summary Update an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {SiteInternalSettings} siteInternalSettings Update settings of a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteSettings(merchantId: string, siteId: string, siteInternalSettings: SiteInternalSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteSettings(merchantId, siteId, siteInternalSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateSiteSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update tips configuration for a site
         * @summary Update tips configuration for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {Tips} tips Tips configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteTips(merchantId: string, siteId: string, tips: Tips, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteTips(merchantId, siteId, tips, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateSiteTips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing site\'s payment method
         * @summary Update an existing site\'s payment method
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} paymentMethodId ID of the payment method
         * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSitesPaymentMethod(merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSitesPaymentMethod(merchantId, siteId, paymentMethodId, updateSitesPaymentMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateSitesPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing site\'s sweep
         * @summary Update an existing site\'s sweep
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} sweepId ID of the sweep
         * @param {UpdateSweepSettingsRequest} updateSweepSettingsRequest Updated settings of a sweep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSweepSettings(merchantId: string, siteId: string, sweepId: string, updateSweepSettingsRequest: UpdateSweepSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSweepSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSweepSettings(merchantId, siteId, sweepId, updateSweepSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateSweepSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user
         * @summary Update user
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {UpdateUserRequest} updateUserRequest Update user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(merchantId: string, userId: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(merchantId, userId, updateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BasecampApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BasecampApi - factory interface
 * @export
 */
export const BasecampApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BasecampApiFp(configuration)
    return {
        /**
         * Add a new credit grant to a deal
         * @summary Add a new credit grant to a deal
         * @param {string} merchantId ID of the customer
         * @param {Credit} credit Credit grant to add to a deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCreditGrant(merchantId: string, credit: Credit, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCreditGrant(merchantId, credit, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a push token
         * @summary Add a push token
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPushToken(merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addPushToken(merchantId, userId, addPushTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new payment method to a site
         * @summary Add a new payment method to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSitesPaymentMethod(merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSitesPaymentMethod(merchantId, siteId, addSitesPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new device to a site
         * @summary Add a new device to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice(merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignDevice200Response> {
            return localVarFp.assignDevice(merchantId, siteId, assignDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Associate a deal\'s rate to a merchant
         * @summary Associate a deal\'s rate to a merchant
         * @param {string} merchantId ID of the customer
         * @param {string} dealReference Reference of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateRates(merchantId: string, dealReference: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.associateRates(merchantId, dealReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Block a merchant
         * @summary Block a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockMerchant(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.blockMerchant(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a session for adyen capital
         * @summary Create a session for adyen capital
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCapitalSession(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateCapitalSession200Response> {
            return localVarFp.createCapitalSession(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a draft merchant
         * @summary Create a draft merchant
         * @param {CreateDraftMerchantRequest} [createDraftMerchantRequest] Create draft merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftMerchant(createDraftMerchantRequest?: CreateDraftMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.createDraftMerchant(createDraftMerchantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an invite token for a draft merchant and sends an email to the recipient
         * @summary Create an invite token for a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {CreateDraftMerchantInviteTokenRequest} [createDraftMerchantInviteTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftMerchantInviteToken(email: string, dealShortCode?: string, createDraftMerchantInviteTokenRequest?: CreateDraftMerchantInviteTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDraftMerchantInviteToken200Response> {
            return localVarFp.createDraftMerchantInviteToken(email, dealShortCode, createDraftMerchantInviteTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create EOD report
         * @summary Create EOD report
         * @param {string} merchantId ID of the customer
         * @param {CreateEODReportRequest} createEODReportRequest Site ID to scope the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEODReport(merchantId: string, createEODReportRequest: CreateEODReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<EODReport> {
            return localVarFp.createEODReport(merchantId, createEODReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a report
         * @summary Create a report
         * @param {string} merchantId ID of the customer
         * @param {CreateReportRequest} createReportRequest Create report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(merchantId: string, createReportRequest: CreateReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateReport201Response> {
            return localVarFp.createReport(merchantId, createReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a transaction
         * @summary Create a transaction placeholder
         * @param {string} merchantId ID of the customer
         * @param {CreateTransactionRequest} createTransactionRequest Create transaction body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction(merchantId: string, createTransactionRequest: CreateTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTransaction(merchantId, createTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create and send a transaction receipt
         * @summary Create and send a transaction receipt
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Receipt params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransactionReceipt(merchantId: string, pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTransactionReceipt(merchantId, pspReference, createTransactionReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a hosted onboarding verification link for a merchant\'s onboarding process
         * @summary Create a hosted onboarding verification link for a merchant
         * @param {string} merchantId ID of the customer
         * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationLink(merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateVerificationLink200Response> {
            return localVarFp.createVerificationLink(merchantId, createVerificationLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a merchant
         * @summary Deactivate a merchant
         * @param {string} merchantId ID of the customer
         * @param {DeactivateMerchantStageEnum} stage Stage of deactivation, allowing to report an action or effectively deactivate a customer
         * @param {DeactivateMerchantRequest} deactivateMerchantRequest Deactivate merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateMerchant(merchantId: string, stage: DeactivateMerchantStageEnum, deactivateMerchantRequest: DeactivateMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateMerchant(merchantId, stage, deactivateMerchantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set default payment method
         * @summary Set default payment method
         * @param {string} merchantId ID of the customer
         * @param {string} paymentMethodId ID of the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultPaymentMethod(merchantId: string, paymentMethodId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.defaultPaymentMethod(merchantId, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a payment method
         * @summary Delete a payment method
         * @param {string} merchantId ID of the customer
         * @param {string} paymentMethodId ID of the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod(merchantId: string, paymentMethodId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentMethod(merchantId, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a push token
         * @summary Delete a push token
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushToken(merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePushToken(merchantId, userId, addPushTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete user
         * @summary Delete a user
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(merchantId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(merchantId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an invoice
         * @summary Download an invoice
         * @param {string} merchantId ID of the customer
         * @param {string} invoiceNumber Number / ID of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice(merchantId: string, invoiceNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DownloadInvoice200ResponseInner>> {
            return localVarFp.downloadInvoice(merchantId, invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a report
         * @summary Download a report
         * @param {string} merchantId ID of the customer
         * @param {string} reportId ID of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport(merchantId: string, reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<DownloadReport200Response> {
            return localVarFp.downloadReport(merchantId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit draft merchant details
         * @summary Update a merchant email during onboarding
         * @param {DraftMerchantEmailRequest} draftMerchantEmailRequest 
         * @param {string} [email] Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {string} [inviteToken] Token from the invite email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        draftMerchantEmail(draftMerchantEmailRequest: DraftMerchantEmailRequest, email?: string, dealShortCode?: string, inviteToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.draftMerchantEmail(draftMerchantEmailRequest, email, dealShortCode, inviteToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Email a receipt for a refund
         * @summary Email a receipt for a refund
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {EmailRefundReceiptRequest} emailRefundReceiptRequest Referenced refund additional parameters to send email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRefundReceipt(merchantId: string, pspReference: string, emailRefundReceiptRequest: EmailRefundReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emailRefundReceipt(merchantId, pspReference, emailRefundReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch device settings
         * @summary Fetch device settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} deviceId ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDevice(merchantId: string, siteId: string, deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchDevice200Response> {
            return localVarFp.fetchDevice(merchantId, siteId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the receipt printing preferences configured for a specific site
         * @summary Fetch receipt config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSiteReceiptConfig(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchSiteReceiptConfig200Response> {
            return localVarFp.fetchSiteReceiptConfig(merchantId, siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a draft merchant
         * @summary Get a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftMerchant(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.getDraftMerchant(email, dealShortCode, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available industries
         * @summary List all available industries
         * @param {string} [email] Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndustries(email?: string, dealShortCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetIndustries200Response> {
            return localVarFp.getIndustries(email, dealShortCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate and return a user hash for intercom user verification based on the user ID and platform.
         * @summary Retrieve a user hash for intercom user verification
         * @param {GetIntercomUserHashPlatformEnum} platform The platform for which the user hash is being requested.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntercomUserHash(platform: GetIntercomUserHashPlatformEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetIntercomUserHash200Response> {
            return localVarFp.getIntercomUserHash(platform, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a merchant
         * @summary Get a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchant(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<Merchant> {
            return localVarFp.getMerchant(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get draft merchant from invite
         * @summary Get draft merchant from invite
         * @param {string} inviteToken Token from the invite email
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingInvite(inviteToken: string, dealShortCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.getOnboardingInvite(inviteToken, dealShortCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an existing site\'s settings by Id
         * @summary Get an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteSettings(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSiteSettings200Response> {
            return localVarFp.getSiteSettings(merchantId, siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction totals for a time period
         * @summary Get transaction totals for a time period
         * @param {string} merchantId ID of the customer
         * @param {string} siteId Scope transactions by site
         * @param {string} startDate Start date for the time period (24-hour range)
         * @param {string} [type] Search by transaction type
         * @param {GetTransactionTotalsPaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionTotals(merchantId: string, siteId: string, startDate: string, type?: string, paymentSource?: GetTransactionTotalsPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTransactionTotals200Response> {
            return localVarFp.getTransactionTotals(merchantId, siteId, startDate, type, paymentSource, paymentMethods, amounts, statuses, cardSummary, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user
         * @summary Get user details
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(merchantId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.getUser(merchantId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite user
         * @summary Invite user
         * @param {string} merchantId ID of the customer
         * @param {InviteUserRequest} inviteUserRequest Invite user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(merchantId: string, inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inviteUser(merchantId, inviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List EOD reports
         * @summary List EOD reports
         * @param {string} merchantId ID of the customer
         * @param {string} [siteId] Scope reports by site
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [dates] Date range for report (Comma separates start and end date)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEODReports(merchantId: string, siteId?: string, lastKey?: string, dates?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListEODReports200Response> {
            return localVarFp.listEODReports(merchantId, siteId, lastKey, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [createdBetween] Search invoices created between dates in timestamp format
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices(merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListInvoices200Response> {
            return localVarFp.listInvoices(merchantId, lastKey, createdBetween, invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [year] Year to fetch invoices for. Default is current year
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoicesV2(merchantId: string, year?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListInvoicesV2200Response> {
            return localVarFp.listInvoicesV2(merchantId, year, invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all merchants associated with the requesting user.
         * @summary Get merchants for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchants(options?: RawAxiosRequestConfig): AxiosPromise<ListMerchants200Response> {
            return localVarFp.listMerchants(options).then((request) => request(axios, basePath));
        },
        /**
         * List payment links for a set of link id
         * @summary List payment links for a set of link id
         * @param {string} merchantId ID of the customer
         * @param {string} linkIds Link ids to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPaymentLinks(merchantId: string, linkIds: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentLink>> {
            return localVarFp.listPaymentLinks(merchantId, linkIds, options).then((request) => request(axios, basePath));
        },
        /**
         * List reports
         * @summary List reports
         * @param {string} merchantId ID of the customer
         * @param {string} [siteId] Scope reports by site
         * @param {ListReportsTypeEnum} [type] Type of report to list
         * @param {string} [lastKey] Pagination parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports(merchantId: string, siteId?: string, type?: ListReportsTypeEnum, lastKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListReports200Response> {
            return localVarFp.listReports(merchantId, siteId, type, lastKey, options).then((request) => request(axios, basePath));
        },
        /**
         * List all sites for a merchant
         * @summary List all sites for a merchant
         * @param {string} merchantId ID of the customer
         * @param {boolean} [includeConfig] Include extended site configuration information
         * @param {boolean} [all] Deprecated. No-op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSites(merchantId: string, includeConfig?: boolean, all?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ListSites200Response> {
            return localVarFp.listSites(merchantId, includeConfig, all, options).then((request) => request(axios, basePath));
        },
        /**
         * List transactions from a merchant
         * @summary List transactions of a merchant
         * @param {string} merchantId ID of the customer
         * @param {string} [type] Search by transaction type
         * @param {ListTransactionPaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {string} [dates] Date range for transactions (Comma separates start and end date)
         * @param {string} [psp] Search transactions by PSP
         * @param {string} [siteId] Search by site
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [countOnly] Returns the number of pages, and no items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransaction(merchantId: string, type?: string, paymentSource?: ListTransactionPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, dates?: string, psp?: string, siteId?: string, lastKey?: string, countOnly?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListTransaction200Response> {
            return localVarFp.listTransaction(merchantId, type, paymentSource, paymentMethods, amounts, statuses, cardSummary, dates, psp, siteId, lastKey, countOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * List users
         * @summary List users
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.listUsers(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get rates for a merchant
         * @summary Get rates for a merchant
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetRates(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<DealRates> {
            return localVarFp.merchantGetRates(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update rates for a merchant
         * @summary Update rates for a merchant
         * @param {string} merchantId ID of the customer
         * @param {MerchantUpdateRatesRequest} merchantUpdateRatesRequest Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantUpdateRates(merchantId: string, merchantUpdateRatesRequest: MerchantUpdateRatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.merchantUpdateRates(merchantId, merchantUpdateRatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle merchant user events
         * @summary Handle merchant user events
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {MerchantUserEventsRequest} merchantUserEventsRequest Event body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantUserEvents(merchantId: string, userId: string, merchantUserEventsRequest: MerchantUserEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.merchantUserEvents(merchantId, userId, merchantUserEventsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch site
         * @summary Patch site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {PatchSiteRequest} patchSiteRequest Update site details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSite(merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchSite(merchantId, siteId, patchSiteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for merchants
         * @summary Search for merchants
         * @param {string} [name] Partial name of customer
         * @param {string} [accountHolderId] Account holder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryMerchants(name?: string, accountHolderId?: string, options?: RawAxiosRequestConfig): AxiosPromise<QueryMerchants200Response> {
            return localVarFp.queryMerchants(name, accountHolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Refund a transaction
         * @summary Refund a transaction
         * @param {string} merchantId ID of the customer
         * @param {string} pspReference The psp reference
         * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundTransaction(merchantId: string, pspReference: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErrorResponse> {
            return localVarFp.refundTransaction(merchantId, pspReference, refundTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset user password
         * @summary Reset user password
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(merchantId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetUserPassword(merchantId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate and return a session token to transfer access and id tokens
         * @summary Create a token for session transfer
         * @param {SessionTransferCreateTokenRequest} sessionTransferCreateTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionTransferCreateToken(sessionTransferCreateTokenRequest: SessionTransferCreateTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionTransferCreateToken200Response> {
            return localVarFp.sessionTransferCreateToken(sessionTransferCreateTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the Cognito credentials associated with a session transfer token.
         * @summary Exchange session token for access and id tokens
         * @param {SessionTransferExchangeTokenRequest} sessionTransferExchangeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionTransferExchangeToken(sessionTransferExchangeTokenRequest: SessionTransferExchangeTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionTransferExchangeToken200Response> {
            return localVarFp.sessionTransferExchangeToken(sessionTransferExchangeTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit draft merchant details
         * @summary Submit draft merchant details
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDraftMerchantDetails(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.submitDraftMerchantDetails(email, dealShortCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit draft merchant site
         * @summary Submit draft merchant site
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDraftMerchantSite(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.submitDraftMerchantSite(email, dealShortCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer a Customer to another user - Staff only
         * @summary Transfer a Customer to another user - Staff only
         * @param {string} merchantId ID of the customer
         * @param {TransferMerchantRequest} transferMerchantRequest Update settings of a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferMerchant(merchantId: string, transferMerchantRequest: TransferMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.transferMerchant(merchantId, transferMerchantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a transfer to the balance account\'s assigned transfer instrument
         * @summary Trigger a transfer to the balance account\'s assigned transfer instrument
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {TriggerTransferRequest} triggerTransferRequest Trigger a transfer to the balance account\&#39;s assigned transfer instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerTransfer(merchantId: string, siteId: string, triggerTransferRequest: TriggerTransferRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.triggerTransfer(merchantId, siteId, triggerTransferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update device settings
         * @summary Update device settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} deviceId ID of the device
         * @param {UpdateDeviceRequest} updateDeviceRequest Update device parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevice(merchantId: string, siteId: string, deviceId: string, updateDeviceRequest: UpdateDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDevice(merchantId, siteId, deviceId, updateDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a draft merchant
         * @summary Update a draft merchant
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {UpdateDraftMerchantDetails} [updateDraftMerchantDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftMerchantDetails(email: string, dealShortCode?: string, updateDraftMerchantDetails?: UpdateDraftMerchantDetails, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.updateDraftMerchantDetails(email, dealShortCode, updateDraftMerchantDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a draft merchant with site details
         * @summary Update a draft merchant with site details
         * @param {string} email Email of the draft merchant
         * @param {string} [dealShortCode] Short code of the deal
         * @param {UpdateDraftMerchantSite} [updateDraftMerchantSite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftMerchantSite(email: string, dealShortCode?: string, updateDraftMerchantSite?: UpdateDraftMerchantSite, options?: RawAxiosRequestConfig): AxiosPromise<DraftMerchant> {
            return localVarFp.updateDraftMerchantSite(email, dealShortCode, updateDraftMerchantSite, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a merchant
         * @summary Update a merchant
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantRequest} updateMerchantRequest Update merchant parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchant(merchantId: string, updateMerchantRequest: UpdateMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchant(merchantId, updateMerchantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update internal merchant settings
         * @summary Update internal merchant settings
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantInternalSettingsRequest} updateMerchantInternalSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantInternalSettings(merchantId: string, updateMerchantInternalSettingsRequest: UpdateMerchantInternalSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantInternalSettings(merchantId, updateMerchantInternalSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update merchant settings
         * @summary Update merchant settings
         * @param {string} merchantId ID of the customer
         * @param {UpdateMerchantSettingsRequest} updateMerchantSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantSettings(merchantId: string, updateMerchantSettingsRequest: UpdateMerchantSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantSettings(merchantId, updateMerchantSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the passcodes for all devices at a site
         * @summary Update the passcodes for all devices at a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteDevicesPasscodes(merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSiteDevicesPasscodes200Response> {
            return localVarFp.updateSiteDevicesPasscodes(merchantId, siteId, updateSiteDevicesPasscodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify the receipt printing behavior for a specific site
         * @summary Update receipt printing config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteReceiptConfig(merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<FetchSiteReceiptConfig200Response> {
            return localVarFp.updateSiteReceiptConfig(merchantId, siteId, updateSiteReceiptConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing site\'s settings by Id
         * @summary Update an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {SiteInternalSettings} siteInternalSettings Update settings of a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteSettings(merchantId: string, siteId: string, siteInternalSettings: SiteInternalSettings, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSiteSettings(merchantId, siteId, siteInternalSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Update tips configuration for a site
         * @summary Update tips configuration for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {Tips} tips Tips configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteTips(merchantId: string, siteId: string, tips: Tips, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSiteTips(merchantId, siteId, tips, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing site\'s payment method
         * @summary Update an existing site\'s payment method
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} paymentMethodId ID of the payment method
         * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSitesPaymentMethod(merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSitesPaymentMethod(merchantId, siteId, paymentMethodId, updateSitesPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing site\'s sweep
         * @summary Update an existing site\'s sweep
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} sweepId ID of the sweep
         * @param {UpdateSweepSettingsRequest} updateSweepSettingsRequest Updated settings of a sweep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSweepSettings(merchantId: string, siteId: string, sweepId: string, updateSweepSettingsRequest: UpdateSweepSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSweepSettings200Response> {
            return localVarFp.updateSweepSettings(merchantId, siteId, sweepId, updateSweepSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user
         * @summary Update user
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {UpdateUserRequest} updateUserRequest Update user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(merchantId: string, userId: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUser(merchantId, userId, updateUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BasecampApi - object-oriented interface
 * @export
 * @class BasecampApi
 * @extends {BaseAPI}
 */
export class BasecampApi extends BaseAPI {
    /**
     * Add a new credit grant to a deal
     * @summary Add a new credit grant to a deal
     * @param {string} merchantId ID of the customer
     * @param {Credit} credit Credit grant to add to a deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public addCreditGrant(merchantId: string, credit: Credit, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).addCreditGrant(merchantId, credit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a push token
     * @summary Add a push token
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public addPushToken(merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).addPushToken(merchantId, userId, addPushTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new payment method to a site
     * @summary Add a new payment method to a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public addSitesPaymentMethod(merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).addSitesPaymentMethod(merchantId, siteId, addSitesPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new device to a site
     * @summary Add a new device to a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public assignDevice(merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).assignDevice(merchantId, siteId, assignDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Associate a deal\'s rate to a merchant
     * @summary Associate a deal\'s rate to a merchant
     * @param {string} merchantId ID of the customer
     * @param {string} dealReference Reference of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public associateRates(merchantId: string, dealReference: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).associateRates(merchantId, dealReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Block a merchant
     * @summary Block a merchant
     * @param {string} merchantId ID of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public blockMerchant(merchantId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).blockMerchant(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a session for adyen capital
     * @summary Create a session for adyen capital
     * @param {string} merchantId ID of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createCapitalSession(merchantId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createCapitalSession(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a draft merchant
     * @summary Create a draft merchant
     * @param {CreateDraftMerchantRequest} [createDraftMerchantRequest] Create draft merchant parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createDraftMerchant(createDraftMerchantRequest?: CreateDraftMerchantRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createDraftMerchant(createDraftMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an invite token for a draft merchant and sends an email to the recipient
     * @summary Create an invite token for a draft merchant
     * @param {string} email Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {CreateDraftMerchantInviteTokenRequest} [createDraftMerchantInviteTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createDraftMerchantInviteToken(email: string, dealShortCode?: string, createDraftMerchantInviteTokenRequest?: CreateDraftMerchantInviteTokenRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createDraftMerchantInviteToken(email, dealShortCode, createDraftMerchantInviteTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create EOD report
     * @summary Create EOD report
     * @param {string} merchantId ID of the customer
     * @param {CreateEODReportRequest} createEODReportRequest Site ID to scope the report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createEODReport(merchantId: string, createEODReportRequest: CreateEODReportRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createEODReport(merchantId, createEODReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a report
     * @summary Create a report
     * @param {string} merchantId ID of the customer
     * @param {CreateReportRequest} createReportRequest Create report parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createReport(merchantId: string, createReportRequest: CreateReportRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createReport(merchantId, createReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a transaction
     * @summary Create a transaction placeholder
     * @param {string} merchantId ID of the customer
     * @param {CreateTransactionRequest} createTransactionRequest Create transaction body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createTransaction(merchantId: string, createTransactionRequest: CreateTransactionRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createTransaction(merchantId, createTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create and send a transaction receipt
     * @summary Create and send a transaction receipt
     * @param {string} merchantId ID of the customer
     * @param {string} pspReference The psp reference
     * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Receipt params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createTransactionReceipt(merchantId: string, pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createTransactionReceipt(merchantId, pspReference, createTransactionReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a hosted onboarding verification link for a merchant\'s onboarding process
     * @summary Create a hosted onboarding verification link for a merchant
     * @param {string} merchantId ID of the customer
     * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public createVerificationLink(merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).createVerificationLink(merchantId, createVerificationLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a merchant
     * @summary Deactivate a merchant
     * @param {string} merchantId ID of the customer
     * @param {DeactivateMerchantStageEnum} stage Stage of deactivation, allowing to report an action or effectively deactivate a customer
     * @param {DeactivateMerchantRequest} deactivateMerchantRequest Deactivate merchant parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public deactivateMerchant(merchantId: string, stage: DeactivateMerchantStageEnum, deactivateMerchantRequest: DeactivateMerchantRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).deactivateMerchant(merchantId, stage, deactivateMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set default payment method
     * @summary Set default payment method
     * @param {string} merchantId ID of the customer
     * @param {string} paymentMethodId ID of the payment method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public defaultPaymentMethod(merchantId: string, paymentMethodId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).defaultPaymentMethod(merchantId, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a payment method
     * @summary Delete a payment method
     * @param {string} merchantId ID of the customer
     * @param {string} paymentMethodId ID of the payment method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public deletePaymentMethod(merchantId: string, paymentMethodId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).deletePaymentMethod(merchantId, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a push token
     * @summary Delete a push token
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {AddPushTokenRequest} addPushTokenRequest Add push token parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public deletePushToken(merchantId: string, userId: string, addPushTokenRequest: AddPushTokenRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).deletePushToken(merchantId, userId, addPushTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete user
     * @summary Delete a user
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public deleteUser(merchantId: string, userId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).deleteUser(merchantId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an invoice
     * @summary Download an invoice
     * @param {string} merchantId ID of the customer
     * @param {string} invoiceNumber Number / ID of the invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public downloadInvoice(merchantId: string, invoiceNumber: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).downloadInvoice(merchantId, invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a report
     * @summary Download a report
     * @param {string} merchantId ID of the customer
     * @param {string} reportId ID of the report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public downloadReport(merchantId: string, reportId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).downloadReport(merchantId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit draft merchant details
     * @summary Update a merchant email during onboarding
     * @param {DraftMerchantEmailRequest} draftMerchantEmailRequest 
     * @param {string} [email] Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {string} [inviteToken] Token from the invite email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public draftMerchantEmail(draftMerchantEmailRequest: DraftMerchantEmailRequest, email?: string, dealShortCode?: string, inviteToken?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).draftMerchantEmail(draftMerchantEmailRequest, email, dealShortCode, inviteToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Email a receipt for a refund
     * @summary Email a receipt for a refund
     * @param {string} merchantId ID of the customer
     * @param {string} pspReference The psp reference
     * @param {EmailRefundReceiptRequest} emailRefundReceiptRequest Referenced refund additional parameters to send email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public emailRefundReceipt(merchantId: string, pspReference: string, emailRefundReceiptRequest: EmailRefundReceiptRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).emailRefundReceipt(merchantId, pspReference, emailRefundReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch device settings
     * @summary Fetch device settings
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {string} deviceId ID of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public fetchDevice(merchantId: string, siteId: string, deviceId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).fetchDevice(merchantId, siteId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the receipt printing preferences configured for a specific site
     * @summary Fetch receipt config for a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public fetchSiteReceiptConfig(merchantId: string, siteId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).fetchSiteReceiptConfig(merchantId, siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a draft merchant
     * @summary Get a draft merchant
     * @param {string} email Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getDraftMerchant(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getDraftMerchant(email, dealShortCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available industries
     * @summary List all available industries
     * @param {string} [email] Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getIndustries(email?: string, dealShortCode?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getIndustries(email, dealShortCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate and return a user hash for intercom user verification based on the user ID and platform.
     * @summary Retrieve a user hash for intercom user verification
     * @param {GetIntercomUserHashPlatformEnum} platform The platform for which the user hash is being requested.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getIntercomUserHash(platform: GetIntercomUserHashPlatformEnum, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getIntercomUserHash(platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a merchant
     * @summary Get a merchant
     * @param {string} merchantId ID of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getMerchant(merchantId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getMerchant(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get draft merchant from invite
     * @summary Get draft merchant from invite
     * @param {string} inviteToken Token from the invite email
     * @param {string} [dealShortCode] Short code of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getOnboardingInvite(inviteToken: string, dealShortCode?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getOnboardingInvite(inviteToken, dealShortCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an existing site\'s settings by Id
     * @summary Get an existing site\'s internal settings
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getSiteSettings(merchantId: string, siteId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getSiteSettings(merchantId, siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get transaction totals for a time period
     * @summary Get transaction totals for a time period
     * @param {string} merchantId ID of the customer
     * @param {string} siteId Scope transactions by site
     * @param {string} startDate Start date for the time period (24-hour range)
     * @param {string} [type] Search by transaction type
     * @param {GetTransactionTotalsPaymentSourceEnum} [paymentSource] Search by payment source
     * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
     * @param {string} [amounts] Search transactions amounts (exact or between) in pence
     * @param {string} [statuses] Search transactions by status (comma separated)
     * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getTransactionTotals(merchantId: string, siteId: string, startDate: string, type?: string, paymentSource?: GetTransactionTotalsPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getTransactionTotals(merchantId, siteId, startDate, type, paymentSource, paymentMethods, amounts, statuses, cardSummary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user
     * @summary Get user details
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public getUser(merchantId: string, userId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).getUser(merchantId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite user
     * @summary Invite user
     * @param {string} merchantId ID of the customer
     * @param {InviteUserRequest} inviteUserRequest Invite user parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public inviteUser(merchantId: string, inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).inviteUser(merchantId, inviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List EOD reports
     * @summary List EOD reports
     * @param {string} merchantId ID of the customer
     * @param {string} [siteId] Scope reports by site
     * @param {string} [lastKey] Pagination parameter
     * @param {string} [dates] Date range for report (Comma separates start and end date)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listEODReports(merchantId: string, siteId?: string, lastKey?: string, dates?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listEODReports(merchantId, siteId, lastKey, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List invoices
     * @summary List invoices
     * @param {string} merchantId ID of the customer
     * @param {string} [lastKey] Pagination parameter
     * @param {string} [createdBetween] Search invoices created between dates in timestamp format
     * @param {string} [invoiceNumber] Search invoices by invoice number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listInvoices(merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listInvoices(merchantId, lastKey, createdBetween, invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List invoices
     * @summary List invoices
     * @param {string} merchantId ID of the customer
     * @param {string} [year] Year to fetch invoices for. Default is current year
     * @param {string} [invoiceNumber] Search invoices by invoice number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listInvoicesV2(merchantId: string, year?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listInvoicesV2(merchantId, year, invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all merchants associated with the requesting user.
     * @summary Get merchants for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listMerchants(options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listMerchants(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List payment links for a set of link id
     * @summary List payment links for a set of link id
     * @param {string} merchantId ID of the customer
     * @param {string} linkIds Link ids to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listPaymentLinks(merchantId: string, linkIds: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listPaymentLinks(merchantId, linkIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List reports
     * @summary List reports
     * @param {string} merchantId ID of the customer
     * @param {string} [siteId] Scope reports by site
     * @param {ListReportsTypeEnum} [type] Type of report to list
     * @param {string} [lastKey] Pagination parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listReports(merchantId: string, siteId?: string, type?: ListReportsTypeEnum, lastKey?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listReports(merchantId, siteId, type, lastKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all sites for a merchant
     * @summary List all sites for a merchant
     * @param {string} merchantId ID of the customer
     * @param {boolean} [includeConfig] Include extended site configuration information
     * @param {boolean} [all] Deprecated. No-op.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listSites(merchantId: string, includeConfig?: boolean, all?: boolean, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listSites(merchantId, includeConfig, all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List transactions from a merchant
     * @summary List transactions of a merchant
     * @param {string} merchantId ID of the customer
     * @param {string} [type] Search by transaction type
     * @param {ListTransactionPaymentSourceEnum} [paymentSource] Search by payment source
     * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
     * @param {string} [amounts] Search transactions amounts (exact or between) in pence
     * @param {string} [statuses] Search transactions by status (comma separated)
     * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
     * @param {string} [dates] Date range for transactions (Comma separates start and end date)
     * @param {string} [psp] Search transactions by PSP
     * @param {string} [siteId] Search by site
     * @param {string} [lastKey] Pagination parameter
     * @param {string} [countOnly] Returns the number of pages, and no items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listTransaction(merchantId: string, type?: string, paymentSource?: ListTransactionPaymentSourceEnum, paymentMethods?: string, amounts?: string, statuses?: string, cardSummary?: string, dates?: string, psp?: string, siteId?: string, lastKey?: string, countOnly?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listTransaction(merchantId, type, paymentSource, paymentMethods, amounts, statuses, cardSummary, dates, psp, siteId, lastKey, countOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List users
     * @summary List users
     * @param {string} merchantId ID of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public listUsers(merchantId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).listUsers(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get rates for a merchant
     * @summary Get rates for a merchant
     * @param {string} merchantId ID of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public merchantGetRates(merchantId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).merchantGetRates(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update rates for a merchant
     * @summary Update rates for a merchant
     * @param {string} merchantId ID of the customer
     * @param {MerchantUpdateRatesRequest} merchantUpdateRatesRequest Rates to save from an existing deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public merchantUpdateRates(merchantId: string, merchantUpdateRatesRequest: MerchantUpdateRatesRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).merchantUpdateRates(merchantId, merchantUpdateRatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle merchant user events
     * @summary Handle merchant user events
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {MerchantUserEventsRequest} merchantUserEventsRequest Event body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public merchantUserEvents(merchantId: string, userId: string, merchantUserEventsRequest: MerchantUserEventsRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).merchantUserEvents(merchantId, userId, merchantUserEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch site
     * @summary Patch site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {PatchSiteRequest} patchSiteRequest Update site details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public patchSite(merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).patchSite(merchantId, siteId, patchSiteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for merchants
     * @summary Search for merchants
     * @param {string} [name] Partial name of customer
     * @param {string} [accountHolderId] Account holder ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public queryMerchants(name?: string, accountHolderId?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).queryMerchants(name, accountHolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refund a transaction
     * @summary Refund a transaction
     * @param {string} merchantId ID of the customer
     * @param {string} pspReference The psp reference
     * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public refundTransaction(merchantId: string, pspReference: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).refundTransaction(merchantId, pspReference, refundTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset user password
     * @summary Reset user password
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public resetUserPassword(merchantId: string, userId: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).resetUserPassword(merchantId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate and return a session token to transfer access and id tokens
     * @summary Create a token for session transfer
     * @param {SessionTransferCreateTokenRequest} sessionTransferCreateTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public sessionTransferCreateToken(sessionTransferCreateTokenRequest: SessionTransferCreateTokenRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).sessionTransferCreateToken(sessionTransferCreateTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the Cognito credentials associated with a session transfer token.
     * @summary Exchange session token for access and id tokens
     * @param {SessionTransferExchangeTokenRequest} sessionTransferExchangeTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public sessionTransferExchangeToken(sessionTransferExchangeTokenRequest: SessionTransferExchangeTokenRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).sessionTransferExchangeToken(sessionTransferExchangeTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit draft merchant details
     * @summary Submit draft merchant details
     * @param {string} email Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public submitDraftMerchantDetails(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).submitDraftMerchantDetails(email, dealShortCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit draft merchant site
     * @summary Submit draft merchant site
     * @param {string} email Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public submitDraftMerchantSite(email: string, dealShortCode?: string, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).submitDraftMerchantSite(email, dealShortCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer a Customer to another user - Staff only
     * @summary Transfer a Customer to another user - Staff only
     * @param {string} merchantId ID of the customer
     * @param {TransferMerchantRequest} transferMerchantRequest Update settings of a site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public transferMerchant(merchantId: string, transferMerchantRequest: TransferMerchantRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).transferMerchant(merchantId, transferMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger a transfer to the balance account\'s assigned transfer instrument
     * @summary Trigger a transfer to the balance account\'s assigned transfer instrument
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {TriggerTransferRequest} triggerTransferRequest Trigger a transfer to the balance account\&#39;s assigned transfer instrument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public triggerTransfer(merchantId: string, siteId: string, triggerTransferRequest: TriggerTransferRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).triggerTransfer(merchantId, siteId, triggerTransferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update device settings
     * @summary Update device settings
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {string} deviceId ID of the device
     * @param {UpdateDeviceRequest} updateDeviceRequest Update device parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateDevice(merchantId: string, siteId: string, deviceId: string, updateDeviceRequest: UpdateDeviceRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateDevice(merchantId, siteId, deviceId, updateDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a draft merchant
     * @summary Update a draft merchant
     * @param {string} email Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {UpdateDraftMerchantDetails} [updateDraftMerchantDetails] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateDraftMerchantDetails(email: string, dealShortCode?: string, updateDraftMerchantDetails?: UpdateDraftMerchantDetails, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateDraftMerchantDetails(email, dealShortCode, updateDraftMerchantDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a draft merchant with site details
     * @summary Update a draft merchant with site details
     * @param {string} email Email of the draft merchant
     * @param {string} [dealShortCode] Short code of the deal
     * @param {UpdateDraftMerchantSite} [updateDraftMerchantSite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateDraftMerchantSite(email: string, dealShortCode?: string, updateDraftMerchantSite?: UpdateDraftMerchantSite, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateDraftMerchantSite(email, dealShortCode, updateDraftMerchantSite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a merchant
     * @summary Update a merchant
     * @param {string} merchantId ID of the customer
     * @param {UpdateMerchantRequest} updateMerchantRequest Update merchant parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateMerchant(merchantId: string, updateMerchantRequest: UpdateMerchantRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateMerchant(merchantId, updateMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update internal merchant settings
     * @summary Update internal merchant settings
     * @param {string} merchantId ID of the customer
     * @param {UpdateMerchantInternalSettingsRequest} updateMerchantInternalSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateMerchantInternalSettings(merchantId: string, updateMerchantInternalSettingsRequest: UpdateMerchantInternalSettingsRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateMerchantInternalSettings(merchantId, updateMerchantInternalSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update merchant settings
     * @summary Update merchant settings
     * @param {string} merchantId ID of the customer
     * @param {UpdateMerchantSettingsRequest} updateMerchantSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateMerchantSettings(merchantId: string, updateMerchantSettingsRequest: UpdateMerchantSettingsRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateMerchantSettings(merchantId, updateMerchantSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the passcodes for all devices at a site
     * @summary Update the passcodes for all devices at a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateSiteDevicesPasscodes(merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateSiteDevicesPasscodes(merchantId, siteId, updateSiteDevicesPasscodesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify the receipt printing behavior for a specific site
     * @summary Update receipt printing config for a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateSiteReceiptConfig(merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateSiteReceiptConfig(merchantId, siteId, updateSiteReceiptConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing site\'s settings by Id
     * @summary Update an existing site\'s internal settings
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {SiteInternalSettings} siteInternalSettings Update settings of a site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateSiteSettings(merchantId: string, siteId: string, siteInternalSettings: SiteInternalSettings, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateSiteSettings(merchantId, siteId, siteInternalSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update tips configuration for a site
     * @summary Update tips configuration for a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {Tips} tips Tips configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateSiteTips(merchantId: string, siteId: string, tips: Tips, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateSiteTips(merchantId, siteId, tips, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing site\'s payment method
     * @summary Update an existing site\'s payment method
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {string} paymentMethodId ID of the payment method
     * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateSitesPaymentMethod(merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateSitesPaymentMethod(merchantId, siteId, paymentMethodId, updateSitesPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing site\'s sweep
     * @summary Update an existing site\'s sweep
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {string} sweepId ID of the sweep
     * @param {UpdateSweepSettingsRequest} updateSweepSettingsRequest Updated settings of a sweep
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateSweepSettings(merchantId: string, siteId: string, sweepId: string, updateSweepSettingsRequest: UpdateSweepSettingsRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateSweepSettings(merchantId, siteId, sweepId, updateSweepSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user
     * @summary Update user
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {UpdateUserRequest} updateUserRequest Update user parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasecampApi
     */
    public updateUser(merchantId: string, userId: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig) {
        return BasecampApiFp(this.configuration).updateUser(merchantId, userId, updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeactivateMerchantStageEnum = {
    InContract: 'in-contract',
    Init: 'init',
    Complete: 'complete'
} as const;
export type DeactivateMerchantStageEnum = typeof DeactivateMerchantStageEnum[keyof typeof DeactivateMerchantStageEnum];
/**
 * @export
 */
export const GetIntercomUserHashPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Web: 'web'
} as const;
export type GetIntercomUserHashPlatformEnum = typeof GetIntercomUserHashPlatformEnum[keyof typeof GetIntercomUserHashPlatformEnum];
/**
 * @export
 */
export const GetTransactionTotalsPaymentSourceEnum = {
    AdyenTerminal: 'adyen-terminal',
    PayByLink: 'pay-by-link',
    TapToPay: 'tap-to-pay'
} as const;
export type GetTransactionTotalsPaymentSourceEnum = typeof GetTransactionTotalsPaymentSourceEnum[keyof typeof GetTransactionTotalsPaymentSourceEnum];
/**
 * @export
 */
export const ListReportsTypeEnum = {
    Transactions: 'transactions',
    Payouts: 'payouts',
    PayoutDetail: 'payout-detail'
} as const;
export type ListReportsTypeEnum = typeof ListReportsTypeEnum[keyof typeof ListReportsTypeEnum];
/**
 * @export
 */
export const ListTransactionPaymentSourceEnum = {
    AdyenTerminal: 'adyen-terminal',
    PayByLink: 'pay-by-link',
    TapToPay: 'tap-to-pay'
} as const;
export type ListTransactionPaymentSourceEnum = typeof ListTransactionPaymentSourceEnum[keyof typeof ListTransactionPaymentSourceEnum];


/**
 * CompanionAppApi - axios parameter creator
 * @export
 */
export const CompanionAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a mobile pos session from Adyen and forward it
         * @summary Create a mobile pos session
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {CreateMobilePosSessionRequest} createMobilePosSessionRequest Pass the mobile setup token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMobilePosSession: async (merchantId: string, siteId: string, createMobilePosSessionRequest: CreateMobilePosSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createMobilePosSession', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('createMobilePosSession', 'siteId', siteId)
            // verify required parameter 'createMobilePosSessionRequest' is not null or undefined
            assertParamExists('createMobilePosSession', 'createMobilePosSessionRequest', createMobilePosSessionRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/mobile-pos-session`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMobilePosSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanionAppApi - functional programming interface
 * @export
 */
export const CompanionAppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanionAppApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a mobile pos session from Adyen and forward it
         * @summary Create a mobile pos session
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {CreateMobilePosSessionRequest} createMobilePosSessionRequest Pass the mobile setup token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMobilePosSession(merchantId: string, siteId: string, createMobilePosSessionRequest: CreateMobilePosSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMobilePosSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMobilePosSession(merchantId, siteId, createMobilePosSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanionAppApi.createMobilePosSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanionAppApi - factory interface
 * @export
 */
export const CompanionAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanionAppApiFp(configuration)
    return {
        /**
         * Create a mobile pos session from Adyen and forward it
         * @summary Create a mobile pos session
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {CreateMobilePosSessionRequest} createMobilePosSessionRequest Pass the mobile setup token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMobilePosSession(merchantId: string, siteId: string, createMobilePosSessionRequest: CreateMobilePosSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMobilePosSession200Response> {
            return localVarFp.createMobilePosSession(merchantId, siteId, createMobilePosSessionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanionAppApi - object-oriented interface
 * @export
 * @class CompanionAppApi
 * @extends {BaseAPI}
 */
export class CompanionAppApi extends BaseAPI {
    /**
     * Create a mobile pos session from Adyen and forward it
     * @summary Create a mobile pos session
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {CreateMobilePosSessionRequest} createMobilePosSessionRequest Pass the mobile setup token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanionAppApi
     */
    public createMobilePosSession(merchantId: string, siteId: string, createMobilePosSessionRequest: CreateMobilePosSessionRequest, options?: RawAxiosRequestConfig) {
        return CompanionAppApiFp(this.configuration).createMobilePosSession(merchantId, siteId, createMobilePosSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevicesApi - axios parameter creator
 * @export
 */
export const DevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a details for account from the site\'s associated EPOS
         * @summary Fetch a details for account from the site\'s associated EPOS
         * @param {string} accountId Epos account identifier
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPullFetchAccountDetails: async (accountId: string, waiterId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('connectPullFetchAccountDetails', 'accountId', accountId)
            const localVarPath = `/v1/devices/connect-pull/accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (waiterId !== undefined) {
                localVarQueryParameter['waiterId'] = waiterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of open accounts for the site\'s associated EPOS
         * @summary Fetch a list of open accounts for the site\'s associated EPOS
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPullFetchOpenAccounts: async (waiterId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/devices/connect-pull/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (waiterId !== undefined) {
                localVarQueryParameter['waiterId'] = waiterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record a payment against an account within the sites associated EPOS
         * @summary Record a payment against an account within the sites associated EPOS
         * @param {string} accountId Epos account identifier
         * @param {EposRecordPaymentRequest} eposRecordPaymentRequest Record payment request body
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPullRecordPayment: async (accountId: string, eposRecordPaymentRequest: EposRecordPaymentRequest, waiterId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('connectPullRecordPayment', 'accountId', accountId)
            // verify required parameter 'eposRecordPaymentRequest' is not null or undefined
            assertParamExists('connectPullRecordPayment', 'eposRecordPaymentRequest', eposRecordPaymentRequest)
            const localVarPath = `/v1/devices/connect-pull/accounts/{accountId}/payments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (waiterId !== undefined) {
                localVarQueryParameter['waiterId'] = waiterId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eposRecordPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a transaction from devices
         * @summary Create a transaction from devices
         * @param {CreateTransactionDeviceRequest} createTransactionDeviceRequest Transaction placeholder additional data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransactionDevice: async (createTransactionDeviceRequest: CreateTransactionDeviceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTransactionDeviceRequest' is not null or undefined
            assertParamExists('createTransactionDevice', 'createTransactionDeviceRequest', createTransactionDeviceRequest)
            const localVarPath = `/v1/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send an email of refund a transaction from devices
         * @summary Send an email of refund a transaction from devices
         * @param {string} pspReference The psp reference
         * @param {EmailRefundTransactionDevicesRequest} emailRefundTransactionDevicesRequest Email refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRefundTransactionDevices: async (pspReference: string, emailRefundTransactionDevicesRequest: EmailRefundTransactionDevicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('emailRefundTransactionDevices', 'pspReference', pspReference)
            // verify required parameter 'emailRefundTransactionDevicesRequest' is not null or undefined
            assertParamExists('emailRefundTransactionDevices', 'emailRefundTransactionDevicesRequest', emailRefundTransactionDevicesRequest)
            const localVarPath = `/v1/transactions/{pspReference}/refunds/receipt`
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailRefundTransactionDevicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns device and store configuration for current authenticated device
         * @summary Fetch device config
         * @param {string} device Device ID for current authenticated device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDeviceConfig: async (device: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'device' is not null or undefined
            assertParamExists('fetchDeviceConfig', 'device', device)
            const localVarPath = `/v1/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (device !== undefined) {
                localVarQueryParameter['device'] = device;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a bill from devices
         * @summary Get a bill from devices
         * @param {string} pspReference The psp reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDevice: async (pspReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('getBillDevice', 'pspReference', pspReference)
            const localVarPath = `/v1/bills/{pspReference}`
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List bills from devices
         * @summary List bills from devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillsDevice: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List transactions from devices
         * @summary List transactions from devices
         * @param {string} [dates] Date range for transactions
         * @param {string} [psp] Search transactions by PSP
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {string} [type] Search by transaction type
         * @param {ListTransactionDevicePaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [countOnly] Returns the number of pages, and no items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactionDevice: async (dates?: string, psp?: string, amounts?: string, statuses?: string, cardSummary?: string, type?: string, paymentSource?: ListTransactionDevicePaymentSourceEnum, paymentMethods?: string, lastKey?: string, countOnly?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dates !== undefined) {
                localVarQueryParameter['dates'] = dates;
            }

            if (psp !== undefined) {
                localVarQueryParameter['psp'] = psp;
            }

            if (amounts !== undefined) {
                localVarQueryParameter['amounts'] = amounts;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (cardSummary !== undefined) {
                localVarQueryParameter['cardSummary'] = cardSummary;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (paymentSource !== undefined) {
                localVarQueryParameter['paymentSource'] = paymentSource;
            }

            if (paymentMethods !== undefined) {
                localVarQueryParameter['paymentMethods'] = paymentMethods;
            }

            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }

            if (countOnly !== undefined) {
                localVarQueryParameter['countOnly'] = countOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refund a transaction from devices
         * @summary Refund a transaction from devices
         * @param {string} pspReference The psp reference
         * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundTransactionDevices: async (pspReference: string, refundTransactionRequest: RefundTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('refundTransactionDevices', 'pspReference', pspReference)
            // verify required parameter 'refundTransactionRequest' is not null or undefined
            assertParamExists('refundTransactionDevices', 'refundTransactionRequest', refundTransactionRequest)
            const localVarPath = `/v1/transactions/{pspReference}/refunds`
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a transaction receipt and email it
         * @summary Create a transaction receipt and email it
         * @param {string} pspReference The psp reference
         * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Transaction receipt params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionReceiptDevices: async (pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pspReference' is not null or undefined
            assertParamExists('transactionReceiptDevices', 'pspReference', pspReference)
            // verify required parameter 'createTransactionReceiptRequest' is not null or undefined
            assertParamExists('transactionReceiptDevices', 'createTransactionReceiptRequest', createTransactionReceiptRequest)
            const localVarPath = `/v1/transactions/{pspReference}/receipt`
                .replace(`{${"pspReference"}}`, encodeURIComponent(String(pspReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevicesApi - functional programming interface
 * @export
 */
export const DevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a details for account from the site\'s associated EPOS
         * @summary Fetch a details for account from the site\'s associated EPOS
         * @param {string} accountId Epos account identifier
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectPullFetchAccountDetails(accountId: string, waiterId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EposAccountDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectPullFetchAccountDetails(accountId, waiterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.connectPullFetchAccountDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a list of open accounts for the site\'s associated EPOS
         * @summary Fetch a list of open accounts for the site\'s associated EPOS
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectPullFetchOpenAccounts(waiterId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenEposAccounts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectPullFetchOpenAccounts(waiterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.connectPullFetchOpenAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Record a payment against an account within the sites associated EPOS
         * @summary Record a payment against an account within the sites associated EPOS
         * @param {string} accountId Epos account identifier
         * @param {EposRecordPaymentRequest} eposRecordPaymentRequest Record payment request body
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectPullRecordPayment(accountId: string, eposRecordPaymentRequest: EposRecordPaymentRequest, waiterId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectPullRecordPayment(accountId, eposRecordPaymentRequest, waiterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.connectPullRecordPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a transaction from devices
         * @summary Create a transaction from devices
         * @param {CreateTransactionDeviceRequest} createTransactionDeviceRequest Transaction placeholder additional data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransactionDevice(createTransactionDeviceRequest: CreateTransactionDeviceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransactionDevice(createTransactionDeviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.createTransactionDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send an email of refund a transaction from devices
         * @summary Send an email of refund a transaction from devices
         * @param {string} pspReference The psp reference
         * @param {EmailRefundTransactionDevicesRequest} emailRefundTransactionDevicesRequest Email refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailRefundTransactionDevices(pspReference: string, emailRefundTransactionDevicesRequest: EmailRefundTransactionDevicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailRefundTransactionDevices(pspReference, emailRefundTransactionDevicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.emailRefundTransactionDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns device and store configuration for current authenticated device
         * @summary Fetch device config
         * @param {string} device Device ID for current authenticated device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchDeviceConfig(device: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDeviceConfig(device, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.fetchDeviceConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a bill from devices
         * @summary Get a bill from devices
         * @param {string} pspReference The psp reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillDevice(pspReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Bill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillDevice(pspReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.getBillDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List bills from devices
         * @summary List bills from devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBillsDevice(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetsBillsDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBillsDevice(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.listBillsDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List transactions from devices
         * @summary List transactions from devices
         * @param {string} [dates] Date range for transactions
         * @param {string} [psp] Search transactions by PSP
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {string} [type] Search by transaction type
         * @param {ListTransactionDevicePaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [countOnly] Returns the number of pages, and no items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransactionDevice(dates?: string, psp?: string, amounts?: string, statuses?: string, cardSummary?: string, type?: string, paymentSource?: ListTransactionDevicePaymentSourceEnum, paymentMethods?: string, lastKey?: string, countOnly?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetsTransactionsDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransactionDevice(dates, psp, amounts, statuses, cardSummary, type, paymentSource, paymentMethods, lastKey, countOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.listTransactionDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refund a transaction from devices
         * @summary Refund a transaction from devices
         * @param {string} pspReference The psp reference
         * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundTransactionDevices(pspReference: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundTransactionDevices(pspReference, refundTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.refundTransactionDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a transaction receipt and email it
         * @summary Create a transaction receipt and email it
         * @param {string} pspReference The psp reference
         * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Transaction receipt params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionReceiptDevices(pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionReceiptDevices(pspReference, createTransactionReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevicesApi.transactionReceiptDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevicesApi - factory interface
 * @export
 */
export const DevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevicesApiFp(configuration)
    return {
        /**
         * Fetch a details for account from the site\'s associated EPOS
         * @summary Fetch a details for account from the site\'s associated EPOS
         * @param {string} accountId Epos account identifier
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPullFetchAccountDetails(accountId: string, waiterId?: string, options?: RawAxiosRequestConfig): AxiosPromise<EposAccountDetails> {
            return localVarFp.connectPullFetchAccountDetails(accountId, waiterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a list of open accounts for the site\'s associated EPOS
         * @summary Fetch a list of open accounts for the site\'s associated EPOS
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPullFetchOpenAccounts(waiterId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OpenEposAccounts> {
            return localVarFp.connectPullFetchOpenAccounts(waiterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Record a payment against an account within the sites associated EPOS
         * @summary Record a payment against an account within the sites associated EPOS
         * @param {string} accountId Epos account identifier
         * @param {EposRecordPaymentRequest} eposRecordPaymentRequest Record payment request body
         * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPullRecordPayment(accountId: string, eposRecordPaymentRequest: EposRecordPaymentRequest, waiterId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.connectPullRecordPayment(accountId, eposRecordPaymentRequest, waiterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a transaction from devices
         * @summary Create a transaction from devices
         * @param {CreateTransactionDeviceRequest} createTransactionDeviceRequest Transaction placeholder additional data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransactionDevice(createTransactionDeviceRequest: CreateTransactionDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTransactionDevice(createTransactionDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send an email of refund a transaction from devices
         * @summary Send an email of refund a transaction from devices
         * @param {string} pspReference The psp reference
         * @param {EmailRefundTransactionDevicesRequest} emailRefundTransactionDevicesRequest Email refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRefundTransactionDevices(pspReference: string, emailRefundTransactionDevicesRequest: EmailRefundTransactionDevicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emailRefundTransactionDevices(pspReference, emailRefundTransactionDevicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns device and store configuration for current authenticated device
         * @summary Fetch device config
         * @param {string} device Device ID for current authenticated device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDeviceConfig(device: string, options?: RawAxiosRequestConfig): AxiosPromise<DeviceConfig> {
            return localVarFp.fetchDeviceConfig(device, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a bill from devices
         * @summary Get a bill from devices
         * @param {string} pspReference The psp reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDevice(pspReference: string, options?: RawAxiosRequestConfig): AxiosPromise<Bill> {
            return localVarFp.getBillDevice(pspReference, options).then((request) => request(axios, basePath));
        },
        /**
         * List bills from devices
         * @summary List bills from devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillsDevice(options?: RawAxiosRequestConfig): AxiosPromise<GetsBillsDeviceResponse> {
            return localVarFp.listBillsDevice(options).then((request) => request(axios, basePath));
        },
        /**
         * List transactions from devices
         * @summary List transactions from devices
         * @param {string} [dates] Date range for transactions
         * @param {string} [psp] Search transactions by PSP
         * @param {string} [amounts] Search transactions amounts (exact or between) in pence
         * @param {string} [statuses] Search transactions by status (comma separated)
         * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
         * @param {string} [type] Search by transaction type
         * @param {ListTransactionDevicePaymentSourceEnum} [paymentSource] Search by payment source
         * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [countOnly] Returns the number of pages, and no items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactionDevice(dates?: string, psp?: string, amounts?: string, statuses?: string, cardSummary?: string, type?: string, paymentSource?: ListTransactionDevicePaymentSourceEnum, paymentMethods?: string, lastKey?: string, countOnly?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetsTransactionsDeviceResponse> {
            return localVarFp.listTransactionDevice(dates, psp, amounts, statuses, cardSummary, type, paymentSource, paymentMethods, lastKey, countOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Refund a transaction from devices
         * @summary Refund a transaction from devices
         * @param {string} pspReference The psp reference
         * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundTransactionDevices(pspReference: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErrorResponse> {
            return localVarFp.refundTransactionDevices(pspReference, refundTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a transaction receipt and email it
         * @summary Create a transaction receipt and email it
         * @param {string} pspReference The psp reference
         * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Transaction receipt params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionReceiptDevices(pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErrorResponse> {
            return localVarFp.transactionReceiptDevices(pspReference, createTransactionReceiptRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
export class DevicesApi extends BaseAPI {
    /**
     * Fetch a details for account from the site\'s associated EPOS
     * @summary Fetch a details for account from the site\'s associated EPOS
     * @param {string} accountId Epos account identifier
     * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public connectPullFetchAccountDetails(accountId: string, waiterId?: string, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).connectPullFetchAccountDetails(accountId, waiterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a list of open accounts for the site\'s associated EPOS
     * @summary Fetch a list of open accounts for the site\'s associated EPOS
     * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public connectPullFetchOpenAccounts(waiterId?: string, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).connectPullFetchOpenAccounts(waiterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record a payment against an account within the sites associated EPOS
     * @summary Record a payment against an account within the sites associated EPOS
     * @param {string} accountId Epos account identifier
     * @param {EposRecordPaymentRequest} eposRecordPaymentRequest Record payment request body
     * @param {string} [waiterId] Waiter identifier required for certain EPOS integrations (e.g. NCR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public connectPullRecordPayment(accountId: string, eposRecordPaymentRequest: EposRecordPaymentRequest, waiterId?: string, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).connectPullRecordPayment(accountId, eposRecordPaymentRequest, waiterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a transaction from devices
     * @summary Create a transaction from devices
     * @param {CreateTransactionDeviceRequest} createTransactionDeviceRequest Transaction placeholder additional data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public createTransactionDevice(createTransactionDeviceRequest: CreateTransactionDeviceRequest, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).createTransactionDevice(createTransactionDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send an email of refund a transaction from devices
     * @summary Send an email of refund a transaction from devices
     * @param {string} pspReference The psp reference
     * @param {EmailRefundTransactionDevicesRequest} emailRefundTransactionDevicesRequest Email refund additional parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public emailRefundTransactionDevices(pspReference: string, emailRefundTransactionDevicesRequest: EmailRefundTransactionDevicesRequest, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).emailRefundTransactionDevices(pspReference, emailRefundTransactionDevicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns device and store configuration for current authenticated device
     * @summary Fetch device config
     * @param {string} device Device ID for current authenticated device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public fetchDeviceConfig(device: string, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).fetchDeviceConfig(device, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a bill from devices
     * @summary Get a bill from devices
     * @param {string} pspReference The psp reference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public getBillDevice(pspReference: string, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).getBillDevice(pspReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List bills from devices
     * @summary List bills from devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public listBillsDevice(options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).listBillsDevice(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List transactions from devices
     * @summary List transactions from devices
     * @param {string} [dates] Date range for transactions
     * @param {string} [psp] Search transactions by PSP
     * @param {string} [amounts] Search transactions amounts (exact or between) in pence
     * @param {string} [statuses] Search transactions by status (comma separated)
     * @param {string} [cardSummary] Search by last 4 digits of card used in transaction
     * @param {string} [type] Search by transaction type
     * @param {ListTransactionDevicePaymentSourceEnum} [paymentSource] Search by payment source
     * @param {string} [paymentMethods] Search by card payment method (e.g. mc, visa, amex, etc)
     * @param {string} [lastKey] Pagination parameter
     * @param {string} [countOnly] Returns the number of pages, and no items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public listTransactionDevice(dates?: string, psp?: string, amounts?: string, statuses?: string, cardSummary?: string, type?: string, paymentSource?: ListTransactionDevicePaymentSourceEnum, paymentMethods?: string, lastKey?: string, countOnly?: string, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).listTransactionDevice(dates, psp, amounts, statuses, cardSummary, type, paymentSource, paymentMethods, lastKey, countOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refund a transaction from devices
     * @summary Refund a transaction from devices
     * @param {string} pspReference The psp reference
     * @param {RefundTransactionRequest} refundTransactionRequest Referenced refund additional parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public refundTransactionDevices(pspReference: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).refundTransactionDevices(pspReference, refundTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a transaction receipt and email it
     * @summary Create a transaction receipt and email it
     * @param {string} pspReference The psp reference
     * @param {CreateTransactionReceiptRequest} createTransactionReceiptRequest Transaction receipt params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public transactionReceiptDevices(pspReference: string, createTransactionReceiptRequest: CreateTransactionReceiptRequest, options?: RawAxiosRequestConfig) {
        return DevicesApiFp(this.configuration).transactionReceiptDevices(pspReference, createTransactionReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListTransactionDevicePaymentSourceEnum = {
    AdyenTerminal: 'adyen-terminal',
    PayByLink: 'pay-by-link',
    TapToPay: 'tap-to-pay'
} as const;
export type ListTransactionDevicePaymentSourceEnum = typeof ListTransactionDevicePaymentSourceEnum[keyof typeof ListTransactionDevicePaymentSourceEnum];


/**
 * PaybylinkApi - axios parameter creator
 * @export
 */
export const PaybylinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve payment link details in order to pay
         * @summary Retrieve payment link details in order to pay
         * @param {string} paymentLinkId Payment link identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentLinkGet: async (paymentLinkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentLinkId' is not null or undefined
            assertParamExists('paymentLinkGet', 'paymentLinkId', paymentLinkId)
            const localVarPath = `/v1/payment-links/{paymentLinkId}`
                .replace(`{${"paymentLinkId"}}`, encodeURIComponent(String(paymentLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow customers using pay by link to provide an email address for receipt
         * @summary Allow customers using pay by link to provide an email address for receipt
         * @param {string} paymentLinkId Payment link identifier
         * @param {PaymentLinkReceiptRequest} paymentLinkReceiptRequest Email for receipt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentLinkReceipt: async (paymentLinkId: string, paymentLinkReceiptRequest: PaymentLinkReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentLinkId' is not null or undefined
            assertParamExists('paymentLinkReceipt', 'paymentLinkId', paymentLinkId)
            // verify required parameter 'paymentLinkReceiptRequest' is not null or undefined
            assertParamExists('paymentLinkReceipt', 'paymentLinkReceiptRequest', paymentLinkReceiptRequest)
            const localVarPath = `/v1/payment-links/{paymentLinkId}/receipt`
                .replace(`{${"paymentLinkId"}}`, encodeURIComponent(String(paymentLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentLinkReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaybylinkApi - functional programming interface
 * @export
 */
export const PaybylinkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaybylinkApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve payment link details in order to pay
         * @summary Retrieve payment link details in order to pay
         * @param {string} paymentLinkId Payment link identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentLinkGet(paymentLinkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentLinkGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentLinkGet(paymentLinkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaybylinkApi.paymentLinkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allow customers using pay by link to provide an email address for receipt
         * @summary Allow customers using pay by link to provide an email address for receipt
         * @param {string} paymentLinkId Payment link identifier
         * @param {PaymentLinkReceiptRequest} paymentLinkReceiptRequest Email for receipt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentLinkReceipt(paymentLinkId: string, paymentLinkReceiptRequest: PaymentLinkReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentLinkReceipt(paymentLinkId, paymentLinkReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaybylinkApi.paymentLinkReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaybylinkApi - factory interface
 * @export
 */
export const PaybylinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaybylinkApiFp(configuration)
    return {
        /**
         * Retrieve payment link details in order to pay
         * @summary Retrieve payment link details in order to pay
         * @param {string} paymentLinkId Payment link identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentLinkGet(paymentLinkId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentLinkGet200Response> {
            return localVarFp.paymentLinkGet(paymentLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow customers using pay by link to provide an email address for receipt
         * @summary Allow customers using pay by link to provide an email address for receipt
         * @param {string} paymentLinkId Payment link identifier
         * @param {PaymentLinkReceiptRequest} paymentLinkReceiptRequest Email for receipt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentLinkReceipt(paymentLinkId: string, paymentLinkReceiptRequest: PaymentLinkReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentLinkReceipt(paymentLinkId, paymentLinkReceiptRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaybylinkApi - object-oriented interface
 * @export
 * @class PaybylinkApi
 * @extends {BaseAPI}
 */
export class PaybylinkApi extends BaseAPI {
    /**
     * Retrieve payment link details in order to pay
     * @summary Retrieve payment link details in order to pay
     * @param {string} paymentLinkId Payment link identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaybylinkApi
     */
    public paymentLinkGet(paymentLinkId: string, options?: RawAxiosRequestConfig) {
        return PaybylinkApiFp(this.configuration).paymentLinkGet(paymentLinkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow customers using pay by link to provide an email address for receipt
     * @summary Allow customers using pay by link to provide an email address for receipt
     * @param {string} paymentLinkId Payment link identifier
     * @param {PaymentLinkReceiptRequest} paymentLinkReceiptRequest Email for receipt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaybylinkApi
     */
    public paymentLinkReceipt(paymentLinkId: string, paymentLinkReceiptRequest: PaymentLinkReceiptRequest, options?: RawAxiosRequestConfig) {
        return PaybylinkApiFp(this.configuration).paymentLinkReceipt(paymentLinkId, paymentLinkReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupportDashboardApi - axios parameter creator
 * @export
 */
export const SupportDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new payment method to a site
         * @summary Add a new payment method to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSitesPaymentMethod: async (merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('addSitesPaymentMethod', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('addSitesPaymentMethod', 'siteId', siteId)
            // verify required parameter 'addSitesPaymentMethodRequest' is not null or undefined
            assertParamExists('addSitesPaymentMethod', 'addSitesPaymentMethodRequest', addSitesPaymentMethodRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/payment-methods`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSitesPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new device to a site
         * @summary Add a new device to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice: async (merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('assignDevice', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('assignDevice', 'siteId', siteId)
            // verify required parameter 'assignDeviceRequest' is not null or undefined
            assertParamExists('assignDevice', 'assignDeviceRequest', assignDeviceRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/assign-device`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a hosted onboarding verification link for a merchant\'s onboarding process
         * @summary Create a hosted onboarding verification link for a merchant
         * @param {string} merchantId ID of the customer
         * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationLink: async (merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createVerificationLink', 'merchantId', merchantId)
            const localVarPath = `/merchants/{merchantId}/verification-links`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVerificationLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download an invoice
         * @summary Download an invoice
         * @param {string} merchantId ID of the customer
         * @param {string} invoiceNumber Number / ID of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice: async (merchantId: string, invoiceNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('downloadInvoice', 'merchantId', merchantId)
            // verify required parameter 'invoiceNumber' is not null or undefined
            assertParamExists('downloadInvoice', 'invoiceNumber', invoiceNumber)
            const localVarPath = `/v1/merchants/{merchantId}/invoices/{invoiceNumber}/download`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"invoiceNumber"}}`, encodeURIComponent(String(invoiceNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the receipt printing preferences configured for a specific site
         * @summary Fetch receipt config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSiteReceiptConfig: async (merchantId: string, siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('fetchSiteReceiptConfig', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('fetchSiteReceiptConfig', 'siteId', siteId)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/receipts`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an existing site\'s settings by Id
         * @summary Get an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteSettings: async (merchantId: string, siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getSiteSettings', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getSiteSettings', 'siteId', siteId)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/internal`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite user
         * @summary Invite user
         * @param {string} merchantId ID of the customer
         * @param {InviteUserRequest} inviteUserRequest Invite user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (merchantId: string, inviteUserRequest: InviteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('inviteUser', 'merchantId', merchantId)
            // verify required parameter 'inviteUserRequest' is not null or undefined
            assertParamExists('inviteUser', 'inviteUserRequest', inviteUserRequest)
            const localVarPath = `/v1/merchants/{merchantId}/users`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [createdBetween] Search invoices created between dates in timestamp format
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices: async (merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listInvoices', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/invoices`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }

            if (createdBetween !== undefined) {
                localVarQueryParameter['createdBetween'] = createdBetween;
            }

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [year] Year to fetch invoices for. Default is current year
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoicesV2: async (merchantId: string, year?: string, invoiceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listInvoicesV2', 'merchantId', merchantId)
            const localVarPath = `/v2/merchants/{merchantId}/invoices`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List users
         * @summary List users
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listUsers', 'merchantId', merchantId)
            const localVarPath = `/v1/merchants/{merchantId}/users`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch site
         * @summary Patch site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {PatchSiteRequest} patchSiteRequest Update site details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSite: async (merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('patchSite', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('patchSite', 'siteId', siteId)
            // verify required parameter 'patchSiteRequest' is not null or undefined
            assertParamExists('patchSite', 'patchSiteRequest', patchSiteRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchSiteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset user password
         * @summary Reset user password
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (merchantId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('resetUserPassword', 'merchantId', merchantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserPassword', 'userId', userId)
            const localVarPath = `/v1/merchants/{merchantId}/users/{userId}/reset-password`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the passcodes for all devices at a site
         * @summary Update the passcodes for all devices at a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteDevicesPasscodes: async (merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteDevicesPasscodes', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteDevicesPasscodes', 'siteId', siteId)
            // verify required parameter 'updateSiteDevicesPasscodesRequest' is not null or undefined
            assertParamExists('updateSiteDevicesPasscodes', 'updateSiteDevicesPasscodesRequest', updateSiteDevicesPasscodesRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/passcodes`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSiteDevicesPasscodesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the receipt printing behavior for a specific site
         * @summary Update receipt printing config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteReceiptConfig: async (merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteReceiptConfig', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteReceiptConfig', 'siteId', siteId)
            // verify required parameter 'updateSiteReceiptConfigRequest' is not null or undefined
            assertParamExists('updateSiteReceiptConfig', 'updateSiteReceiptConfigRequest', updateSiteReceiptConfigRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/receipts`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSiteReceiptConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update tips configuration for a site
         * @summary Update tips configuration for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {Tips} tips Tips configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteTips: async (merchantId: string, siteId: string, tips: Tips, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSiteTips', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSiteTips', 'siteId', siteId)
            // verify required parameter 'tips' is not null or undefined
            assertParamExists('updateSiteTips', 'tips', tips)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/tips`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tips, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing site\'s payment method
         * @summary Update an existing site\'s payment method
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} paymentMethodId ID of the payment method
         * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSitesPaymentMethod: async (merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'merchantId', merchantId)
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'siteId', siteId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'paymentMethodId', paymentMethodId)
            // verify required parameter 'updateSitesPaymentMethodRequest' is not null or undefined
            assertParamExists('updateSitesPaymentMethod', 'updateSitesPaymentMethodRequest', updateSitesPaymentMethodRequest)
            const localVarPath = `/v1/merchants/{merchantId}/sites/{siteId}/payment-methods/{paymentMethodId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BasecampBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication SupportDashboardApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSitesPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportDashboardApi - functional programming interface
 * @export
 */
export const SupportDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new payment method to a site
         * @summary Add a new payment method to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSitesPaymentMethod(merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSitesPaymentMethod(merchantId, siteId, addSitesPaymentMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.addSitesPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new device to a site
         * @summary Add a new device to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDevice(merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignDevice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDevice(merchantId, siteId, assignDeviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.assignDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a hosted onboarding verification link for a merchant\'s onboarding process
         * @summary Create a hosted onboarding verification link for a merchant
         * @param {string} merchantId ID of the customer
         * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVerificationLink(merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateVerificationLink200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVerificationLink(merchantId, createVerificationLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.createVerificationLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download an invoice
         * @summary Download an invoice
         * @param {string} merchantId ID of the customer
         * @param {string} invoiceNumber Number / ID of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadInvoice(merchantId: string, invoiceNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DownloadInvoice200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadInvoice(merchantId, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.downloadInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the receipt printing preferences configured for a specific site
         * @summary Fetch receipt config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchSiteReceiptConfig(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSiteReceiptConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchSiteReceiptConfig(merchantId, siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.fetchSiteReceiptConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an existing site\'s settings by Id
         * @summary Get an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteSettings(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSiteSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteSettings(merchantId, siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.getSiteSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite user
         * @summary Invite user
         * @param {string} merchantId ID of the customer
         * @param {InviteUserRequest} inviteUserRequest Invite user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(merchantId: string, inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(merchantId, inviteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [createdBetween] Search invoices created between dates in timestamp format
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoices(merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInvoices200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoices(merchantId, lastKey, createdBetween, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.listInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [year] Year to fetch invoices for. Default is current year
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoicesV2(merchantId: string, year?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInvoicesV2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoicesV2(merchantId, year, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.listInvoicesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List users
         * @summary List users
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch site
         * @summary Patch site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {PatchSiteRequest} patchSiteRequest Update site details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSite(merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSite(merchantId, siteId, patchSiteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.patchSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset user password
         * @summary Reset user password
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(merchantId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(merchantId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.resetUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the passcodes for all devices at a site
         * @summary Update the passcodes for all devices at a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteDevicesPasscodes(merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSiteDevicesPasscodes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteDevicesPasscodes(merchantId, siteId, updateSiteDevicesPasscodesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.updateSiteDevicesPasscodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify the receipt printing behavior for a specific site
         * @summary Update receipt printing config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteReceiptConfig(merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSiteReceiptConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteReceiptConfig(merchantId, siteId, updateSiteReceiptConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.updateSiteReceiptConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update tips configuration for a site
         * @summary Update tips configuration for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {Tips} tips Tips configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSiteTips(merchantId: string, siteId: string, tips: Tips, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSiteTips(merchantId, siteId, tips, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.updateSiteTips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing site\'s payment method
         * @summary Update an existing site\'s payment method
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} paymentMethodId ID of the payment method
         * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSitesPaymentMethod(merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSitesPaymentMethod(merchantId, siteId, paymentMethodId, updateSitesPaymentMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportDashboardApi.updateSitesPaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupportDashboardApi - factory interface
 * @export
 */
export const SupportDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportDashboardApiFp(configuration)
    return {
        /**
         * Add a new payment method to a site
         * @summary Add a new payment method to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSitesPaymentMethod(merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSitesPaymentMethod(merchantId, siteId, addSitesPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new device to a site
         * @summary Add a new device to a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice(merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignDevice200Response> {
            return localVarFp.assignDevice(merchantId, siteId, assignDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a hosted onboarding verification link for a merchant\'s onboarding process
         * @summary Create a hosted onboarding verification link for a merchant
         * @param {string} merchantId ID of the customer
         * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationLink(merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateVerificationLink200Response> {
            return localVarFp.createVerificationLink(merchantId, createVerificationLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download an invoice
         * @summary Download an invoice
         * @param {string} merchantId ID of the customer
         * @param {string} invoiceNumber Number / ID of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice(merchantId: string, invoiceNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DownloadInvoice200ResponseInner>> {
            return localVarFp.downloadInvoice(merchantId, invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the receipt printing preferences configured for a specific site
         * @summary Fetch receipt config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSiteReceiptConfig(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchSiteReceiptConfig200Response> {
            return localVarFp.fetchSiteReceiptConfig(merchantId, siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an existing site\'s settings by Id
         * @summary Get an existing site\'s internal settings
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteSettings(merchantId: string, siteId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSiteSettings200Response> {
            return localVarFp.getSiteSettings(merchantId, siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite user
         * @summary Invite user
         * @param {string} merchantId ID of the customer
         * @param {InviteUserRequest} inviteUserRequest Invite user parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(merchantId: string, inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inviteUser(merchantId, inviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [lastKey] Pagination parameter
         * @param {string} [createdBetween] Search invoices created between dates in timestamp format
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices(merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListInvoices200Response> {
            return localVarFp.listInvoices(merchantId, lastKey, createdBetween, invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * List invoices
         * @summary List invoices
         * @param {string} merchantId ID of the customer
         * @param {string} [year] Year to fetch invoices for. Default is current year
         * @param {string} [invoiceNumber] Search invoices by invoice number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoicesV2(merchantId: string, year?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListInvoicesV2200Response> {
            return localVarFp.listInvoicesV2(merchantId, year, invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * List users
         * @summary List users
         * @param {string} merchantId ID of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.listUsers(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch site
         * @summary Patch site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {PatchSiteRequest} patchSiteRequest Update site details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSite(merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchSite(merchantId, siteId, patchSiteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset user password
         * @summary Reset user password
         * @param {string} merchantId ID of the customer
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(merchantId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetUserPassword(merchantId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the passcodes for all devices at a site
         * @summary Update the passcodes for all devices at a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteDevicesPasscodes(merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSiteDevicesPasscodes200Response> {
            return localVarFp.updateSiteDevicesPasscodes(merchantId, siteId, updateSiteDevicesPasscodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify the receipt printing behavior for a specific site
         * @summary Update receipt printing config for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteReceiptConfig(merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<FetchSiteReceiptConfig200Response> {
            return localVarFp.updateSiteReceiptConfig(merchantId, siteId, updateSiteReceiptConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update tips configuration for a site
         * @summary Update tips configuration for a site
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {Tips} tips Tips configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteTips(merchantId: string, siteId: string, tips: Tips, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSiteTips(merchantId, siteId, tips, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing site\'s payment method
         * @summary Update an existing site\'s payment method
         * @param {string} merchantId ID of the customer
         * @param {string} siteId ID of the site
         * @param {string} paymentMethodId ID of the payment method
         * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSitesPaymentMethod(merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSitesPaymentMethod(merchantId, siteId, paymentMethodId, updateSitesPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportDashboardApi - object-oriented interface
 * @export
 * @class SupportDashboardApi
 * @extends {BaseAPI}
 */
export class SupportDashboardApi extends BaseAPI {
    /**
     * Add a new payment method to a site
     * @summary Add a new payment method to a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {AddSitesPaymentMethodRequest} addSitesPaymentMethodRequest Add a new payment method to a site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public addSitesPaymentMethod(merchantId: string, siteId: string, addSitesPaymentMethodRequest: AddSitesPaymentMethodRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).addSitesPaymentMethod(merchantId, siteId, addSitesPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new device to a site
     * @summary Add a new device to a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {AssignDeviceRequest} assignDeviceRequest Add a new device to a site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public assignDevice(merchantId: string, siteId: string, assignDeviceRequest: AssignDeviceRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).assignDevice(merchantId, siteId, assignDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a hosted onboarding verification link for a merchant\'s onboarding process
     * @summary Create a hosted onboarding verification link for a merchant
     * @param {string} merchantId ID of the customer
     * @param {CreateVerificationLinkRequest} [createVerificationLinkRequest] Create verification link parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public createVerificationLink(merchantId: string, createVerificationLinkRequest?: CreateVerificationLinkRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).createVerificationLink(merchantId, createVerificationLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download an invoice
     * @summary Download an invoice
     * @param {string} merchantId ID of the customer
     * @param {string} invoiceNumber Number / ID of the invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public downloadInvoice(merchantId: string, invoiceNumber: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).downloadInvoice(merchantId, invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the receipt printing preferences configured for a specific site
     * @summary Fetch receipt config for a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public fetchSiteReceiptConfig(merchantId: string, siteId: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).fetchSiteReceiptConfig(merchantId, siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an existing site\'s settings by Id
     * @summary Get an existing site\'s internal settings
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public getSiteSettings(merchantId: string, siteId: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).getSiteSettings(merchantId, siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite user
     * @summary Invite user
     * @param {string} merchantId ID of the customer
     * @param {InviteUserRequest} inviteUserRequest Invite user parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public inviteUser(merchantId: string, inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).inviteUser(merchantId, inviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List invoices
     * @summary List invoices
     * @param {string} merchantId ID of the customer
     * @param {string} [lastKey] Pagination parameter
     * @param {string} [createdBetween] Search invoices created between dates in timestamp format
     * @param {string} [invoiceNumber] Search invoices by invoice number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public listInvoices(merchantId: string, lastKey?: string, createdBetween?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).listInvoices(merchantId, lastKey, createdBetween, invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List invoices
     * @summary List invoices
     * @param {string} merchantId ID of the customer
     * @param {string} [year] Year to fetch invoices for. Default is current year
     * @param {string} [invoiceNumber] Search invoices by invoice number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public listInvoicesV2(merchantId: string, year?: string, invoiceNumber?: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).listInvoicesV2(merchantId, year, invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List users
     * @summary List users
     * @param {string} merchantId ID of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public listUsers(merchantId: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).listUsers(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch site
     * @summary Patch site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {PatchSiteRequest} patchSiteRequest Update site details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public patchSite(merchantId: string, siteId: string, patchSiteRequest: PatchSiteRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).patchSite(merchantId, siteId, patchSiteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset user password
     * @summary Reset user password
     * @param {string} merchantId ID of the customer
     * @param {string} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public resetUserPassword(merchantId: string, userId: string, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).resetUserPassword(merchantId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the passcodes for all devices at a site
     * @summary Update the passcodes for all devices at a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {UpdateSiteDevicesPasscodesRequest} updateSiteDevicesPasscodesRequest Passcodes to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public updateSiteDevicesPasscodes(merchantId: string, siteId: string, updateSiteDevicesPasscodesRequest: UpdateSiteDevicesPasscodesRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).updateSiteDevicesPasscodes(merchantId, siteId, updateSiteDevicesPasscodesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify the receipt printing behavior for a specific site
     * @summary Update receipt printing config for a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {UpdateSiteReceiptConfigRequest} updateSiteReceiptConfigRequest Receipt printing settings to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public updateSiteReceiptConfig(merchantId: string, siteId: string, updateSiteReceiptConfigRequest: UpdateSiteReceiptConfigRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).updateSiteReceiptConfig(merchantId, siteId, updateSiteReceiptConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update tips configuration for a site
     * @summary Update tips configuration for a site
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {Tips} tips Tips configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public updateSiteTips(merchantId: string, siteId: string, tips: Tips, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).updateSiteTips(merchantId, siteId, tips, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing site\'s payment method
     * @summary Update an existing site\'s payment method
     * @param {string} merchantId ID of the customer
     * @param {string} siteId ID of the site
     * @param {string} paymentMethodId ID of the payment method
     * @param {UpdateSitesPaymentMethodRequest} updateSitesPaymentMethodRequest Update settings of a payment method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportDashboardApi
     */
    public updateSitesPaymentMethod(merchantId: string, siteId: string, paymentMethodId: string, updateSitesPaymentMethodRequest: UpdateSitesPaymentMethodRequest, options?: RawAxiosRequestConfig) {
        return SupportDashboardApiFp(this.configuration).updateSitesPaymentMethod(merchantId, siteId, paymentMethodId, updateSitesPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TraderportalApi - axios parameter creator
 * @export
 */
export const TraderportalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Save new rates for a new deal
         * @summary Save new rates for a new deal
         * @param {DealRates} dealRates Rates to save from new deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDealRates: async (dealRates: DealRates, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealRates' is not null or undefined
            assertParamExists('createDealRates', 'dealRates', dealRates)
            const localVarPath = `/v1/rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication TraderPortalApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dealRates, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing deal\'s rate (patch)
         * @summary Edit an existing deal\'s rate (patch)
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {PatchUpdateDealRates} patchUpdateDealRates Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUpdateDealRates: async (dealReference: string, patchUpdateDealRates: PatchUpdateDealRates, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealReference' is not null or undefined
            assertParamExists('patchUpdateDealRates', 'dealReference', dealReference)
            // verify required parameter 'patchUpdateDealRates' is not null or undefined
            assertParamExists('patchUpdateDealRates', 'patchUpdateDealRates', patchUpdateDealRates)
            const localVarPath = `/v1/rates/{dealReference}`
                .replace(`{${"dealReference"}}`, encodeURIComponent(String(dealReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication TraderPortalApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchUpdateDealRates, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark an existing deal as signed
         * @summary Mark an existing deal as signed
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signDealRates: async (dealReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealReference' is not null or undefined
            assertParamExists('signDealRates', 'dealReference', dealReference)
            const localVarPath = `/v1/rates/{dealReference}/sign`
                .replace(`{${"dealReference"}}`, encodeURIComponent(String(dealReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication TraderPortalApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save the URL to sign deal in an existing deal
         * @summary Save the URL to sign deal in an existing deal
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {SignUrlDealRatesRequest} signUrlDealRatesRequest URL to sign the agreed rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUrlDealRates: async (dealReference: string, signUrlDealRatesRequest: SignUrlDealRatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealReference' is not null or undefined
            assertParamExists('signUrlDealRates', 'dealReference', dealReference)
            // verify required parameter 'signUrlDealRatesRequest' is not null or undefined
            assertParamExists('signUrlDealRates', 'signUrlDealRatesRequest', signUrlDealRatesRequest)
            const localVarPath = `/v1/rates/{dealReference}/signUrl`
                .replace(`{${"dealReference"}}`, encodeURIComponent(String(dealReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication TraderPortalApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUrlDealRatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing deal\'s rate
         * @summary Edit an existing deal\'s rate
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {UpdateDealRates} updateDealRates Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDealRates: async (dealReference: string, updateDealRates: UpdateDealRates, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealReference' is not null or undefined
            assertParamExists('updateDealRates', 'dealReference', dealReference)
            // verify required parameter 'updateDealRates' is not null or undefined
            assertParamExists('updateDealRates', 'updateDealRates', updateDealRates)
            const localVarPath = `/v1/rates/{dealReference}`
                .replace(`{${"dealReference"}}`, encodeURIComponent(String(dealReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication TraderPortalApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDealRates, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TraderportalApi - functional programming interface
 * @export
 */
export const TraderportalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TraderportalApiAxiosParamCreator(configuration)
    return {
        /**
         * Save new rates for a new deal
         * @summary Save new rates for a new deal
         * @param {DealRates} dealRates Rates to save from new deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDealRates(dealRates: DealRates, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDealRates201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDealRates(dealRates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraderportalApi.createDealRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing deal\'s rate (patch)
         * @summary Edit an existing deal\'s rate (patch)
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {PatchUpdateDealRates} patchUpdateDealRates Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUpdateDealRates(dealReference: string, patchUpdateDealRates: PatchUpdateDealRates, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDealRates201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUpdateDealRates(dealReference, patchUpdateDealRates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraderportalApi.patchUpdateDealRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark an existing deal as signed
         * @summary Mark an existing deal as signed
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signDealRates(dealReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signDealRates(dealReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraderportalApi.signDealRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save the URL to sign deal in an existing deal
         * @summary Save the URL to sign deal in an existing deal
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {SignUrlDealRatesRequest} signUrlDealRatesRequest URL to sign the agreed rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUrlDealRates(dealReference: string, signUrlDealRatesRequest: SignUrlDealRatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUrlDealRates(dealReference, signUrlDealRatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraderportalApi.signUrlDealRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing deal\'s rate
         * @summary Edit an existing deal\'s rate
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {UpdateDealRates} updateDealRates Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDealRates(dealReference: string, updateDealRates: UpdateDealRates, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDealRates201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDealRates(dealReference, updateDealRates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TraderportalApi.updateDealRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TraderportalApi - factory interface
 * @export
 */
export const TraderportalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TraderportalApiFp(configuration)
    return {
        /**
         * Save new rates for a new deal
         * @summary Save new rates for a new deal
         * @param {DealRates} dealRates Rates to save from new deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDealRates(dealRates: DealRates, options?: RawAxiosRequestConfig): AxiosPromise<CreateDealRates201Response> {
            return localVarFp.createDealRates(dealRates, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing deal\'s rate (patch)
         * @summary Edit an existing deal\'s rate (patch)
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {PatchUpdateDealRates} patchUpdateDealRates Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUpdateDealRates(dealReference: string, patchUpdateDealRates: PatchUpdateDealRates, options?: RawAxiosRequestConfig): AxiosPromise<CreateDealRates201Response> {
            return localVarFp.patchUpdateDealRates(dealReference, patchUpdateDealRates, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark an existing deal as signed
         * @summary Mark an existing deal as signed
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signDealRates(dealReference: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signDealRates(dealReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Save the URL to sign deal in an existing deal
         * @summary Save the URL to sign deal in an existing deal
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {SignUrlDealRatesRequest} signUrlDealRatesRequest URL to sign the agreed rates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUrlDealRates(dealReference: string, signUrlDealRatesRequest: SignUrlDealRatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signUrlDealRates(dealReference, signUrlDealRatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing deal\'s rate
         * @summary Edit an existing deal\'s rate
         * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
         * @param {UpdateDealRates} updateDealRates Rates to save from an existing deal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDealRates(dealReference: string, updateDealRates: UpdateDealRates, options?: RawAxiosRequestConfig): AxiosPromise<CreateDealRates201Response> {
            return localVarFp.updateDealRates(dealReference, updateDealRates, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TraderportalApi - object-oriented interface
 * @export
 * @class TraderportalApi
 * @extends {BaseAPI}
 */
export class TraderportalApi extends BaseAPI {
    /**
     * Save new rates for a new deal
     * @summary Save new rates for a new deal
     * @param {DealRates} dealRates Rates to save from new deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraderportalApi
     */
    public createDealRates(dealRates: DealRates, options?: RawAxiosRequestConfig) {
        return TraderportalApiFp(this.configuration).createDealRates(dealRates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing deal\'s rate (patch)
     * @summary Edit an existing deal\'s rate (patch)
     * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
     * @param {PatchUpdateDealRates} patchUpdateDealRates Rates to save from an existing deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraderportalApi
     */
    public patchUpdateDealRates(dealReference: string, patchUpdateDealRates: PatchUpdateDealRates, options?: RawAxiosRequestConfig) {
        return TraderportalApiFp(this.configuration).patchUpdateDealRates(dealReference, patchUpdateDealRates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark an existing deal as signed
     * @summary Mark an existing deal as signed
     * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraderportalApi
     */
    public signDealRates(dealReference: string, options?: RawAxiosRequestConfig) {
        return TraderportalApiFp(this.configuration).signDealRates(dealReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save the URL to sign deal in an existing deal
     * @summary Save the URL to sign deal in an existing deal
     * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
     * @param {SignUrlDealRatesRequest} signUrlDealRatesRequest URL to sign the agreed rates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraderportalApi
     */
    public signUrlDealRates(dealReference: string, signUrlDealRatesRequest: SignUrlDealRatesRequest, options?: RawAxiosRequestConfig) {
        return TraderportalApiFp(this.configuration).signUrlDealRates(dealReference, signUrlDealRatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing deal\'s rate
     * @summary Edit an existing deal\'s rate
     * @param {string} dealReference Deal reference from our external system, used to link with later available Account Holder ID
     * @param {UpdateDealRates} updateDealRates Rates to save from an existing deal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraderportalApi
     */
    public updateDealRates(dealReference: string, updateDealRates: UpdateDealRates, options?: RawAxiosRequestConfig) {
        return TraderportalApiFp(this.configuration).updateDealRates(dealReference, updateDealRates, options).then((request) => request(this.axios, this.basePath));
    }
}



